const translations = {
  pt: {
    // ============ Generic / Common ============
    app_title: "HPDC RFQ",
    login: "Entrar",
    logout: "Sair",
    username: "Utilizador",
    password: "Password",
    dashboard: "Painel",
    rfqs: "Cotações",
    clients: "Clientes",
    admin: "Administração",
    config: "Configuração",
    new_rfq: "Nova Cotação",
    search: "Pesquisar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    expand: "Expandir",
    collapse: "Colapsar",
    expand_all: "Expandir tudo",
    collapse_all: "Recolher tudo",
    collection_changed_summary: "Lista actualizada — {old} → {new} linhas",
    create: "Criar",
    back: "Voltar",
    submit: "Submeter",
    approve: "Aprovar",
    reject: "Rejeitar",
    download: "Descarregar",
    status: "Estado",
    deadline: "Prazo",
    client: "Cliente",
    part_ref: "Ref. Peça",
    part_designation: "Designação",
    annual_volume: "Volume Anual (peças/ano)",
    created_at: "Data Criação",
    engineer: "Engenheiro",
    commercial: "Comercial",
    loading: "A carregar...",
    error: "Erro",
    success: "Sucesso",
    confirm: "Confirmar",
    no_data: "Sem dados",
    name: "Nome",
    code: "Código",
    description: "Descrição",
    country: "País",
    contact: "Contacto",
    email: "Email",
    full_name: "Nome completo",
    language: "Idioma",
    role: "Perfil",
    notes: "Notas",
    color: "Cor",
    actions: "Acções",
    system: "Sistema",
    active: "Activa",
    inactive: "Inactiva",
    active_m: "Activo",
    inactive_m: "Inactivo",
    activate: "Activar",
    deactivate: "Desactivar",
    previous: "Anterior",
    next: "Seguinte",
    page: "Página",
    page_x_of_y: "Página {page} de {pages}",
    per_page: "Por página",
    results: "resultados",
    type: "Tipo",
    required_field: "*",

    // ============ States ============
    in_preparation: "Em Preparação",
    awaiting_engineering_assignment: "Aguarda Atribuição de Engenheiro",
    in_analysis: "Em Análise Técnica",
    awaiting_logistics: "Aguarda Logística",
    awaiting_commercial_margins: "Aguarda Margens Comerciais",
    awaiting_finance: "Aguarda Financeiro",
    awaiting_direction: "Aguarda Administração (Exceção)",
    awaiting_admin: "Aguarda Administração",
    approved: "Aprovado",
    offer_sent: "Proposta Enviada",
    won: "Ganho",
    lost: "Perdido",
    in_negotiation: "Em Negociação",
    all_states: "Todos os estados",

    // ============ Business gates / workflow ============
    gate_g1: "G1 — Triagem Estratégica",
    gate_g2: "G2 — Validação Documental",
    gate_g3: "G3 — Validação Técnica",
    gate_g4: "G4 — Validação Financeira",
    gate_g5: "G5 — Exceção da Administração",
    strategic_triage: "Triagem Estratégica",
    strategic_reject: "Rejeitar por triagem estratégica",
    strategic_reject_title: "Rejeitar por triagem estratégica (G1)",
    strategic_reject_desc: "Indique o motivo estratégico para rejeitar este RFQ. O cliente será comunicado fora da aplicação.",
    strategic_rejected_toast: "RFQ rejeitado por triagem estratégica",
    request_client_info: "Solicitar informação ao cliente",
    request_client_info_title: "Solicitar informação adicional",
    request_client_info_desc: "Indique que informação precisa do cliente. A RFQ fica assinalada como a aguardar informação externa.",
    client_info_received: "Informação recebida do cliente",
    client_info_received_title: "Marcar informação como recebida",
    client_info_requested_toast: "Pedido de informação registado",
    client_info_requested_with_email_toast: "Pedido registado e email enviado ao cliente",
    client_info_requested_no_email_toast: "Pedido registado, mas o email não foi enviado",
    client_info_no_email_toast: "Não foi indicado nenhum destinatário — não será enviado email",
    client_info_received_toast: "Informação marcada como recebida",
    send_email_to_client: "Enviar email automático ao cliente",
    email_to_recipients: "Destinatários",
    email_to_recipients_help: "Separe múltiplos endereços com vírgula. Pré-preenchido com o email principal do cliente.",
    email_recipient_role: "Destinatário do cliente",
    email_recipient_role_help: "Selecciona o departamento do cliente que deve receber o pedido. Os emails vêm da ficha do cliente.",
    email_role_custom: "Outro endereço (escrever manualmente)",
    email_no_dept_configured: "O cliente ainda não tem emails departamentais configurados. Use o input abaixo.",
    awaiting_client_flag: "A aguardar informação do cliente",
    awaiting_client_pending: "Pedido(s) de informação pendente(s)",
    return_to_commercial: "Devolver para retrabalho",
    return_to_commercial_title: "Devolver ao Comercial (retrabalho técnico)",
    return_to_commercial_desc: "Indique as alterações técnicas necessárias. Uma nova versão da cotação será criada.",
    returned_to_commercial_toast: "RFQ devolvido para retrabalho",
    submit_to_logistics: "Enviar para Logística",
    submit_to_logistics_title: "Enviar para validação de transporte e embalagem",
    submit_to_logistics_desc: "Classifique o risco técnico. A RFQ segue para o perfil Logística preencher/validar transporte e embalagem.",
    submitted_logistics_toast: "RFQ enviado para Logística",
    submit_to_commercial_margins: "Enviar ao Comercial",
    submit_to_commercial_margins_title: "Enviar para ajuste de margens",
    submit_to_commercial_margins_desc: "Classifique o risco técnico. A RFQ segue directamente para o Comercial preencher as margens (sem passar pela Logística no novo fluxo simplificado).",
    submitted_commercial_margins_toast: "RFQ enviado ao Comercial para margens",
    gate_logistics: "Logística — Transporte e embalagem",
    gate_logistics_desc: "Valide ou complete os dados de transporte e embalagem. Quando estiver pronto, confirme para devolver ao Comercial para ajuste de margens.",
    logistics_complete: "Validação logística concluída",
    logistics_complete_title: "Concluir validação logística",
    logistics_complete_desc: "Opcional: nota para o histórico. A RFQ volta ao Comercial para ajuste de margens.",
    logistics_complete_toast: "Validação de logística registada",
    gate_commercial_margins: "Comercial — Ajuste de margens",
    gate_commercial_margins_desc: "Ajuste as margens segmentadas (operações internas, embalagem, transporte) e submeta ao Financeiro para validação final.",
    gate_commercial_margins_desc_v2: "Ajuste as margens segmentadas. Quando submeter, o sistema decide automaticamente se aprova ou se escala para a Administração com base no PnL audit.",
    submit_for_finance: "Submeter ao Financeiro",
    submit_for_finance_title: "Submeter ao Financeiro (G4)",
    submit_for_finance_desc_commercial: "Confirme o envio para validação financeira. Pode acrescentar uma nota opcional.",
    submitted_finance_toast: "Submetido para validação financeira",
    submit_to_administration: "Submeter à Administração",
    submit_for_approval: "Submeter para aprovação",
    submit_escalate_title: "Submeter à Administração",
    submit_escalate_desc: "O PnL audit indica EBITDA-alvo negativo — a RFQ será escalada para a Administração (G5) para decisão.",
    submit_approve_title: "Submeter para aprovação",
    submit_approve_desc: "O PnL audit valida a margem proposta. A RFQ será aprovada automaticamente.",
    final_decision_will_escalate: "PnL audit indica EBITDA-alvo abaixo do limite — ao submeter, a RFQ será escalada para a Administração (G5).",
    final_decision_will_warn_admin: "A RFQ pode ser aprovada automaticamente, mas a Administração será notificada porque o PV teórico Schreder ficou negativo.",
    final_decision_will_approve: "PnL audit dentro dos limites — ao submeter, a RFQ será aprovada automaticamente.",
    escalated_to_administration_toast: "RFQ escalado para a Administração",
    approved_with_admin_warning_toast: "RFQ aprovado (Administração notificada — Schreder negativo)",
    technical_risk: "Risco Técnico",
    risk_low: "Baixo",
    risk_medium: "Médio",
    risk_high: "Alto",
    risk_required: "Classificação de risco obrigatória",
    approve_finance: "Aprovar (Financeiro)",
    reject_escalate: "Rejeitar e escalar à Administração",
    reject_escalate_title: "Rejeitar e escalar à Administração (G4 → G5)",
    reject_escalate_desc: "Indique o motivo financeiro. A RFQ será escalada para decisão excecional da Administração.",
    escalated_toast: "RFQ escalado para a Administração",
    approve_exception: "Aprovar por exceção",
    approve_exception_title: "Aprovar por exceção (G5)",
    approve_exception_desc: "A Administração aprova esta RFQ por exceção, apesar da reprovação financeira.",
    reject_final: "Rejeição final",
    reject_final_title: "Rejeição final (G5)",
    reject_final_desc: "Indique o motivo final. A RFQ será marcada como perdida por decisão de governo.",
    rework_version: "Retrabalho",
    rework_version_badge: "Retrabalho v",

    // Engineering SLA
    engineering_overdue: "Engenharia — Prazo Ultrapassado",
    no_engineering_overdue: "Sem atrasos da Engenharia",
    days_overdue_suffix: "dias em atraso",
    sla_overdue_badge: "Prazo ultrapassado",
    deadline_required: "Defina um prazo antes de submeter à Engenharia",
    required_for_submit: "Necessário para submeter à Engenharia",
    cannot_submit_reasons: "Falta preencher para submeter à Engenharia:",
    missing_document: "Anexar pelo menos um documento",
    missing_engineer: "Atribuir um engenheiro responsável",
    missing_deadline: "Definir um prazo de resposta",
    missing_client_reply: "Marcar a informação do cliente como recebida",
    min_chars_hint: "Mínimo {n} caracteres",
    submission_data: "Dados para submissão",
    save_rfq_meta: "Guardar dados",
    rfq_meta_saved: "Dados actualizados",
    engineer_responsible_label: "Engenheiro responsável",
    engineer_not_assigned: "Não atribuído",
    commercial_engineer_section: "Atribuição de engenheiro (Comercial)",
    error_load_assignable: "Não foi possível carregar a lista de engenheiros.",
    download_document: "Descarregar ficheiro",
    error_download_doc: "Não foi possível descarregar o ficheiro.",

    // ============ Form versioning ============
    versions_title: "Versões do formulário",
    versions_empty: "Ainda não existem versões seladas. A v1 é criada automaticamente quando o Comercial submete o RFQ para a Engenharia.",
    version_number_short: "v{n}",
    version_label_baseline: "Baseline",
    version_label_engineering: "Engenharia",
    version_label_commercial_rework: "Retrabalho comercial",
    version_author: "Autor",
    version_created_at: "Criada em",
    version_status_at_snapshot: "Estado no snapshot",
    version_no_changes: "Sem alterações vs versão anterior",
    rfq_info_title: "Dados do RFQ",
    quotation_form_title: "Formulário da Cotação",
    yes: "Sim",
    no: "Não",
    strategic_notes: "Notas estratégicas",
    loss_reason: "Motivo de perda",
    commercial_result: "Resultado comercial",
    result_notes: "Notas do resultado",
    version_changes_count: "{n} campo(s) alterado(s)",
    view_version: "Ver",
    compare_vs_previous: "Diferenças vs versão anterior",
    form_snapshot: "Formulário (snapshot)",
    calc_snapshot: "Resultado do cálculo",
    field: "Campo",
    old_value: "Valor anterior",
    new_value: "Valor novo",
    edit_rfq_version: "Editar (nova versão)",
    lock_edit_version: "Terminar edição e selar",
    editing_mode_banner: "A editar nova versão — as alterações ficam destacadas em âmbar. Carrega em 'Terminar edição' para selar vN.",
    locked_for_edit_info: "Esta versão está selada. Para alterar valores, carrega em 'Editar' e cria uma nova versão.",
    unlock_confirm: "Abrir uma nova versão editável?",
    lock_edit_comment_label: "Breve descrição das alterações (opcional)",
    changes_summary_header: "Alterações nesta versão",
    fields_highlighted_from_baseline: "Campos alterados vs baseline",

    // ============ Quotation sections ============
    vm_section: "Valor Matéria (VM)",
    va_foundry_section: "VA Fundição",
    va_finishing_section: "VA Acabamento",
    extra_works_section: "Trabalhos Extra",
    extra_works_empty: "Sem operações configuradas em Trabalhos Extra. Crie-as no admin (Acabamento → categoria \"Trabalhos extra\").",
    va_machining_control_label: "VA Maquinagem & Controlo",
    category_finishing: "Acabamento",
    category_extra_works: "Trabalhos extra",
    finishing_admin_category: "Categoria",
    all: "Todos",
    finishing_op_backstand_rebarbagem: "Backstand/Rebarbagem",
    finishing_op_granalagem: "Granalagem",
    finishing_op_polimento: "Polimento",
    finishing_op_maquinagem_cnc: "Maquinagem CNC",
    finishing_op_controlo_gabarit: "Controlo/Gabarit",
    finishing_op_pintura: "Pintura",
    finishing_op_name: "Operação",
    finishing_cadence_hdr: "Cadência (peças/h)",
    finishing_rate_hdr: "Tarifa (€/h)",
    finishing_scrap_hdr: "Rejeição (%)",
    finishing_cadence_placeholder: "peças/h",
    finishing_rate_placeholder: "€/h",
    finishing_scrap_placeholder: "%",
    subcontract_section: "Subcontratação",
    packaging_section: "Embalagem",
    transport_section: "Transporte",
    packaging_transport_section: "Embalagem & Transporte",
    tooling_section: "Moldes / Ferramentas",
    margin_section: "Margem Comercial",
    results_section: "Resultado do Cálculo",
    packaging_section_card: "Embalagem (palete + caixa + separadores)",
    transport_section_card: "Transporte",
    piece_length_mm: "Comprimento peça (mm)",
    piece_width_mm: "Largura peça (mm)",
    piece_height_mm: "Altura peça (mm)",
    machine_pressure_bar: "Pressão máquina (bar)",
    finishing_rate_from_config: "Tarifa definida na configuração (admin)",
    boxes_per_lot: "Caixas por lote",
    separators_per_box: "Separadores por caixa",
    transport_incoterm: "Tipo / incoterm",
    transport_incoterm_other: "Outros",
    transport_km: "Km a percorrer",
    transport_eur_per_km: "€ / km",
    transport_pieces_per_trip: "Nº peças por viagem",
    commercial_margins_segmented: "Margens comerciais (segmentadas)",
    commercial_margins_segmented_help:
      "Cada bucket (VA interno, embalagem, transporte, trabalhos extra, subcontratação e componentes) tem a sua própria margem. Quando vazia, conta como 0%. A margem dos trabalhos extra cai sobre a margem interna se não for definida.",
    margin_internal_ops: "Margem VA interno (fundição+acabamento) (%)",
    margin_packaging: "Margem embalagem (%)",
    margin_transport: "Margem transporte (%)",
    margin_extra_works: "Margem trabalhos extra (%)",
    margin_subcontract: "Margem subcontratação (%)",
    margin_components: "Margem componentes (%)",
    // Labels usados pelo painel de Diferenças vs versão anterior (modal de
    // versões). São neutros e curtos, para caberem na coluna "Campo".
    recycling_rate: "Taxa de reciclagem",
    machine_override: "Máquina manual (override)",
    cycle_time_manual: "Tempo de ciclo manual",
    subcontract_machining_supplier: "Fornecedor maquinagem",
    subcontract_other_description: "Descrição (outro subcontrato)",
    tooling_cost_foundry_eur: "Custo molde fundição (€)",
    tooling_sale_price_eur: "PV ferramenta (€)",
    gabarit_cost_eur: "Custo gabarit (€)",
    gabarit_margin_percent: "Margem gabarit (%)",
    position: "Posição",
    qty_per_piece: "Qtd. por peça",
    category: "Categoria",
    lot_size: "Tamanho do lote",
    pcs_per_pallet: "Peças por palete",
    designation: "Designação",
    cost_eur: "Custo (€)",
    box_type_label: "Tipo de caixa",
    box_type_placeholder: "Seleccione…",
    box_type_none: "Sem tipo definido (só palete / custo manual)",
    packaging_manual_counts_hint: "Sem tipo de caixa, Peças por caixa e Caixas por palete são valores manuais.",
    cross_profile_notes_title: "Comentários entre perfis",
    cross_profile_notes_desc: "Troca de observações visível a equipas com acesso à RFQ.",
    cross_profile_notes_placeholder: "Escreva uma observação…",
    cross_profile_notes_post: "Publicar observação",
    cross_profile_notes_empty: "Ainda não há observações.",
    cross_profile_note_added: "Observação adicionada",

    // ============ Quotation fields ============
    alloy: "Liga",
    base_mb: "Base MB (€/T)",
    premium: "Prémio (€/T)",
    premium_buy: "Prémio de Compra (€/T)",
    premium_sell: "Prémio de Venda (€/T)",
    alloy_premiums_required: "Os prémios de compra e de venda são obrigatórios.",
    alloy_total_buy: "Total de Compra (€/T)",
    alloy_version: "Versão da liga",
    select_alloy_version: "Selecionar versão...",
    chart_alloy_price_evolution: "Evolução de preços das ligas",
    history: "Histórico",
    effective_date: "Data de vigência",
    alloy_history_title: "Histórico de preços da liga",
    alloy_history_hint: "Cada alteração de preço cria uma nova versão.",
    project_name: "Nome do projeto",
    plan_number: "Nº do plano",
    plan_revision: "Revisão",
    plan_revision_date: "Data da revisão",
    g2_project_info: "Identificação do projeto / plano",
    base_mb_edit_comment: "Motivo da edição do Base MB",
    base_mb_comment_required: "Indique o motivo da edição do Base MB",
    base_mb_comment_min: "O motivo da edição do Base MB deve ter pelo menos {n} caracteres.",
    duplicating: "A duplicar...",
    recorded_by: "Registado por",
    system_author: "Sistema",
    base_mb_overridden: "Base MB editado manualmente",
    base_mb_overridden_by: "Editado por",
    cycle_time_per_piece: "Tempo de ciclo (s/peça)",
    shots_per_day: "Shots/dia",
    pieces_per_day: "Peças/dia",
    pieces_per_day_no_scrap: "Peças/dia (sem sucata)",
    assign_engineer: "Atribuir engenheiro",
    assign_engineer_title: "Atribuição de engenheiro (Diretor Técnico)",
    assign_engineer_hint: "Selecione o engenheiro responsável para iniciar a análise técnica.",
    engineer_assigned_ok: "Engenheiro atribuído",
    paf: "PAF (%)",
    piece_weight: "Peso Peça (kg)",
    runner_weight: "Peso Gito (kg)",
    projected_area: "Área Projectada (cm²)",
    safety_factor: "Coef. Gavetas",
    safety_factor_hint: "Entre 0 e 1 — 0,1 sem gavetas, 0,2 com gavetas; entra na fórmula como (1 + coeficiente).",
    mold_complexity_coef: "Coeficiente de segurança",
    mold_complexity_hint: "Entre 0 e 1 (default 0,5); entra na fórmula como (1 + coeficiente).",
    projection_coef: "Coeficiente de projeção",
    projection_coef_hint: "Fração da bounding box L×W ocupada pela peça (default 0,7). Peças que ocupam quase todo o retângulo aproximam-se de 0,9–1,0; peças finas/lobadas descem abaixo de 0,5.",
    calculated_tonnage: "Força de fecho (T)",
    tonnage_missing_inputs: "Preencha a Pressão Máquina para a fórmula calcular.",
    runner_weight_coef: "Coeficiente do peso do gito",
    runner_weight_coef_hint: "Entre 0 e 1; a força de fecho usa o factor (1 + coeficiente).",
    auto_selected: "auto-seleccionada",
    machine: "Máquina",
    cavities: "Cavidades",
    shots_hour: "Cadência (shots/h)",
    trs: "TRS (%)",
    cycle_time: "Tempo Ciclo (s)",
    scrap_rate: "Rejeição (%)",
    production_cost: "Custo Produção",
    sale_price: "Preço Venda",
    margin: "Margem",
    margin_percent_label: "Margem (%)",
    auto_by_area: "Auto (por área)",
    inactive_marker: "(inactiva)",
    select_alloy: "Seleccionar liga...",
    select_client: "Seleccionar cliente...",
    select_placeholder: "Seleccionar...",

    // Subcontract / Packaging / Transport fields
    subcontract_machining: "Maquinagem ST (€/pça)",
    subcontract_surface: "Trat. Superfície (€/pça)",
    subcontract_painting: "Pintura ST (€/pça)",
    subcontract_other: "Outro (€/pça)",
    packaging_per_piece: "Embalagem (€/pça)",
    transport_per_lot: "Transporte (€/lote)",
    pieces_per_lot: "Peças por lote",

    // Cost cascade / KPIs
    tooling_amortized: "Outillage (amort.)",
    vm_share: "VM share",
    expected_annual_va: "VA anual esperado",
    expected_annual_va_detail:
      "= {volume} × {rate} €/peça (bucket «VA Fundição + Acabamento» com margem interna). As linhas VA Fundição e VA Acabamento acima são mostradas com 2 casas decimais; o cálculo usa o valor exacto do motor, por isso o total pode não coincidir com a multiplicação dos valores se vêm arredondados.",
    annual_revenue: "Receita anual",
    total_scrap_estimate: "Rejeição total est.",
    save_quotation_to_see: "Guarde a cotação para ver o resultado",
    engine_mode: "Modo",
    engine_version: "Engine",

    // Snapshot labels
    snapshot_alloy: "Liga",
    snapshot_piece_weight: "Peso peça (kg)",
    snapshot_runner_weight: "Peso gito (kg)",
    snapshot_projected_area: "Área proj. (cm²)",
    snapshot_cadence: "Cadência (shots/h)",
    snapshot_cavities: "Nº cavidades",
    snapshot_margin: "Margem",
    snapshot_sale_price: "Preço venda (€/pça)",
    snapshot_production_cost: "Custo produção (€/pça)",

    // Quotation actions
    save_quotation: "Guardar Cotação",
    saving_wait: "A guardar...",
    submit_engineering: "Submeter para Engenharia",
    submit_validation: "Submeter para Validação",
    mark_offer_sent: "Marcar Offer Enviado",
    duplicate: "Duplicar",
    comment_placeholder: "Comentário/Justificação...",

    // Commercial outcome (after offer sent)
    commercial_outcome_title: "Resultado Comercial",
    commercial_outcome_desc: "Registar a decisão do cliente sobre a proposta enviada. Esta informação alimenta os indicadores do painel.",
    mark_won: "Ganho",
    mark_lost: "Perdido",
    mark_in_negotiation: "Em negociação",
    mark_won_title: "Marcar como ganho",
    mark_lost_title: "Marcar como perdido",
    mark_in_negotiation_title: "Marcar em negociação",
    mark_won_desc: "O cliente aceitou a proposta. Podes opcionalmente registar uma nota.",
    mark_lost_desc: "O cliente rejeitou a proposta. Indica o motivo da perda.",
    mark_in_negotiation_desc: "O cliente refutou a proposta. A cotação fica em negociação e podes reabri-la para criar uma nova versão (passa novamente por Engenharia).",
    outcome_notes: "Notas (opcional)",
    loss_reason_label: "Motivo da perda",
    loss_reason_price: "Preço",
    loss_reason_lead_time: "Prazo de entrega",
    loss_reason_technical: "Técnico",
    loss_reason_strategic_pass: "Estratégico",
    loss_reason_competitor: "Concorrência",
    loss_reason_other: "Outro",
    outcome_won_toast: "Resultado registado: ganho",
    outcome_lost_toast: "Resultado registado: perdido",
    outcome_in_negotiation_toast: "Cotação marcada como 'em negociação'",
    confirm_outcome: "Confirmar",
    in_negotiation_title: "Cotação em negociação",
    in_negotiation_desc: "O cliente refutou a proposta. Reabre a cotação para criar uma nova versão; a RFQ volta a passar por Engenharia antes de poder ser fechada como Ganho/Perdido.",
    reopen_negotiation_action: "Reabrir / Re-cotar",
    reopen_negotiation_title: "Reabrir cotação para nova versão",
    reopen_negotiation_desc: "A cotação volta para 'em preparação' (modo edição). Qualquer alteração entra como nova versão e volta a passar por Engenharia.",
    reopened_negotiation_toast: "Cotação reaberta para nova versão",

    // List filters
    all_clients: "Todos os clientes",
    all_alloys: "Todas as ligas",
    all_machines: "Todas as máquinas",
    clear_filters: "Limpar filtros",
    pieces_unit: "peças/ano",

    // Toasts
    saved_and_recalculated: "Cotação guardada e recalculada",
    submitted_engineering: "Submetido para Engenharia",
    submitted_validation: "Submetido para validação",
    approved_toast: "Aprovado",
    rejected_toast: "Rejeitado com justificação",
    offer_sent_toast: "Offer marcado como enviado",
    offer_pdf_section: "Oferta comercial (PDF)",
    generate_offer_pdf: "Gerar Offer (PDF)",
    generate_offer_pdf_title: "Gerar oferta comercial em PDF",
    generate_offer_pdf_desc: "Os campos abaixo aparecem no PDF. Pode deixar em branco para usar os valores por defeito (validade da configuração global, sem condições adicionais).",
    offer_pdf_language: "Idioma do PDF",
    offer_pdf_language_help: "Aplica-se a rótulos e textos padrão da oferta. Dados do cliente, valores e observações não são traduzidos.",
    offer_lang_en: "Inglês",
    offer_lang_fr: "Francês",
    offer_lang_pt: "Português",
    offer_validity_days: "Validade (dias)",
    offer_specific_conditions: "Condições específicas",
    offer_observations: "Observações",
    offer_generated_toast: "PDF da oferta gerado",
    offer_generate_error: "Erro ao gerar PDF da oferta",
    offer_download_error: "Erro ao descarregar PDF",
    no_offers_yet: "Sem PDFs gerados ainda.",
    duplicated_toast: "RFQ duplicado",
    rfq_deleted_toast: "RFQ apagado",
    delete_rfq_confirm: "Tem a certeza que pretende apagar o RFQ {ref}? Esta acção é irreversível.",
    error_operation: "Erro na operação",
    error_saving: "Erro ao guardar",
    error_loading_rfq: "Erro ao carregar RFQ",
    justification_min_chars: "Justificação mínima: 20 caracteres",
    rfq_not_found: "RFQ não encontrado",
    doc_attached: "Documento anexado",
    extracting_drawing: "A extrair informação do desenho 2D (texto + OCR)... Pode demorar 10–30 s.",
    error_attaching_doc: "Erro ao anexar documento",

    // Documents / History
    documents: "Documentos",
    no_documents: "Sem documentos",
    attach_document: "Anexar documento",
    g1_essential_documents: "Documentos essenciais (G1)",
    slot_model_3d: "Modelação 3D",
    slot_drawing_2d: "Desenho 2D (Injeção)",
    slot_drawing_2d_machining: "Desenho 2D (Maquinagem)",
    slot_additional: "Especificações de qualidade",
    slot_hint_3d: "Esperado: .step / .stp / .stl",
    slot_hint_2d: "Esperado: PDF (com camada de texto)",
    slot_hint_additional: "Requisitos de qualidade, normas e critérios de aceitação",
    attach: "Anexar",
    replace: "Substituir",
    remove: "Remover",
    no_file: "Sem ficheiro",
    drawing_extracted_info: "Info detectada no desenho 2D",
    drawing_extracted_disclaimer: "modo descoberta (não preenche cotação)",
    reextract: "Re-extrair",
    extraction_loading: "A extrair informação…",
    extraction_keyword_hits: "Palavras-chave detectadas",
    extraction_numeric_tokens: "Valores numéricos detectados",
    extraction_title_block: "Bloco de título (canto inferior direito)",
    extraction_revisions: "Indícios de revisão",
    extraction_pages: "Páginas / dimensões",
    extraction_warning_no_text: "PDF sem camada de texto — extracção indisponível (será necessário OCR numa próxima iteração).",
    extraction_warning_multipage: "Documento com várias páginas — todas foram analisadas.",
    extraction_warning_unsupported: "Formato não suportado para extracção (esperado PDF).",
    extraction_empty: "Não foi detectada nenhuma informação extraível.",
    section_drawing_data: "Dados do desenho",
    section_piece_metadata: "Metadados da peça",
    section_dimension_candidates: "Candidatos a dimensões totais",
    section_raw_advanced: "Modo avançado (output bruto)",
    field_part_number: "Part number",
    field_designation: "Designação",
    field_scale: "Escala",
    field_page_format: "Formato da folha",
    field_step_ref: "Ficheiro 3D referenciado",
    field_drawn_date: "Data do desenho",
    field_revision: "Revisão",
    field_weight: "Peso estimado",
    field_material: "Material / liga",
    field_tolerance: "Norma de tolerâncias",
    dimension_candidates_disclaimer: "Os 3 maiores valores depois de filtrar IDs, normas, ângulos, raios e referências. A confidence é uma heurística — confirme sempre nos desenhos.",
    show_more_candidates: "Mostrar mais candidatos",
    // ============ Quotation Suggestions panel (pré-preenchimento via desenho 2D) ============
    suggest_panel_title: "Pré-preencher cotação a partir do desenho 2D",
    suggest_panel_disclaimer: "auto-aplica campos com alta confiança",
    suggest_count_label: "sugestões",
    suggest_auto_section: "Aplicado automaticamente",
    suggest_pending_section: "A confirmar — verifica os valores",
    suggest_info_section: "Avisos",
    suggest_already_filled_section: "Já preenchidos ({n}) — sugestão ignorada",
    suggest_apply_selected: "Aplicar selecionados ({n})",
    suggest_threshold_hint: "Campos com confidence ≥ {pct}% são auto-aplicados; os restantes pedem confirmação.",
    suggest_auto_applied: "{n} sugestão(ões) aplicada(s) automaticamente",
    suggest_applied: "{n} sugestão(ões) aplicada(s)",
    suggest_overridden: "Valor sobrescrito",
    suggest_override: "aplicar mesmo assim",
    suggest_field_badge: "Sugerido",
    suggest_field_tooltip: "Pré-preenchido a partir do desenho 2D. Edita para confirmar.",
    suggest_part_reference: "Referência da peça",
    suggest_part_designation: "Designação da peça",
    suggest_alloy: "Liga",
    suggest_piece_weight: "Peso da peça",
    suggest_piece_length: "Comprimento (L)",
    suggest_piece_width: "Largura (W)",
    suggest_piece_height: "Altura (H)",
    suggest_warn_height_low_conf: "altura — verificar",
    suggest_warn_weight_no_unit: "peso sem unidade — verificar",
    suggest_warn_alloy_not_in_config: "liga não está na configuração — pede ao admin para a criar",
    status_history: "Histórico de Estados",
    no_history: "Sem histórico",
    hide_quotation: "Ocultar cotação",
    view_quotation_snapshot: "Ver cotação neste momento",

    // ============ Dashboard ============
    pending_action: "Pendentes",
    near_deadline: "Próximos do Prazo",
    recent_activity: "Actividade Recente",
    total_rfqs: "Total RFQs",
    conversion_rate: "Taxa Conversão",
    pipeline_value: "Valor Pipeline",
    blocked_rfqs: "RFQs Bloqueadas",
    avg_pipeline_margin: "Margem Média Pipeline",
    my_pipeline_value: "Meu Pipeline",
    real_close_rate: "Taxa Fecho Real",
    proposals_to_follow_up: "Propostas por Fechar",
    engineering_short: "Eng",
    finance_short: "Fin",
    administration_short: "Adm",
    rfqs_suffix: "RFQs",
    no_pending_rfqs: "Sem RFQs pendentes",
    no_near_deadline: "Sem RFQs próximos do prazo",
    no_recent_activity: "Sem actividade recente",
    action_col: "Acção",
    detail_col: "Detalhe",
    date_col: "Data",
    error_loading_dashboard: "Erro ao carregar dashboard",

    // ============ Validation ============
    justification_required: "Justificação obrigatória (mín. 20 caracteres)",
    comment: "Comentário",

    // ============ Notifications ============
    notifications: "Notificações",
    mark_all_read: "Marcar todas como lidas",
    no_notifications: "Sem notificações",
    unread_suffix: "por ler",
    delete_notification: "Apagar notificação",
    clear_all_notifications: "Apagar todas",

    // ============ Admin ============
    users: "Utilizadores",
    roles: "Perfis",
    machines: "Máquinas",
    alloys: "Ligas",
    finishing_rates: "Taxas Acabamento",
    global_config: "Configuração Global",
    calc_mode: "Modo de Cálculo",
    legacy_mode: "Legacy (Excel)",
    enhanced_mode: "Enhanced (Melhorado)",

    access_restricted: "Acesso restrito",
    admin_only_desc: "Apenas utilizadores com perfil de administrador têm acesso a esta página.",
    load_error: "Erro ao carregar dados",
    create_error: "Erro ao criar",
    save_error: "Erro ao guardar",
    created: "Criado",
    saved: "Guardado",
    no_results: "Sem resultados",
    activity_sectors_tab: "Setores de atividade",
    activity_sectors_title: "Setores de atividade",
    activity_sectors_desc: "Valores do dropdown 'Setor de atividade' na ficha do cliente.",
    new_activity_sector: "Novo setor de atividade",
    contact_functions_tab: "Funções de contacto",
    contact_functions_title: "Funções de contacto",
    contact_functions_desc: "Valores do dropdown 'Função' nos contactos da equipa do cliente.",
    new_contact_function: "Nova função de contacto",

    // Box types admin tab
    boxes_admin_tab: "Caixas",
    boxes_admin_title: "Catálogo de caixas",
    boxes_admin_desc: "Caixas disponíveis no card Embalagem da cotação. As dimensões e o volume útil servem de base ao cálculo automático de \"Peças por caixa\" quando as dimensões da peça estão preenchidas.",
    pallet_cost_admin_title: "Custo palete",
    pallet_cost_admin_desc: "Valor único da europalete, aplicado automaticamente a todas as cotações. No card Embalagem o campo é só de leitura.",
    pallet_cost_saved: "Custo palete guardado",
    pallet_cost_invalid: "Indique um custo palete válido (≥ 0).",
    pallet_cost_readonly_hint: "Definido na Administração (separador Caixas). Não é editável na cotação.",
    new_box_type: "Nova caixa",
    box_type_name: "Nome",
    box_type_description: "Descrição",
    box_type_length_mm: "Comprimento (mm)",
    box_type_width_mm: "Largura (mm)",
    box_type_height_mm: "Altura (mm)",
    box_type_price_eur: "Preço (€)",
    box_type_volume_l: "Volume (L)",
    box_type_volume_hint: "Litros (1 L = 1 000 cm³). Deixe vazio para auto-calcular a partir das dimensões.",
    box_type_created: "Caixa criada",
    box_type_updated: "Caixa actualizada",
    box_type_deactivated: "Caixa desactivada",
    box_type_activated: "Caixa activada",

    // Suppliers admin tab
    suppliers_admin_tab: "Fornecedores",
    suppliers_admin_title: "Catálogo de fornecedores",
    suppliers_admin_desc: "Fornecedores disponíveis no select \"Fornecedor\" do card de Subcontratação. Cada fornecedor está associado a um tipo (maquinagem, tratamento de superfície, pintura, outro) e o card filtra automaticamente as opções pelo tipo da linha.",
    new_supplier: "Novo fornecedor",
    supplier_name: "Nome",
    supplier_type: "Tipo de fornecedor",
    supplier_type_machining: "Maquinagem",
    supplier_type_surface_treatment: "Tratamento de superfície",
    supplier_type_painting: "Pintura",
    supplier_type_other: "Outro",
    supplier_notes: "Notas",
    supplier_created: "Fornecedor criado",
    supplier_updated: "Fornecedor actualizado",
    supplier_deactivated: "Fornecedor desactivado",
    supplier_activated: "Fornecedor activado",
    supplier_select_placeholder: "Seleccionar fornecedor…",
    supplier_no_options: "Sem fornecedores deste tipo (configure em Administração → Fornecedores).",

    // Slot G1 — imagem da peça (sai no PDF da proposta comercial)
    slot_part_image: "Imagem da peça",
    slot_hint_part_image: "Foto/render (.png, .jpg). Embutida no PDF da proposta comercial.",

    // Per-client payment terms (saem no PDF da proposta comercial)
    payment_terms_section: "Payment Terms (PDF da proposta)",
    internal_code: "Código interno",
    address_field: "Morada",
    activity_sector: "Setor de atividade",
    purchase_volume_eur: "Volume de compras (€)",
    team_contacts: "Contactos da equipa do cliente",
    function_field: "Função",
    phone_field: "Telefone",
    financial_health: "Saúde financeira",
    liquidity_days: "Liquidez (prazo médio de pagamento a fornecedores, dias)",
    liabilities_total: "Passivo total (€)",
    equity: "Capital próprio (€)",
    solvency_ratio: "Solvabilidade (passivo / capital próprio)",
    ebitda_eur: "Rentabilidade — EBITDA (€)",
    risk_rating: "Avaliação de risco",
    risk_1: "nada arriscado",
    risk_2: "pouco arriscado",
    risk_3: "moderado",
    risk_4: "arriscado",
    risk_5: "muito arriscado",
    financial_reports: "Relatórios financeiros",
    upload_report: "Anexar relatório",
    uploading: "A carregar…",
    save_financial: "Guardar indicadores",
    financial_saved: "Indicadores financeiros guardados",
    financial_save_error: "Erro ao guardar indicadores",
    financial_complete: "Preenchida",
    financial_pending: "Pendente",
    read_only: "Só leitura",
    close: "Fechar",
    open: "Abrir",
    download_error: "Erro ao descarregar",
    delete_error: "Erro ao remover",
    payment_terms_help: "Quando vazios, são usados os valores por defeito da configuração global.",
    payment_terms_parts: "Payment terms — peças",
    payment_terms_tooling: "Payment terms — moldes/ferramentas",

    // Payment terms editáveis no diálogo Gerar Offer (herdam do cliente)
    offer_payment_terms_section: "Payment terms",
    offer_payment_terms_help: "Aparecem na secção Payment Terms do PDF. Deixe vazio para herdar os payment terms do cliente e, na falta destes, os defaults globais.",

    // Planning weeks (editáveis no diálogo Gerar Offer; defaults 12/2/8/6)
    offer_planning_section: "Planning (semanas)",
    offer_planning_help: "Aparecem na secção Planning do PDF. Deixe vazio para usar os defaults globais (12 / 2 / 8 / 6).",
    offer_planning_first_article_weeks: "Primeira amostra (semanas)",
    offer_planning_first_series_weeks: "Primeira série após validação (semanas)",
    offer_planning_supplying_weeks: "Fornecimento (semanas)",
    offer_planning_supplying_forecast_weeks: "Fornecimento com forecast (semanas)",

    // Finishing operations admin tab
    finishing_admin_title: "Operações de acabamento",
    finishing_admin_desc: "Defina as operações disponíveis no painel \"VA Acabamento\" da cotação e a respectiva tarifa horária. A cadência (peças/h) e a rejeição (%) são preenchidas pelo comercial em cada cotação.",
    new_finishing_rate: "Nova operação",
    no_finishing_rates: "Sem operações configuradas. Crie a primeira para que apareça nas cotações.",
    finishing_name_required: "Nome da operação obrigatório",
    finishing_rate_created: "Operação criada",
    finishing_rate_updated: "Operação actualizada",
    finishing_rate_deactivated: "Operação desactivada",
    finishing_rate_activated: "Operação activada",

    // Machines tab
    new_machine: "Nova Máquina",
    tonnage: "Tonelagem",
    hourly_rate: "Taxa (€/h)",
    max_area: "Área máx (cm²)",
    max_area_header: "Área Máx (cm²)",
    machine_created: "Máquina criada",
    machine_updated: "Máquina actualizada",
    machine_deactivated: "Máquina desactivada",
    machine_activated: "Máquina activada",

    // Alloys tab
    new_alloy: "Nova Liga",
    alloy_created: "Liga criada",
    alloy_updated: "Liga actualizada",
    alloy_deactivated: "Liga desactivada",
    alloy_activated: "Liga activada",
    paf_hint: "PAF (0-1)",

    // Users tab
    new_user: "Novo Utilizador",
    administrator: "Administrador",
    create_user: "Criar Utilizador",
    user_created: "Utilizador criado",
    user_updated: "Utilizador actualizado",
    user_deactivated: "Utilizador desactivado",
    user_reactivated: "Utilizador reactivado",
    deactivate_user_title: "Desactivar utilizador",
    deactivate_user_desc_prefix: "O utilizador",
    deactivate_user_desc_suffix: "deixará de poder entrar na aplicação. Pode reactivar depois.",
    no_profile: "Sem perfil",
    portuguese_full: "Português",
    french_full: "Français",
    english_full: "English",

    // Roles tab
    new_role: "Novo Perfil",
    permissions: "Permissões",
    create_role: "Criar Perfil",
    role_created: "Perfil criado",
    role_updated: "Perfil actualizado",
    system_role_locked: "Sistema — não editável",
    permission_help_aria: "O que esta permissão permite",
    perm_help_rfq_view_own: "Ver apenas RFQs criadas ou atribuídas a si.",
    perm_help_rfq_view_all: "Ver todas as RFQs da plataforma.",
    perm_help_rfq_create: "Criar novas RFQs.",
    perm_help_rfq_edit_own: "Editar RFQs próprias (criadas ou atribuídas).",
    perm_help_rfq_edit_all: "Editar qualquer RFQ, independentemente do dono.",
    perm_help_rfq_submit: "Submeter a RFQ no fluxo (triagem comercial, fecho de análise ou decisão).",
    perm_help_rfq_approve: "Aprovar a RFQ (decisão de Administração / G5).",
    perm_help_rfq_reject: "Rejeitar a RFQ (rejeição estratégica G1 ou decisão G5).",
    perm_help_rfq_view_margin: "Ver preço de venda, margens e painel Rent_Bud.",
    perm_help_rfq_assign_engineer: "Atribuir o engenheiro responsável após a submissão comercial.",
    perm_help_doc_attach: "Anexar documentos à RFQ.",
    perm_help_doc_download: "Descarregar documentos da RFQ.",
    perm_help_offer_generate: "Gerar o PDF da oferta comercial.",
    perm_help_offer_edit: "Editar campos da oferta no momento da geração do PDF.",
    perm_help_offer_download: "Descarregar o PDF da oferta comercial.",
    perm_help_client_view: "Ver a ficha e a lista de clientes.",
    perm_help_client_create: "Criar novos clientes.",
    perm_help_client_edit: "Editar a ficha geral do cliente.",
    perm_help_client_financial_edit: "Editar só os indicadores financeiros do cliente.",
    perm_help_history_view: "Ver o histórico e as notas da RFQ.",
    perm_help_history_add: "Adicionar notas ao histórico da RFQ.",

    // ============ Clients ============
    new_client: "Novo Cliente",
    strategic_type: "Tipo Estratégico",
    growth_potential: "Potencial Crescimento",
    strategic: "Estratégico",
    standard: "Standard",
    transactional: "Transaccional",
    high: "Alto",
    medium: "Médio",
    low: "Baixo",
    potential_label: "Potencial",
    name_required_toast: "Nome obrigatório",
    no_clients: "Sem clientes",
    client_created: "Cliente criado",
    client_create_error: "Erro ao criar cliente",
    client_updated: "Cliente actualizado",
    client_update_error: "Erro ao actualizar cliente",
    edit_client: "Editar cliente",
    email_primary: "Email principal",
    email_primary_help: "Endereço usado por defeito quando o comercial pede informações ao cliente.",
    dept_emails: "Emails por departamento",
    dept_emails_help: "Cada email aparece como opção na caixa de selecção do botão \"Solicitar Informação Adicional\". Deixe em branco se o departamento não for aplicável.",
    email_logistica: "Email logística",
    email_qualidade: "Email qualidade",
    email_comercial: "Email comercial",
    email_projeto: "Email projeto",
    email_contacts: "Contactos adicionais",
    add_contact: "Adicionar contacto",
    no_extra_contacts: "Sem contactos adicionais.",
    role_field: "Função",
    email_invalid_toast: "Endereço de email inválido",

    // ============ RFQ create ============
    fill_required_fields: "Preencha os campos obrigatórios",
    invalid_email: "Email inválido",
    username_min_length: "Utilizador: mínimo 3 caracteres",
    name_min_length: "Nome: mínimo 2 caracteres",
    client_name_required: "Nome do cliente obrigatório",
    rfq_created: "RFQ criado com sucesso",
    rfq_create_error: "Erro ao criar RFQ",
    add_client_aria: "Adicionar cliente",
    cancel_new_client_aria: "Cancelar novo cliente",
    part_ref_placeholder: "Referência peça cliente",
    part_designation_placeholder: "Designação da peça",
    context_placeholder: "Observações, contexto do pedido...",
    commercial_context: "Contexto Comercial",
    create_client: "Criar Cliente",
    rfq_data: "Dados do RFQ",
    creating_wait: "A criar...",

    // ============ RFQ list ============
    no_rfqs_found: "Sem RFQs encontrados",
    reference: "Referência",

    // ============ Login ============
    login_success: "Login com sucesso",
    login_error: "Erro de autenticação",
    login_subtitle: "Gestão de Cotações — Fundição Injectada",
    login_brand_kicker: "Aluthea Group",
    login_brand_lead: "Cotações técnicas com a precisão da fundição injectada de alumínio.",
    login_brand_point_1: "Workflow comercial, engenharia e decisão no mesmo sítio",
    login_brand_point_2: "Motor de cálculo HPDC e validação de preço",
    login_brand_point_3: "Offer PDF, auditoria e histórico de versões",
    entering: "A entrar...",
    default_admin: "Admin padrão",
    email_or_username: "Email ou utilizador",
    email_or_username_placeholder: "exemplo@empresa.pt",
    forgot_password: "Esqueci-me da password",
    forgot_password_title: "Recuperar password",
    forgot_password_subtitle: "Indique o email da sua conta para receber as instruções de recuperação.",
    forgot_password_sent: "Se existir uma conta associada a esse email, foi enviada uma mensagem com as instruções de recuperação. Verifique também a pasta de spam.",
    send_reset_link: "Enviar link de recuperação",
    sending: "A enviar...",
    back_to_login: "Voltar ao login",
    reset_password_title: "Definir nova password",
    reset_password_subtitle: "Escolha uma nova password para a sua conta.",
    reset_password_action: "Alterar password",
    reset_password_success: "Password alterada com sucesso. Pode iniciar sessão.",
    reset_password_error: "Não foi possível alterar a password. Solicite um novo link.",
    reset_password_invalid_token: "Link inválido ou em falta. Solicite um novo email de recuperação.",
    request_new_link: "Solicitar novo link",
    new_password: "Nova password",
    confirm_password: "Confirmar nova password",
    password_min_length: "Mínimo 8 caracteres.",
    passwords_do_not_match: "As passwords não coincidem.",
    saving: "A guardar...",
    generic_error: "Ocorreu um erro. Tente novamente.",

    // ============ Layout ============
    sidebar_open_menu: "Abrir menu lateral",
    sidebar_close_menu: "Fechar menu lateral",
    autosave_pending: "Alterações por guardar…",
    autosave_saving: "A guardar…",
    autosave_saved: "Guardado",
    autosave_error: "Erro ao guardar",
    main_nav_label: "Navegação principal",
    toggle_to_light: "Activar modo claro",
    toggle_to_dark: "Activar modo escuro",
    light_mode: "Modo claro",
    dark_mode: "Modo escuro",
    skip_to_content: "Saltar para conteúdo",
    language_aria: "Idioma",

    // ============ Calc v2 – componentes, subcontratação, outillage ============
    components_section: "Componentes / Insertos",
    no_components_yet: "Sem linhas de componentes. Clica em + para adicionar.",
    add_line: "Adicionar linha",
    add_candidate: "Adicionar candidato",
    no_candidates_yet: "Sem candidatos.",
    component_reference: "Referência",
    component_purchase: "Compra (€)",
    component_transport: "Transporte (€)",
    component_qty: "Qtd/peça",
    component_scrap: "Refugo detetado (%)",
    component_shrink: "Desvio de inventário (%)",
    component_supplier_margin: "Margem fornecedor (%)",
    subcontract_machining: "Maquinagem",
    subcontract_surface_treatment: "Tratamento Superfície",
    subcontract_painting: "Pintura",
    subcontract_other: "Outros",
    selected: "Escolhido",
    supplier: "Fornecedor",
    purchase: "Compra (€)",
    transport_pallet: "Transporte/palete (€)",
    pcs_pallet: "Pças/palete",
    scrap_percent: "Rebut (%)",
    pieces_per_box: "Peças por caixa",
    pieces_per_box_auto_hint: "Calculado automaticamente quando a caixa está seleccionada e as dimensões da peça (Comprimento/Largura/Altura) estão preenchidas.",
    boxes_per_pallet: "Caixas por palete",
    boxes_per_pallet_auto_hint: "Europalete 1200×800×144 mm. Máximo de caixas até ao peso máx. de peças (1500 kg) ou até à altura útil do TIR (2,70 m, já descontada a palete). Ganha o limite que se esgota primeiro.",
    pallet_cost: "Custo palete (€)",
    max_pallet_weight: "Peso máx. palete (kg)",
    tooling_line_label: "Linha",
    tooling_cost: "Custo (€)",
    tooling_margin: "Margem (%)",
    tooling_sale: "Venda (€)",
    tooling_guarantee_shots: "Garantia (nº de shots)",
    tooling_separate_note: "Os moldes / ferramentas são facturados separadamente e não entram no preço por peça.",
    tooling_label_mould_foundry: "Molde fundição",
    tooling_label_mould_cutting: "Molde corte",
    tooling_label_gabarit_machining: "Gabarito maquinagem",
    tooling_label_gabarit_control: "Gabarito controlo",
    tooling_add_line: "Adicionar linha",
    tooling_remove_line: "Remover linha",
    tooling_custom_label_placeholder: "Designação",
    studies_section: "Estudos / Desenvolvimentos",
    studies_separate_note: "Estudos e desenvolvimentos são apenas informativos — não entram no preço por peça nem no preço dos moldes.",
    studies_no_lines: "Sem linhas. Adicione conforme necessário.",
    studies_add_line: "Adicionar linha",
    studies_remove_line: "Remover linha",
    studies_label_placeholder: "Designação do estudo",
    shrink_section: "Écart Inventaire",
    inventory_shrink_label: "Desvio de inventário (%)",
    inventory_shrink_help: "Percentagem de perda de inventário aplicada à cascata de rebut. Default: 5%.",
    pricing_buckets: "Preço de Venda (por bucket)",
    bucket_vm: "VM",
    bucket_va_pack_trans: "VA + Emb. + Transp.",
    // Sub-buckets individualizados (espelham as Margens segmentadas)
    bucket_va_internal: "VA Fundição + Acabamento",
    bucket_extra_works: "Trabalhos extra",
    bucket_packaging: "Embalagem",
    bucket_transport: "Transporte",
    bucket_components: "Componentes",
    bucket_subcontract: "Subcontratação",
    global_margin: "Margem global",
    margin_eur: "Margem (€)",
    tooling_total_separate: "Outillage total (factura separada)",
    warnings: "Alertas",
    warn_pallet_weight_exceeded: "Peso da palete excede o máximo configurado.",

    // ===== Estrutura de custos / validação de preço (Rent_Bud) =====
    pnl_tab_label: "Estrutura de custos",
    pnl_admin_title: "Estrutura de custos",
    pnl_admin_subtitle: "Parâmetros macro da fábrica para a validação de preço. Cada gravação cria uma nova versão imutável.",
    pnl_year: "Ano",
    pnl_active: "Activo",
    pnl_load_error: "Erro a carregar configuração PnL",
    pnl_save_error: "Erro a guardar configuração PnL",
    pnl_saved: "Configuração PnL guardada",
    pnl_reset_to_defaults: "Repor defaults 26-27",
    pnl_reset_to_defaults_done: "Defaults 26-27 carregados (não esquecer de gravar)",
    pnl_block_fixed_costs: "2.1 — Custos fixos anuais (k€/ano)",
    pnl_fixed_charges: "Charges fixes",
    pnl_indirect_labour: "MOI (mão-de-obra indirecta)",
    pnl_management_fees: "Management fees",
    pnl_mod_foundry: "MOD Fundição",
    pnl_mod_finishing: "MOD Acabamento",
    pnl_block_splits: "2.2 — Splits MOI / Charges fixes",
    pnl_moi_split_foundry: "Split MOI fundição (0–1)",
    pnl_cf_split_foundry: "Split CF fundição (0–1)",
    pnl_block_capacity: "2.3 — Capacidade (h/ano)",
    pnl_press_hours_400: "Horas/ano presse 400T",
    pnl_press_hours_600: "Horas/ano presse 600T",
    pnl_press_hours_900: "Horas/ano presse 900T",
    pnl_press_hours_1100: "Horas/ano presse 1100T",
    pnl_labour_hours_finishing: "Horas/ano MO acabamento",
    pnl_working_days: "Dias úteis/ano",
    pnl_absenteeism: "Taxa de absentismo",
    pnl_block_rates: "2.4 — Tarifas €/h",
    pnl_rate_press_400: "Tarifa presse 400T",
    pnl_rate_press_600: "Tarifa presse 600T",
    pnl_rate_press_900: "Tarifa presse 900T",
    pnl_rate_press_1100: "Tarifa presse 1100T",
    pnl_rate_finishing: "Tarifa finishing",
    pnl_block_variable_margins: "2.5 — Variável + margens",
    pnl_variable_costs_pct: "% custos variáveis sobre VA",
    pnl_variable_costs_hint: "Default 13.86 % — aplica-se sobre VA, nunca sobre VM/GAS/ST",
    pnl_energy_default: "Energia €/kg (fallback)",
    pnl_marge_va_target: "Margem VA alvo",
    pnl_marge_va_hint: "20 % por defeito — aplica-se SÓ sobre PR_INJ + PR_Para",
    pnl_ebitda_target: "EBITDA-alvo (% receita)",
    pnl_alloys_table: "Tabela de ligas (€/kg)",
    pnl_add_alloy: "Adicionar liga",
    pnl_alloy_code: "Código (ex: 47100)",
    pnl_purchase_eur_per_kg: "HA €/kg (compra)",
    pnl_selling_eur_per_kg: "PV €/kg (venda)",
    pnl_energy_table: "Energia por presse (€/kg)",
    pnl_energy_400: "400T €/kg",
    pnl_energy_600: "600T €/kg",
    pnl_energy_900: "900T €/kg",
    pnl_energy_1100: "1100T €/kg",

    // PnLAuditPanel
    pnl_audit_title: "Auditoria PnL cross-check",
    pnl_audit_unavailable: "Auditoria indisponível",
    pnl_audit_unavailable_hint: "Guarda a cotação para correr o cross-check PnL.",
    pnl_verdict_ok: "OK — preço alinhado cotação",
    pnl_verdict_subprecificado: "Subprecificado",
    pnl_verdict_sobreprecificado: "Sobreprecificado",
    pnl_verdict_critico: "Crítico — abaixo do mínimo EBITDA",
    pnl_verdict_error: "Erro na auditoria",
    pnl_reason_reason_below_min_ebitda: "Δ vs mínimo EBITDA < -5%",
    pnl_reason_reason_below_theoretical: "Δ vs calculado < -5%",
    pnl_reason_reason_above_theoretical: "Δ vs calculado > +10%",
    pnl_reason_reason_in_range: "Δ vs calculado dentro de [-5%, +10%]",
    pnl_pv_proposed: "PV proposto",
    pnl_pv_proposed_hint: "Calculado pelo motor existente",
    pnl_pv_theoretical_schreder: "PV teórico",
    pnl_pv_min_ebitda: "PV mín. EBITDA-alvo",
    pnl_delta_vs_schreder: "Δ vs calculado",
    pnl_delta_vs_min_ebitda: "Δ vs mínimo",
    pnl_breakdown_title: "Decomposição (€/peça)",
    pnl_vm: "VM",
    pnl_vm_hint: "matéria — pass-through, sem margem",
    pnl_pr_inj: "PR_INJ",
    pnl_pr_inj_hint: "presse",
    pnl_pr_para: "PR_Para",
    pnl_pr_para_hint: "acabamento",
    pnl_pr_gas: "PR_GAS",
    pnl_pr_gas_hint: "energia",
    pnl_pr_st: "PR_ST",
    pnl_pr_st_hint: "subcontratação — pass-through",
    pnl_pr_total: "Pr_total",
    pnl_ebitda_implied: "EBITDA implícito",
    pnl_ebitda_implied_hint: "(PV − Pr_total − cargas variáveis) / PV",
    pnl_press_hours: "Horas-presse",
    pnl_press_capacity_used: "da capacidade",
    pnl_finishing_hours: "Horas finishing/ano",
    pnl_finishing_hours_hint: "incluindo absentismo",
    pnl_diag_alloy: "Liga",
    pnl_diag_press: "Presse",
    pnl_energy: "Energia",
    pnl_kg: "kg",
    pnl_warnings: "Alertas",
    pnl_warn_warn_capacity: "Peça excede a capacidade anual da presse",
    pnl_warn_warn_loss: "EBITDA implícito negativo — peça em prejuízo",
    pnl_warn_warn_outlier: "Δ fora do intervalo ±25 % — verificar inputs",
    pnl_warn_warn_alloy_unknown: "Liga não reconhecida nos dados de PnL",
    pnl_warn_warn_alloy_not_priced: "Liga sem preços configurados — fallback à 1ª",
    pnl_warn_warn_press_unknown: "Tonelagem da máquina indeterminada — usado bucket 600T",
    pnl_warn_warn_volume_missing: "Volume anual em falta",
    pnl_warn_warn_cycle_missing: "Tempo de ciclo em falta",
    pnl_warn_warn_weight_missing: "Peso da peça em falta",
    pnl_warn_warn_scrap_foundry_out_of_range: "Scrap fundição fora de [0, 30 %]",
    pnl_warn_warn_scrap_finishing_out_of_range: "Scrap acabamento fora de [0, 30 %]",
    pnl_warn_warn_audit_exception: "Excepção interna na auditoria",
    pnl_warn_warn_no_pnl_config: "Sem FactoryPnLConfig activa — auditoria não disponível",
    pnl_warn_warn_no_cost_structure: "Sem estrutura de custos activa",
    pnl_warn_warn_energy_fallback: "Energia €/kg: fallback usado (máquina sem valor)",

    price_validation_title: "Validação de preço",
    price_validation_subtitle: "Modelo absorção mono-produto (Rent_Bud)",
    pnl_legacy_snapshot_title: "Snapshot antigo",
    pnl_legacy_snapshot_hint: "Este resultado foi calculado com o modelo anterior. Guarde novamente a cotação para actualizar a validação.",
    traffic_VERDE: "Verde",
    traffic_AMARELO: "Amarelo",
    traffic_VERMELHO: "Vermelho",
    kpi_marge_vm_va_pct: "Margem VM+VA (%)",
    price_validation_decomposition: "Decomposição",
    resultado_va: "Resultado VA (€)",
    resultado_vm: "Resultado VM (€)",
    marge_total_eur: "Marge total (€)",
    price_validation_support: "Dados de suporte",
    qtd_pieces_year: "Quantidade (peças/ano)",
    ca_vendu: "CA vendido (€)",
    va_vendu: "VA vendido (€)",
    tonnes: "Toneladas",
    // Memória de cálculo do card "Validação de preço" (bloco colapsável).
    pv_aux_title: "Cálculos auxiliares",
    pv_aux_group_quantity: "Quantidade",
    pv_aux_group_margin: "Margem e semáforo",
    pv_aux_cadence: "Cadência de injeção (peças/h)",
    pv_aux_cadence_f: "Injeções/h × TRS × Cavidades",
    pv_aux_hours_year: "Horas de injeção / ano",
    pv_aux_hours_year_f:
      "Dias úteis × Turnos/dia × Horas/turno × Nº máquinas × Utilização × (1 − Sucata macro)",
    pv_aux_qtd_f: "Horas de injeção/ano × Cadência",
    pv_aux_ca_f: "Quantidade × Preço de venda",
    pv_aux_va_vendu_f: "(Preço de venda − VM/peça) × Quantidade",
    pv_aux_tonnes_f: "Quantidade × Peso peça ÷ 1000",
    pv_aux_energy: "Energia (€/ano)",
    pv_aux_energy_f: "Quantidade × Peso peça × Energia €/kg da máquina",
    pv_aux_variable: "Custos variáveis sobre VA (€/ano)",
    pv_aux_variable_f: "VA vendido × % variáveis",
    pv_aux_fixed: "Custos fixos (€/ano)",
    pv_aux_fixed_f: "Soma das rubricas fixas anuais",
    pv_aux_finishing_seconds: "Tempo de acabamentos (s/peça)",
    pv_aux_finishing_seconds_f: "Σ 3600 ÷ cadência de cada operação ativa (Polimento × 2)",
    pv_aux_effectif: "Efetivo acabamentos (pessoas)",
    pv_aux_effectif_f:
      "Quantidade × (Segundos/peça ÷ 3600) ÷ (Dias úteis × Horas/turno acabamentos)",
    pv_aux_mod: "MOD acabamentos (€/ano)",
    pv_aux_mod_f: "Efetivo × Custo anual por pessoa",
    pv_aux_transport: "Transporte (€/ano)",
    pv_aux_transport_f: "Quantidade × Transporte/peça",
    pv_aux_resultado_va_f:
      "VA vendido − (Energia + Variáveis + Fixos + MOD + Transporte)",
    pv_aux_vm_sold: "VM vendida (€/ano)",
    pv_aux_vm_sold_f: "Quantidade × VM/peça",
    pv_aux_vm_bought: "VM comprada (€/ano)",
    pv_aux_vm_bought_f:
      "Toneladas × (1 + Perda ao fogo de revenda) × (Base MB + Prémio de Compra)",
    pv_aux_vm_paf_resold: "VM PAF revendido (€/ano)",
    pv_aux_vm_paf_resold_f:
      "Perda ao fogo de revenda × Toneladas × (Valorização escória × Base MB × % escória + Valorização limalhas × Base MB × % limalhas)",
    pv_aux_resultado_vm_f: "VM vendida − VM comprada + VM PAF revendido",
    pv_aux_marge_f: "Resultado VA + Resultado VM",
    pv_aux_marge_pct_f: "Marge total ÷ CA vendido",
    pv_aux_thresholds: "Limiares do semáforo",

    price_validation_simulation: "Simulação",
    sim_sale_price: "Preço de venda (€/peça)",
    sim_shots_per_hour: "Cadência injecção (peças/h)",
    recalculate: "Recalcular",
    cs_block_capacity: "1. Capacidade e calendário",
    cs_block_fixed: "2. Custos fixos estruturais (€/ano)",
    cs_block_mo: "3. Mão-de-obra acabamentos",
    cs_block_variable: "4. % custos variáveis sobre VA",
    cs_block_fire_loss: "5. Perda ao fogo",
    cs_block_thresholds: "6. Semáforo (limiares margem %)",
    cs_save_new_version: "Guardar nova versão",
    cs_add_fixed_line: "Adicionar linha",
    cs_add_var_line: "Adicionar %",
    machine_energy_eur_per_kg: "Energia €/kg fundido",
    finishing_parallel_ops: "Operadores em paralelo",
    cs_name_version: "Nome da versão",
    cs_name_required: "Indique o nome da versão antes de guardar.",
    // Histórico de tempos de ciclo (admin) + sugestão no card VA Fundição.
    cycle_times_tab: "Tempos de ciclo",
    ct_import_title: "Importar histórico (Excel)",
    ct_import_hint:
      "Ficheiro .xlsx com colunas: peso peça (kg), peso peça c/ gito (kg), máquina, tempo de ciclo (s/peça) e nº de molde (opcional, indicativo). A primeira linha deve conter os cabeçalhos.",
    ct_import_btn: "Importar Excel",
    ct_importing: "A importar…",
    ct_replace_existing: "Substituir histórico existente",
    ct_imported: "Linhas importadas",
    ct_import_skipped: "Linhas ignoradas",
    ct_import_error: "Erro ao importar o ficheiro.",
    ct_new_record: "Nova linha de histórico",
    ct_part_weight: "Peso peça (kg)",
    ct_part_weight_runner: "Peso c/ gito (kg)",
    ct_cycle_time: "Tempo de ciclo (s/peça)",
    ct_mold_number: "Nº molde",
    ct_created: "Linha adicionada.",
    ct_updated: "Linha atualizada.",
    ct_deleted: "Linha removida.",
    ct_fields_required: "Preencha peso peça, peso c/ gito e tempo de ciclo (valores > 0).",
    ct_empty: "Sem registos no histórico. Importe um Excel ou adicione linhas.",
    ct_suggestion_label: "Sugestão (histórico)",
    ct_suggestion_records: "registos",
    ct_suggestion_all_machines: "todas as máquinas",
    ct_apply: "Aplicar",
    cs_working_days: "Dias úteis / ano",
    cs_shifts: "Turnos / dia",
    cs_shifts_injection: "Turnos / dia — Injecção",
    cs_shifts_finishing: "Turnos / dia — Acabamentos",
    cs_hours_inj: "Horas / turno — injecção",
    cs_hours_fin: "Horas / turno — acabamentos",
    cs_machine_count: "Nº máquinas injecção",
    cs_utilization: "Taxa utilização capacidade (0–1)",
    cs_macro_scrap: "Sucata macro fábrica (0–1)",
    cs_finishing_fte_cost: "Custo MO acabamentos (€ / pessoa / ano)",
    cs_margin_green: "Limiar verde — margem VM+VA (0–1)",
    cs_margin_warn: "Limiar amarelo — margem VM+VA (0–1)",
    cs_fire_loss_resale_pct: "Perda ao fogo de revenda (0–1)",
    cs_slag_valuation_rate: "Valorização da escória (0–1)",
    cs_slag_share_rate: "Percentagem de escória (0–1)",
    cs_slag_share_rate_hint: "Escória vendida do total de resíduos aproveitados.",
    cs_chips_valuation_rate: "Valorização das limalhas (0–1)",
    cs_chips_share_rate: "Percentagem de limalhas (0–1)",
    cs_chips_share_rate_hint: "Limalhas vendidas do total de resíduos aproveitados.",
    cs_fixed_label: "Rubrica",
    cs_fixed_amount: "Montante anual (€)",
    cs_var_label: "Rubrica",
    cs_var_pct: "% sobre VA vendido",
    cs_versions_title: "Histórico de versões",
    cs_activate: "Activar",
    cs_load_error: "Erro a carregar estrutura de custos",
    cs_save_error: "Erro a guardar versão",
    cs_saved: "Nova versão gravada e activada",
    cs_activate_done: "Versão activada",

    // ===== Dashboard (revisão profissional, multi-perfil) =====
    // Saudações dinâmicas no cabeçalho do dashboard
    greeting_morning: "Bom dia",
    greeting_afternoon: "Boa tarde",
    greeting_evening: "Boa noite",
    // Selector de período
    period_last_7d: "7 dias",
    period_last_30d: "30 dias",
    period_last_90d: "90 dias",
    period_ytd: "YTD",
    period_last_12m: "12 meses",
    period_custom: "Personalizado",
    period_from: "De",
    period_to: "Até",
    period_apply: "Aplicar",
    period_invalid_range: "Intervalo inválido",
    vs_previous_period: "vs período anterior",
    // KPI labels — Admin
    dash_kpi_total_rfqs: "RFQs no período",
    dash_kpi_conversion: "Taxa de conversão",
    dash_kpi_won_revenue: "Receita anual ganha",
    dash_kpi_pipeline_value: "Pipeline activo",
    dash_kpi_blocked: "RFQs bloqueados",
    // KPI labels — Comercial
    dash_kpi_my_active_rfqs: "Minhas RFQs activas",
    dash_kpi_my_pipeline_value: "Meu pipeline",
    dash_kpi_my_close_rate: "Minha taxa de fecho",
    dash_kpi_my_follow_up: "Follow-ups urgentes",
    // KPI labels — Engenharia
    dash_kpi_eng_in_analysis: "RFQs em análise",
    dash_kpi_eng_overdue: "SLA-overdue",
    dash_kpi_eng_avg_time: "Tempo médio em Eng.",
    dash_kpi_eng_rework: "Retrabalho",
    // KPI labels — Financeiro
    dash_kpi_avg_pipeline_margin: "Margem média do pipeline",
    dash_kpi_avg_won_margin: "Margem média (ganhas)",
    dash_kpi_vm_share: "Custo VM (% PV)",
    // KPI labels — Logística
    dash_kpi_active_with_transport: "Activas c/ transporte",
    dash_kpi_annual_weight: "Peso anual estimado",
    dash_kpi_distinct_box_types: "Tipos de caixa em uso",
    dash_kpi_active_suppliers: "Fornecedores activos",
    // Charts — títulos
    chart_loss_reasons: "Motivos de perda",
    chart_funnel_timeseries: "Funil ao longo do tempo",
    chart_pipeline_by_status: "Pipeline por estado",
    chart_pnl_by_commercial: "PnL audit por Comercial",
    chart_my_status: "As minhas RFQs por estado",
    chart_my_funnel_timeseries: "O meu funil ao longo do tempo",
    chart_my_loss_reasons: "Motivos das minhas perdas",
    chart_engineering_flow: "Fluxo da Engenharia",
    chart_eng_distribution: "Distribuição por estado",
    chart_margin_timeseries: "Margem ao longo do tempo",
    chart_cost_composition: "Composição média do custo",
    chart_margin_by_client_type: "Margem por tipo de cliente",
    chart_incoterm_mix: "Mix de incoterms",
    chart_box_type_mix: "Tipos de caixa",
    chart_subcontract_mix: "Subcontratação por categoria",
    // Tabelas — títulos
    table_top_clients: "Top clientes (receita ganha)",
    table_awaiting_direction: "À espera da Administração (G5)",
    table_my_followup: "Os meus follow-ups urgentes",
    table_my_deadlines: "Os meus deadlines próximos",
    table_eng_queue: "A minha fila ordenada por urgência",
    table_underpriced: "RFQs sub-precificadas activas",
    table_logistics_pending: "RFQs com transporte/embalagem por completar",
    // Séries
    series_created: "Criadas",
    series_won: "Ganhas",
    series_lost: "Perdidas",
    series_entered: "Entraram",
    series_left: "Saíram",
    series_margin: "Margem (%)",
    // Donut center labels
    total: "Total",
    lost_total: "Perdidas",
    cost_total: "Custo médio",
    // Tabela — headers
    rfq_ref: "Ref. RFQ",
    last_update: "Última actualização",
    days_idle: "Dias parado",
    days_remaining: "Dias",
    missing_fields: "Por completar",
    won_revenue_short: "Receita ganha",
    won_count_short: "Ganhos",
    conversion_short: "Conversão",
    client: "Cliente",
    pnl_verdict: "PnL audit",
    ebitda_implied_pct_short: "EBITDA",
    // Verdicts (lowercase para t() funcionar com snake_case)
    pnl_verdict_ok: "OK",
    pnl_verdict_subprecificado: "Subprecificada",
    pnl_verdict_sobreprecificado: "Sobreprecificada",
    pnl_verdict_critico: "Crítica",
    pnl_verdict_unknown: "—",
    // Tipos de cliente (rotulagem amigável para os charts)
    client_type_strategic: "Estratégico",
    client_type_standard: "Padrão",
    client_type_transactional: "Transaccional",
    // Composição do custo (legenda do donut financeiro)
    cost_vm: "VM (matéria-prima)",
    cost_va_foundry: "VA Fundição",
    cost_va_finishing: "VA Acabamento",
    cost_va_extra_works: "Trabalhos extra",
    cost_components: "Componentes",
    cost_subcontract: "Subcontratação",
    // Subcontratação (legenda do bar chart)
    subcontract_machining: "Maquinagem",
    subcontract_surface_treatment: "Tratamento superfície",
    subcontract_painting: "Pintura",
    subcontract_other: "Outro",
    // Incoterms (rotulagem amigável)
    incoterm_exwork: "Ex Works",
    incoterm_exworks: "Ex Works",
    incoterm_ex_works: "Ex Works",
    incoterm_ddp: "DDP",
    incoterm_dap: "DAP",
    incoterm_fca: "FCA",
    incoterm_fob: "FOB",
    incoterm_cif: "CIF",
    "incoterm_—": "Sem incoterm",
    // Empties + missing
    no_data: "Sem dados no período seleccionado",
    no_followup: "Sem follow-ups urgentes",
    no_queue: "Fila vazia",
    no_underpriced: "Sem RFQs sub-precificadas activas",
    no_logistics_pending: "Tudo completo",
    missing_incoterm: "Incoterm",
    missing_box_type: "Caixa",
    missing_pieces_per_box: "Pças/caixa",
    // Tabela "Acções pendentes" (Comercial e Engenharia)
    table_pending_action: "Acções pendentes (à minha espera)",
    table_pending_action_eng: "Acções pendentes (RFQs em análise)",
    no_pending_action: "Não há nada à tua espera",
    days_in_state: "Dias no estado",
    // ----- KPI descriptions (pequena linha por baixo do valor) -----
    // Placeholders {won}, {lost}, {count}, {days}, {value} são substituídos
    // no frontend pelo helper resolveKpiDescription.
    kpi_desc_won_lost: "{won} ganhas · {lost} perdidas",
    kpi_desc_n_rfqs: "{count} RFQs",
    kpi_desc_blocked_threshold: "> 7 dias sem actividade",
    kpi_desc_followup: ">{days}d · {value} €",
    kpi_desc_eng_avg_time: "dias entre Eng→Comercial",
    kpi_desc_eng_rework: "RFQs com mais de uma versão",
    kpi_desc_vm_share: "% do PV em matéria-prima",
    kpi_desc_annual_weight: "kg/ano (estimado)",
    kpi_desc_distinct_box_types: "tipos diferentes em uso",
    // ----- KPI tooltips (ícone "i" ao lado do label, mostra ao passar o rato) -----
    kpi_help_total_rfqs: "Número de RFQs criadas (campo 'created_at' dentro do período seleccionado).",
    kpi_help_conversion: "Ganhas / (Ganhas + Perdidas) das RFQs cuja decisão final caiu no período. Não conta as que ainda estão em pipeline ou em negociação.",
    kpi_help_won_revenue: "Σ (volume anual × preço de venda) das RFQs marcadas como ganhas no período. É a receita anualizada que ficou assegurada.",
    kpi_help_pipeline_value: "Σ (volume anual × preço de venda) das RFQs que ainda não fecharam (excluindo Won/Lost). Mostra quanto está em jogo agora.",
    kpi_help_blocked: "RFQs em estados intermédios (Engenharia, Margens, Financeiro, Administração) que estão no mesmo estado há mais de 7 dias sem actividade. Atenção operacional.",
    kpi_help_my_active_rfqs: "Total das tuas RFQs (criadas por ti) que ainda não foram fechadas como Ganhas ou Perdidas.",
    kpi_help_my_pipeline_value: "Σ (volume anual × preço de venda) das tuas RFQs activas. Quanto tens em pipeline próprio.",
    kpi_help_my_close_rate: "Ganhas / (Ganhas + Perdidas) só para as TUAS RFQs (filtra por created_by). Conta apenas as que fecharam dentro do período.",
    kpi_help_my_follow_up: "RFQs tuas em 'Oferta enviada' ou 'Em negociação' há mais de 14 dias sem actividade — provavelmente o cliente não respondeu, vale a pena dar um toque.",
    kpi_help_eng_in_analysis: "Número de RFQs no estado 'Em análise' atribuídas a ti como engenheiro responsável (ou todas, se não tens nenhuma atribuída).",
    kpi_help_eng_overdue: "Subset das tuas RFQs em análise cujo deadline já passou (SLA-overdue). Estas geram notificações automáticas para ti e para o comercial criador.",
    kpi_help_eng_avg_time: "Mediana ponderada do tempo (em dias) entre o submit do Comercial para Engenharia e o envio de volta com o estudo técnico, calculado para fechos no período seleccionado. Indicador de cadência da Engenharia.",
    kpi_help_eng_rework: "RFQs cuja versão actual do formulário é > 1, ou seja, foram devolvidas ao Comercial pelo menos uma vez (correcção de dados, lock-edit, novo passe). Mede a qualidade do primeiro passe técnico — quanto mais alto, mais a Engenharia está a corrigir / pedir alterações depois do submit inicial.",
    kpi_help_avg_pipeline_margin: "Média da margem global (margin_global_percent) das cotações activas em pipeline. Excluí Won/Lost.",
    kpi_help_avg_won_margin: "Média da margem global das cotações que ficaram fechadas como ganhas no período seleccionado. Indica a qualidade do que vendeste.",
    kpi_help_vm_share: "Quanto do preço de venda corresponde a matéria-prima (alumínio + premiums + PAF). Sinaliza exposição a flutuações de preço do metal.",
    kpi_help_active_with_transport: "RFQs em pipeline (não fechadas) que já têm um Incoterm seleccionado. Útil para perceber quantas estão prontas para análise logística.",
    kpi_help_annual_weight: "Σ (volume anual × peso por peça) das RFQs activas. Estimativa do tonelagem anual a movimentar — ajuda a antecipar capacidade de transporte.",
    kpi_help_distinct_box_types: "Quantos tipos de caixa diferentes estão associados às RFQs activas. Quanto maior, mais fragmentação na embalagem.",
    kpi_help_active_suppliers: "Fornecedores marcados como activos no catálogo (Administração → Fornecedores). Inclui os 4 tipos: maquinagem, tratamento superfície, pintura, outro.",
    // ----- KPIs Engenharia novos (substituem o "Retrabalho") -----
    dash_kpi_eng_throughput: "Entregues no período",
    dash_kpi_eng_upcoming: "Carga próxima 7 dias",
    kpi_desc_eng_throughput: "Saíram da análise para o Comercial",
    kpi_desc_eng_upcoming: "Em análise · deadline ≤ 7 d",
    kpi_help_eng_throughput: "RFQs cuja transição IN_ANALYSIS → próximo estado (tipicamente AWAITING_COMMERCIAL_MARGINS) ocorreu DENTRO do período seleccionado. É a métrica de produtividade real da Engenharia: 'quantas RFQs entregaste de volta ao Comercial neste horizonte'.",
    kpi_help_eng_upcoming: "RFQs que estão actualmente em análise contigo e cujo deadline cai nos próximos 7 dias (sem incluir as que já passaram — essas estão no KPI 'Em atraso'). Ajuda a planear a semana e antecipar pressão de SLA antes de virar overdue.",
    // ----- Charts: máquinas e VA Acabamento em RFQs ganhas -----
    chart_machines_won: "Máquinas — RFQs ganhas",
    chart_finishing_won: "Acabamentos — RFQs ganhas",
    chart_my_machines_won: "As minhas máquinas — RFQs ganhas",
    chart_my_finishing_won: "Os meus acabamentos — RFQs ganhas",
    chart_machines_won_eng: "Máquinas — RFQs ganhas (com Engenharia)",
    chart_finishing_won_eng: "Acabamentos — RFQs ganhas (com Engenharia)",
    no_won_data: "Sem RFQs ganhas no escopo",
  },

  fr: {
    app_title: "HPDC RFQ",
    login: "Connexion",
    logout: "Déconnexion",
    username: "Utilisateur",
    password: "Mot de passe",
    dashboard: "Tableau de bord",
    rfqs: "Devis",
    clients: "Clients",
    admin: "Administration",
    config: "Configuration",
    new_rfq: "Nouveau Devis",
    search: "Rechercher",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    expand: "Développer",
    collapse: "Réduire",
    expand_all: "Tout développer",
    collapse_all: "Tout réduire",
    collection_changed_summary: "Liste mise à jour — {old} → {new} lignes",
    create: "Créer",
    back: "Retour",
    submit: "Soumettre",
    approve: "Approuver",
    reject: "Rejeter",
    download: "Télécharger",
    status: "État",
    deadline: "Échéance",
    client: "Client",
    part_ref: "Réf. Pièce",
    part_designation: "Désignation",
    annual_volume: "Volume Annuel (pcs/an)",
    created_at: "Date Création",
    engineer: "Ingénieur",
    commercial: "Commercial",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    confirm: "Confirmer",
    no_data: "Aucune donnée",
    name: "Nom",
    code: "Code",
    description: "Description",
    country: "Pays",
    contact: "Contact",
    email: "Email",
    full_name: "Nom complet",
    language: "Langue",
    role: "Profil",
    notes: "Notes",
    color: "Couleur",
    actions: "Actions",
    system: "Système",
    active: "Active",
    inactive: "Inactive",
    active_m: "Actif",
    inactive_m: "Inactif",
    activate: "Activer",
    deactivate: "Désactiver",
    previous: "Précédent",
    next: "Suivant",
    page: "Page",
    page_x_of_y: "Page {page} sur {pages}",
    per_page: "Par page",
    results: "résultats",
    type: "Type",
    required_field: "*",

    in_preparation: "En Préparation",
    awaiting_engineering_assignment: "Attente Attribution Ingénieur",
    in_analysis: "En Analyse Technique",
    awaiting_logistics: "Attente Logistique",
    awaiting_commercial_margins: "Attente Marges Commerciales",
    awaiting_finance: "Attente Financier",
    awaiting_direction: "Attente Administration (Exception)",
    awaiting_admin: "Attente Administration",
    approved: "Approuvé",
    offer_sent: "Offre Envoyée",
    won: "Gagné",
    lost: "Perdu",
    in_negotiation: "En Négociation",
    all_states: "Tous les états",

    gate_g1: "G1 — Qualification Stratégique",
    gate_g2: "G2 — Validation Documentaire",
    gate_g3: "G3 — Validation Technique",
    gate_g4: "G4 — Validation Financière",
    gate_g5: "G5 — Exception Administration",
    strategic_triage: "Qualification Stratégique",
    strategic_reject: "Rejeter par qualification stratégique",
    strategic_reject_title: "Rejeter par qualification stratégique (G1)",
    strategic_reject_desc: "Indiquez le motif stratégique du rejet. Le client sera informé hors de l'application.",
    strategic_rejected_toast: "Devis rejeté par qualification stratégique",
    request_client_info: "Demander information au client",
    request_client_info_title: "Demander information supplémentaire",
    request_client_info_desc: "Indiquez l'information nécessaire. Le devis sera marqué comme en attente d'information externe.",
    client_info_received: "Information reçue du client",
    client_info_received_title: "Marquer l'information comme reçue",
    client_info_requested_toast: "Demande d'information enregistrée",
    client_info_requested_with_email_toast: "Demande enregistrée et email envoyé au client",
    client_info_requested_no_email_toast: "Demande enregistrée mais email non envoyé",
    client_info_no_email_toast: "Aucun destinataire indiqué — aucun email ne sera envoyé",
    client_info_received_toast: "Information marquée comme reçue",
    send_email_to_client: "Envoyer un email automatique au client",
    email_to_recipients: "Destinataires",
    email_to_recipients_help: "Séparez plusieurs adresses par une virgule. Pré-rempli avec l'email principal du client.",
    email_recipient_role: "Destinataire du client",
    email_recipient_role_help: "Sélectionnez le département du client à contacter. Les emails proviennent de la fiche client.",
    email_role_custom: "Autre adresse (saisie manuelle)",
    email_no_dept_configured: "Le client n'a pas encore d'emails par département configurés. Utilisez le champ ci-dessous.",
    awaiting_client_flag: "En attente d'information du client",
    awaiting_client_pending: "Demande(s) d'information en attente",
    return_to_commercial: "Renvoyer pour retravail",
    return_to_commercial_title: "Renvoyer au Commercial (retravail technique)",
    return_to_commercial_desc: "Indiquez les ajustements techniques nécessaires. Une nouvelle version du devis sera créée.",
    returned_to_commercial_toast: "Devis renvoyé pour retravail",
    submit_for_finance: "Soumettre au Financier",
    submit_for_finance_title: "Approuver techniquement et soumettre au Financier (G3 → G4)",
    submit_for_finance_desc: "Classez le risque technique avant de soumettre pour validation financière.",
    submitted_finance_toast: "Soumis pour validation financière",
    submit_to_commercial_margins: "Envoyer au Commercial",
    submit_to_commercial_margins_title: "Envoyer pour ajustement des marges",
    submit_to_commercial_margins_desc: "Classez le risque technique. Le devis va directement au Commercial pour ajuster les marges (sans passer par la Logistique dans le nouveau flux simplifié).",
    submitted_commercial_margins_toast: "Devis envoyé au Commercial pour ajuster les marges",
    gate_commercial_margins_desc_v2: "Ajustez les marges segmentées. À la soumission, le système décide automatiquement entre approuver ou escalader à l'Administration selon l'audit PnL.",
    submit_to_administration: "Soumettre à l'Administration",
    submit_for_approval: "Soumettre pour approbation",
    submit_escalate_title: "Soumettre à l'Administration",
    submit_escalate_desc: "L'audit PnL indique EBITDA-cible négatif — le devis sera escaladé à l'Administration (G5) pour décision.",
    submit_approve_title: "Soumettre pour approbation",
    submit_approve_desc: "L'audit PnL valide la marge proposée. Le devis sera approuvé automatiquement.",
    final_decision_will_escalate: "L'audit PnL indique EBITDA-cible sous le seuil — à la soumission, le devis sera escaladé à l'Administration (G5).",
    final_decision_will_warn_admin: "Le devis peut être approuvé automatiquement, mais l'Administration sera notifiée car le PV théorique Schreder est négatif.",
    final_decision_will_approve: "Audit PnL dans les limites — à la soumission, le devis sera approuvé automatiquement.",
    escalated_to_administration_toast: "Devis escaladé à l'Administration",
    approved_with_admin_warning_toast: "Devis approuvé (Administration notifiée — Schreder négatif)",
    technical_risk: "Risque Technique",
    risk_low: "Faible",
    risk_medium: "Moyen",
    risk_high: "Élevé",
    risk_required: "Classification de risque obligatoire",
    approve_finance: "Approuver (Financier)",
    reject_escalate: "Rejeter et escalader à l'Administration",
    reject_escalate_title: "Rejeter et escalader à l'Administration (G4 → G5)",
    reject_escalate_desc: "Indiquez le motif financier. Le devis sera escaladé pour décision exceptionnelle de l'Administration.",
    escalated_toast: "Devis escaladé à l'Administration",
    approve_exception: "Approuver par exception",
    approve_exception_title: "Approuver par exception (G5)",
    approve_exception_desc: "L'Administration approuve ce devis par exception, malgré le rejet financier.",
    reject_final: "Rejet final",
    reject_final_title: "Rejet final (G5)",
    reject_final_desc: "Indiquez le motif final. Le devis sera marqué comme perdu par décision de gouvernance.",
    rework_version: "Retravail",
    rework_version_badge: "Retravail v",

    engineering_overdue: "Ingénierie — Échéance Dépassée",
    no_engineering_overdue: "Aucun retard d'ingénierie",
    days_overdue_suffix: "jours de retard",
    sla_overdue_badge: "Échéance dépassée",
    deadline_required: "Définissez une échéance avant de soumettre à l'Ingénierie",
    required_for_submit: "Requis pour soumettre à l'Ingénierie",
    cannot_submit_reasons: "À compléter avant de soumettre à l'Ingénierie :",
    missing_document: "Joindre au moins un document",
    missing_engineer: "Assigner un ingénieur responsable",
    missing_deadline: "Définir une échéance de réponse",
    missing_client_reply: "Marquer l'information du client comme reçue",
    min_chars_hint: "Minimum {n} caractères",
    submission_data: "Données pour la soumission",
    save_rfq_meta: "Enregistrer les données",
    rfq_meta_saved: "Données mises à jour",
    engineer_responsible_label: "Ingénieur responsable",
    engineer_not_assigned: "Non assigné",
    commercial_engineer_section: "Assignation ingénieur (Commercial)",
    error_load_assignable: "Impossible de charger la liste des ingénieurs.",
    download_document: "Télécharger le fichier",
    error_download_doc: "Impossible de télécharger le fichier.",

    versions_title: "Versions du formulaire",
    versions_empty: "Aucune version scellée. La v1 est créée automatiquement lorsque le Commercial soumet le RFQ à l'Ingénierie.",
    version_number_short: "v{n}",
    version_label_baseline: "Baseline",
    version_label_engineering: "Ingénierie",
    version_label_commercial_rework: "Reprise commerciale",
    version_author: "Auteur",
    version_created_at: "Créée le",
    version_status_at_snapshot: "État au snapshot",
    version_no_changes: "Aucun changement vs version précédente",
    rfq_info_title: "Données du RFQ",
    quotation_form_title: "Formulaire de la cotation",
    yes: "Oui",
    no: "Non",
    strategic_notes: "Notes stratégiques",
    loss_reason: "Motif de perte",
    commercial_result: "Résultat commercial",
    result_notes: "Notes du résultat",
    version_changes_count: "{n} champ(s) modifié(s)",
    view_version: "Voir",
    compare_vs_previous: "Différences vs version précédente",
    form_snapshot: "Formulaire (snapshot)",
    calc_snapshot: "Résultat du calcul",
    field: "Champ",
    old_value: "Valeur précédente",
    new_value: "Nouvelle valeur",
    edit_rfq_version: "Modifier (nouvelle version)",
    lock_edit_version: "Terminer l'édition et sceller",
    editing_mode_banner: "Édition d'une nouvelle version — les modifications sont surlignées en ambre. Cliquez sur « Terminer l'édition » pour sceller vN.",
    locked_for_edit_info: "Cette version est scellée. Pour modifier les valeurs, cliquez sur « Modifier » et créez une nouvelle version.",
    unlock_confirm: "Ouvrir une nouvelle version modifiable ?",
    lock_edit_comment_label: "Brève description des modifications (optionnel)",
    changes_summary_header: "Modifications dans cette version",
    fields_highlighted_from_baseline: "Champs modifiés vs baseline",

    vm_section: "Valeur Matière (VM)",
    va_foundry_section: "VA Fonderie",
    va_finishing_section: "VA Parachèvement",
    extra_works_section: "Travaux supplémentaires",
    extra_works_empty: "Aucune opération configurée en Travaux supplémentaires. Créez-les dans l'admin (Parachèvement → catégorie \"Travaux supplémentaires\").",
    va_machining_control_label: "VA Usinage & Contrôle",
    category_finishing: "Parachèvement",
    category_extra_works: "Travaux supplémentaires",
    finishing_admin_category: "Catégorie",
    all: "Tous",
    finishing_op_backstand_rebarbagem: "Backstand / Rebarbagem",
    finishing_op_granalagem: "Grenaillage",
    finishing_op_polimento: "Polissage",
    finishing_op_maquinagem_cnc: "Usinage CNC",
    finishing_op_controlo_gabarit: "Contrôle / Gabarit",
    finishing_op_pintura: "Peinture",
    finishing_op_name: "Opération",
    finishing_cadence_hdr: "Cadence (pcs/h)",
    finishing_rate_hdr: "Tarif (€/h)",
    finishing_scrap_hdr: "Rebut (%)",
    finishing_cadence_placeholder: "pcs/h",
    finishing_rate_placeholder: "€/h",
    finishing_scrap_placeholder: "%",
    subcontract_section: "Sous-traitance",
    packaging_section: "Emballage",
    transport_section: "Transport",
    packaging_transport_section: "Emballage & Transport",
    tooling_section: "Outillage",
    margin_section: "Marge Commerciale",
    results_section: "Résultat du Calcul",
    packaging_section_card: "Emballage (palette + caisse + séparateurs)",
    transport_section_card: "Transport",
    piece_length_mm: "Longueur pièce (mm)",
    piece_width_mm: "Largeur pièce (mm)",
    piece_height_mm: "Hauteur pièce (mm)",
    machine_pressure_bar: "Pression machine (bar)",
    boxes_per_lot: "Caisses par lot",
    separators_per_box: "Séparateurs par caisse",
    transport_incoterm: "Type / incoterm",
    transport_incoterm_other: "Autres",
    transport_km: "Km à parcourir",
    transport_eur_per_km: "€ / km",
    transport_pieces_per_trip: "Nb pièces par voyage",
    commercial_margins_segmented: "Marges commerciales (segmentées)",
    commercial_margins_segmented_help:
      "Chaque poste (VA interne, emballage, transport, travaux supp., sous-traitance et composants) a sa propre marge. Vide = 0 %. La marge des travaux supplémentaires reprend la marge interne si elle n'est pas renseignée.",
    margin_internal_ops: "Marge VA interne (fonderie+finition) (%)",
    margin_packaging: "Marge emballage (%)",
    margin_transport: "Marge transport (%)",
    margin_extra_works: "Marge travaux supplémentaires (%)",
    margin_subcontract: "Marge sous-traitance (%)",
    margin_components: "Marge composants (%)",
    recycling_rate: "Taux de recyclage",
    machine_override: "Machine manuelle (override)",
    cycle_time_manual: "Temps de cycle manuel",
    subcontract_machining_supplier: "Fournisseur usinage",
    subcontract_other_description: "Description (autre sous-traitance)",
    tooling_cost_foundry_eur: "Coût moule fonderie (€)",
    tooling_sale_price_eur: "PV outil (€)",
    gabarit_cost_eur: "Coût gabarit (€)",
    gabarit_margin_percent: "Marge gabarit (%)",
    position: "Position",
    qty_per_piece: "Qté par pièce",
    category: "Catégorie",
    lot_size: "Taille du lot",
    pcs_per_pallet: "Pièces par palette",
    designation: "Désignation",
    cost_eur: "Coût (€)",
    box_type_label: "Type de caisse",
    box_type_placeholder: "Sélectionner…",
    box_type_none: "Aucun (palette seule / coût manuel)",
    packaging_manual_counts_hint: "Sans type de caisse, Pièces par caisse et Caisses par palette sont saisis manuellement.",

    alloy: "Alliage",
    base_mb: "Base MB (€/T)",
    premium: "Prime (€/T)",
    premium_buy: "Prime d'achat (€/T)",
    premium_sell: "Prime de vente (€/T)",
    alloy_premiums_required: "Les primes d'achat et de vente sont obligatoires.",
    alloy_total_buy: "Total d'achat (€/T)",
    alloy_version: "Version de l'alliage",
    select_alloy_version: "Sélectionner une version...",
    chart_alloy_price_evolution: "Évolution des prix des alliages",
    history: "Historique",
    effective_date: "Date d'effet",
    alloy_history_title: "Historique des prix de l'alliage",
    alloy_history_hint: "Chaque changement de prix crée une nouvelle version.",
    project_name: "Nom du projet",
    plan_number: "N° du plan",
    plan_revision: "Révision",
    plan_revision_date: "Date de révision",
    g2_project_info: "Identification du projet / plan",
    base_mb_edit_comment: "Motif de la modification du Base MB",
    base_mb_comment_required: "Indiquez le motif de la modification du Base MB",
    base_mb_comment_min: "Le motif de la modification du Base MB doit comporter au moins {n} caractères.",
    duplicating: "Duplication...",
    recorded_by: "Enregistré par",
    system_author: "Système",
    base_mb_overridden: "Base MB modifié manuellement",
    base_mb_overridden_by: "Modifié par",
    cycle_time_per_piece: "Temps de cycle (s/pièce)",
    shots_per_day: "Coups/jour",
    pieces_per_day: "Pièces/jour",
    pieces_per_day_no_scrap: "Pièces/jour (hors rebut)",
    assign_engineer: "Attribuer un ingénieur",
    assign_engineer_title: "Attribution d'ingénieur (Directeur Technique)",
    assign_engineer_hint: "Sélectionnez l'ingénieur responsable pour démarrer l'analyse technique.",
    engineer_assigned_ok: "Ingénieur attribué",
    paf: "PAF (%)",
    piece_weight: "Poids Pièce (kg)",
    runner_weight: "Poids Masselotte (kg)",
    projected_area: "Surface Projetée (cm²)",
    safety_factor: "Coef. Tiroirs",
    safety_factor_hint: "Entre 0 et 1 — 0,1 sans tiroirs, 0,2 avec tiroirs ; la formule utilise (1 + coefficient).",
    mold_complexity_coef: "Coefficient de sécurité",
    mold_complexity_hint: "Entre 0 et 1 (défaut 0,5) ; la formule utilise (1 + coefficient).",
    projection_coef: "Coefficient de projection",
    projection_coef_hint: "Fraction de la bounding box L×W occupée par la pièce (défaut 0,7). Les pièces qui remplissent presque tout le rectangle approchent 0,9–1,0 ; les pièces fines/lobées descendent sous 0,5.",
    calculated_tonnage: "Force de fermeture (T)",
    tonnage_missing_inputs: "Saisissez la Pression Machine pour que la formule s'applique.",
    runner_weight_coef: "Coefficient du poids du jet",
    runner_weight_coef_hint: "Entre 0 et 1 ; la force de fermeture utilise le facteur (1 + coefficient).",
    auto_selected: "auto-sélectionnée",
    machine: "Machine",
    cavities: "Empreintes",
    shots_hour: "Cadence (coups/h)",
    trs: "TRS (%)",
    cycle_time: "Temps Cycle (s)",
    scrap_rate: "Rebut (%)",
    production_cost: "Coût Production",
    sale_price: "Prix de Vente",
    margin: "Marge",
    margin_percent_label: "Marge (%)",
    auto_by_area: "Auto (par surface)",
    inactive_marker: "(inactif)",
    select_alloy: "Sélectionner un alliage...",
    select_client: "Sélectionner un client...",
    select_placeholder: "Sélectionner...",

    subcontract_machining: "Usinage ST (€/pce)",
    subcontract_surface: "Trait. Surface (€/pce)",
    subcontract_painting: "Peinture ST (€/pce)",
    subcontract_other: "Autre (€/pce)",
    packaging_per_piece: "Emballage (€/pce)",
    transport_per_lot: "Transport (€/lot)",
    pieces_per_lot: "Pièces par lot",

    tooling_amortized: "Outillage (amorti)",
    vm_share: "Part VM",
    expected_annual_va: "VA annuelle attendue",
    expected_annual_va_detail:
      "= {volume} × {rate} €/pièce (bucket «VA Fonderie + Finition» avec marge interne). Les lignes VA ci-dessus sont affichées à 2 décimales ; le moteur calcule avec plus de précision, d’où un léger écart par rapport au produit «à vue d’œil».",
    annual_revenue: "Chiffre d'affaires annuel",
    total_scrap_estimate: "Rebut total est.",
    save_quotation_to_see: "Enregistrez le devis pour voir le résultat",
    engine_mode: "Mode",
    engine_version: "Moteur",

    snapshot_alloy: "Alliage",
    snapshot_piece_weight: "Poids pièce (kg)",
    snapshot_runner_weight: "Poids masselotte (kg)",
    snapshot_projected_area: "Surface proj. (cm²)",
    snapshot_cadence: "Cadence (coups/h)",
    snapshot_cavities: "Nb empreintes",
    snapshot_margin: "Marge",
    snapshot_sale_price: "Prix de vente (€/pce)",
    snapshot_production_cost: "Coût production (€/pce)",

    save_quotation: "Enregistrer le devis",
    saving_wait: "Enregistrement...",
    submit_engineering: "Soumettre à l'Ingénierie",
    submit_validation: "Soumettre pour Validation",
    mark_offer_sent: "Marquer l'offre envoyée",
    duplicate: "Dupliquer",
    comment_placeholder: "Commentaire/Justification...",

    commercial_outcome_title: "Résultat Commercial",
    commercial_outcome_desc: "Enregistrer la décision du client sur la proposition envoyée. Cette information alimente les indicateurs du tableau de bord.",
    mark_won: "Gagné",
    mark_lost: "Perdu",
    mark_in_negotiation: "En négociation",
    mark_won_title: "Marquer comme gagné",
    mark_lost_title: "Marquer comme perdu",
    mark_in_negotiation_title: "Marquer en négociation",
    mark_won_desc: "Le client a accepté la proposition. Vous pouvez ajouter une note (optionnel).",
    mark_lost_desc: "Le client a rejeté la proposition. Indiquez le motif de la perte.",
    mark_in_negotiation_desc: "Le client a refusé la proposition. Le devis passe en négociation et peut être réouvert pour créer une nouvelle version (repasse par l'Ingénierie).",
    outcome_notes: "Notes (optionnel)",
    loss_reason_label: "Motif de la perte",
    loss_reason_price: "Prix",
    loss_reason_lead_time: "Délai de livraison",
    loss_reason_technical: "Technique",
    loss_reason_strategic_pass: "Stratégique",
    loss_reason_competitor: "Concurrence",
    loss_reason_other: "Autre",
    outcome_won_toast: "Résultat enregistré : gagné",
    outcome_lost_toast: "Résultat enregistré : perdu",
    outcome_in_negotiation_toast: "Devis marqué « en négociation »",
    confirm_outcome: "Confirmer",
    in_negotiation_title: "Devis en négociation",
    in_negotiation_desc: "Le client a refusé la proposition. Réouvrez le devis pour créer une nouvelle version ; il repasse par l'Ingénierie avant de pouvoir être clôturé en Gagné/Perdu.",
    reopen_negotiation_action: "Réouvrir / Re-coter",
    reopen_negotiation_title: "Réouvrir le devis pour nouvelle version",
    reopen_negotiation_desc: "Le devis revient à « en préparation » (mode édition). Toute modification crée une nouvelle version et repasse par l'Ingénierie.",
    reopened_negotiation_toast: "Devis réouvert pour nouvelle version",

    all_clients: "Tous les clients",
    all_alloys: "Tous les alliages",
    all_machines: "Toutes les machines",
    clear_filters: "Effacer les filtres",
    pieces_unit: "pcs/an",

    saved_and_recalculated: "Devis enregistré et recalculé",
    submitted_engineering: "Soumis à l'Ingénierie",
    submitted_validation: "Soumis pour validation",
    approved_toast: "Approuvé",
    rejected_toast: "Rejeté avec justification",
    offer_sent_toast: "Offre marquée comme envoyée",
    offer_pdf_section: "Offre commerciale (PDF)",
    generate_offer_pdf: "Générer offre (PDF)",
    generate_offer_pdf_title: "Générer l'offre commerciale en PDF",
    generate_offer_pdf_desc: "Les champs ci-dessous apparaissent dans le PDF. Laissez vide pour utiliser les valeurs par défaut (validité depuis la configuration globale, sans conditions supplémentaires).",
    offer_pdf_language: "Langue du PDF",
    offer_pdf_language_help: "S'applique aux libellés et textes standards de l'offre. Les données client, montants et observations ne sont pas traduits.",
    offer_lang_en: "Anglais",
    offer_lang_fr: "Français",
    offer_lang_pt: "Portugais",
    offer_validity_days: "Validité (jours)",
    offer_specific_conditions: "Conditions spécifiques",
    offer_observations: "Observations",
    offer_generated_toast: "PDF de l'offre généré",
    offer_generate_error: "Erreur lors de la génération du PDF",
    offer_download_error: "Erreur lors du téléchargement du PDF",
    no_offers_yet: "Aucun PDF généré pour l'instant.",
    duplicated_toast: "Devis dupliqué",
    rfq_deleted_toast: "Devis supprimé",
    delete_rfq_confirm: "Voulez-vous vraiment supprimer le devis {ref} ? Cette action est irréversible.",
    error_operation: "Erreur dans l'opération",
    error_saving: "Erreur lors de l'enregistrement",
    error_loading_rfq: "Erreur lors du chargement du devis",
    justification_min_chars: "Justification minimum : 20 caractères",
    rfq_not_found: "Devis non trouvé",
    doc_attached: "Document joint",
    extracting_drawing: "Extraction des informations du dessin 2D (texte + OCR)... Peut prendre 10–30 s.",
    error_attaching_doc: "Erreur lors de l'ajout du document",

    documents: "Documents",
    no_documents: "Aucun document",
    attach_document: "Joindre un document",
    g1_essential_documents: "Documents essentiels (G1)",
    slot_model_3d: "Modélisation 3D",
    slot_drawing_2d: "Dessin 2D (Injection)",
    slot_drawing_2d_machining: "Dessin 2D (Usinage)",
    slot_additional: "Spécifications qualité",
    slot_hint_3d: "Attendu : .step / .stp / .stl",
    slot_hint_2d: "Attendu : PDF (avec couche de texte)",
    slot_hint_additional: "Exigences qualité, normes et critères d'acceptation",
    attach: "Joindre",
    replace: "Remplacer",
    remove: "Supprimer",
    no_file: "Aucun fichier",
    drawing_extracted_info: "Info détectée dans le dessin 2D",
    drawing_extracted_disclaimer: "mode découverte (ne pré-remplit pas le devis)",
    reextract: "Ré-extraire",
    extraction_loading: "Extraction en cours…",
    extraction_keyword_hits: "Mots-clés détectés",
    extraction_numeric_tokens: "Valeurs numériques détectées",
    extraction_title_block: "Cartouche (coin inférieur droit)",
    extraction_revisions: "Indices de révision",
    extraction_pages: "Pages / dimensions",
    extraction_warning_no_text: "PDF sans couche de texte — extraction indisponible (OCR requis dans une prochaine itération).",
    extraction_warning_multipage: "Document multipage — toutes les pages ont été analysées.",
    extraction_warning_unsupported: "Format non supporté pour l'extraction (PDF attendu).",
    extraction_empty: "Aucune information extractible détectée.",
    section_drawing_data: "Données du dessin",
    section_piece_metadata: "Métadonnées de la pièce",
    section_dimension_candidates: "Candidats aux dimensions totales",
    section_raw_advanced: "Mode avancé (sortie brute)",
    field_part_number: "Part number",
    field_designation: "Désignation",
    field_scale: "Échelle",
    field_page_format: "Format de la feuille",
    field_step_ref: "Fichier 3D référencé",
    field_drawn_date: "Date du dessin",
    field_revision: "Révision",
    field_weight: "Poids estimé",
    field_material: "Matériau / alliage",
    field_tolerance: "Norme de tolérances",
    dimension_candidates_disclaimer: "Les 3 plus grandes valeurs après filtrage des ID, normes, angles, rayons et références. La confidence est une heuristique — toujours vérifier sur le dessin.",
    show_more_candidates: "Afficher plus de candidats",
    // ============ Quotation Suggestions panel (pré-remplissage via dessin 2D) ============
    suggest_panel_title: "Pré-remplir le devis à partir du dessin 2D",
    suggest_panel_disclaimer: "applique automatiquement les champs à haute confiance",
    suggest_count_label: "suggestions",
    suggest_auto_section: "Appliqué automatiquement",
    suggest_pending_section: "À confirmer — vérifier les valeurs",
    suggest_info_section: "Avertissements",
    suggest_already_filled_section: "Déjà remplis ({n}) — suggestion ignorée",
    suggest_apply_selected: "Appliquer sélectionnés ({n})",
    suggest_threshold_hint: "Les champs avec confiance ≥ {pct}% sont appliqués automatiquement ; les autres nécessitent confirmation.",
    suggest_auto_applied: "{n} suggestion(s) appliquée(s) automatiquement",
    suggest_applied: "{n} suggestion(s) appliquée(s)",
    suggest_overridden: "Valeur écrasée",
    suggest_override: "appliquer quand même",
    suggest_field_badge: "Suggéré",
    suggest_field_tooltip: "Pré-rempli à partir du dessin 2D. Modifier pour confirmer.",
    suggest_part_reference: "Référence de la pièce",
    suggest_part_designation: "Désignation de la pièce",
    suggest_alloy: "Alliage",
    suggest_piece_weight: "Poids de la pièce",
    suggest_piece_length: "Longueur (L)",
    suggest_piece_width: "Largeur (W)",
    suggest_piece_height: "Hauteur (H)",
    suggest_warn_height_low_conf: "hauteur — à vérifier",
    suggest_warn_weight_no_unit: "poids sans unité — à vérifier",
    suggest_warn_alloy_not_in_config: "alliage absent de la configuration — demander à l'admin de le créer",
    status_history: "Historique des États",
    no_history: "Aucun historique",
    hide_quotation: "Masquer le devis",
    view_quotation_snapshot: "Voir le devis à ce moment",

    pending_action: "En Attente",
    near_deadline: "Proches de l'Échéance",
    recent_activity: "Activité Récente",
    total_rfqs: "Total Devis",
    conversion_rate: "Taux de Conversion",
    pipeline_value: "Valeur du Pipeline",
    blocked_rfqs: "Devis Bloqués",
    avg_pipeline_margin: "Marge Moyenne Pipeline",
    my_pipeline_value: "Mon Pipeline",
    real_close_rate: "Taux de Clôture Réel",
    proposals_to_follow_up: "Propositions à Relancer",
    engineering_short: "Ing",
    finance_short: "Fin",
    administration_short: "Adm",
    rfqs_suffix: "devis",
    no_pending_rfqs: "Aucun devis en attente",
    no_near_deadline: "Aucun devis proche de l'échéance",
    no_recent_activity: "Aucune activité récente",
    action_col: "Action",
    detail_col: "Détail",
    date_col: "Date",
    error_loading_dashboard: "Erreur lors du chargement du tableau de bord",

    justification_required: "Justification obligatoire (min. 20 caractères)",
    comment: "Commentaire",

    notifications: "Notifications",
    mark_all_read: "Tout marquer comme lu",
    no_notifications: "Aucune notification",
    unread_suffix: "non lu(s)",
    delete_notification: "Supprimer la notification",
    clear_all_notifications: "Tout supprimer",

    users: "Utilisateurs",
    roles: "Profils",
    machines: "Machines",
    alloys: "Alliages",
    finishing_rates: "Tarifs Parachèvement",
    global_config: "Configuration Globale",
    calc_mode: "Mode de Calcul",
    legacy_mode: "Legacy (Excel)",
    enhanced_mode: "Enhanced (Amélioré)",

    access_restricted: "Accès restreint",
    admin_only_desc: "Seuls les utilisateurs avec le profil administrateur ont accès à cette page.",
    load_error: "Erreur lors du chargement des données",
    create_error: "Erreur lors de la création",
    save_error: "Erreur lors de l'enregistrement",
    created: "Créé",
    saved: "Enregistré",
    no_results: "Aucun résultat",
    activity_sectors_tab: "Secteurs d'activité",
    activity_sectors_title: "Secteurs d'activité",
    activity_sectors_desc: "Valeurs du menu 'Secteur d'activité' dans la fiche client.",
    new_activity_sector: "Nouveau secteur d'activité",
    contact_functions_tab: "Fonctions de contact",
    contact_functions_title: "Fonctions de contact",
    contact_functions_desc: "Valeurs du menu 'Fonction' dans les contacts de l'équipe client.",
    new_contact_function: "Nouvelle fonction de contact",

    boxes_admin_tab: "Caisses",
    boxes_admin_title: "Catalogue de caisses",
    boxes_admin_desc: "Caisses disponibles dans le card Emballage du devis. Les dimensions et le volume utile servent de base au calcul automatique de « Pièces par boîte » lorsque les dimensions de la pièce sont saisies.",
    pallet_cost_admin_title: "Coût palette",
    pallet_cost_admin_desc: "Valeur unique de l'europalette, appliquée automatiquement à tous les devis. Dans le card Emballage le champ est en lecture seule.",
    pallet_cost_saved: "Coût palette enregistré",
    pallet_cost_invalid: "Indiquez un coût palette valide (≥ 0).",
    pallet_cost_readonly_hint: "Défini dans l'Administration (onglet Caisses). Non modifiable dans le devis.",
    new_box_type: "Nouvelle caisse",
    box_type_name: "Nom",
    box_type_description: "Description",
    box_type_length_mm: "Longueur (mm)",
    box_type_width_mm: "Largeur (mm)",
    box_type_height_mm: "Hauteur (mm)",
    box_type_price_eur: "Prix (€)",
    box_type_volume_l: "Volume (L)",
    box_type_volume_hint: "Litres (1 L = 1 000 cm³). Laisser vide pour calcul automatique à partir des dimensions.",
    box_type_created: "Caisse créée",
    box_type_updated: "Caisse mise à jour",
    box_type_deactivated: "Caisse désactivée",
    box_type_activated: "Caisse activée",

    suppliers_admin_tab: "Fournisseurs",
    suppliers_admin_title: "Catalogue de fournisseurs",
    suppliers_admin_desc: "Fournisseurs disponibles dans le sélecteur « Fournisseur » de la carte Sous-traitance. Chaque fournisseur est associé à un type (usinage, traitement de surface, peinture, autre) et la carte filtre automatiquement les options selon le type de la ligne.",
    new_supplier: "Nouveau fournisseur",
    supplier_name: "Nom",
    supplier_type: "Type de fournisseur",
    supplier_type_machining: "Usinage",
    supplier_type_surface_treatment: "Traitement de surface",
    supplier_type_painting: "Peinture",
    supplier_type_other: "Autre",
    supplier_notes: "Notes",
    supplier_created: "Fournisseur créé",
    supplier_updated: "Fournisseur mis à jour",
    supplier_deactivated: "Fournisseur désactivé",
    supplier_activated: "Fournisseur activé",
    supplier_select_placeholder: "Sélectionner un fournisseur…",
    supplier_no_options: "Aucun fournisseur de ce type (configurez dans Administration → Fournisseurs).",

    slot_part_image: "Image de la pièce",
    slot_hint_part_image: "Photo/rendu (.png, .jpg). Intégrée au PDF de l'offre commerciale.",

    payment_terms_section: "Payment Terms (PDF de l'offre)",
    internal_code: "Code interne",
    address_field: "Adresse",
    activity_sector: "Secteur d'activité",
    purchase_volume_eur: "Volume d'achats (€)",
    team_contacts: "Contacts de l'équipe du client",
    function_field: "Fonction",
    phone_field: "Téléphone",
    financial_health: "Santé financière",
    liquidity_days: "Liquidité (délai moyen de paiement aux fournisseurs, jours)",
    liabilities_total: "Passif total (€)",
    equity: "Capitaux propres (€)",
    solvency_ratio: "Solvabilité (passif / capitaux propres)",
    ebitda_eur: "Rentabilité — EBITDA (€)",
    risk_rating: "Évaluation du risque",
    risk_1: "aucun risque",
    risk_2: "faible risque",
    risk_3: "modéré",
    risk_4: "risqué",
    risk_5: "très risqué",
    financial_reports: "Rapports financiers",
    upload_report: "Joindre un rapport",
    uploading: "Chargement…",
    save_financial: "Enregistrer les indicateurs",
    financial_saved: "Indicateurs financiers enregistrés",
    financial_save_error: "Erreur lors de l'enregistrement des indicateurs",
    financial_complete: "Complète",
    financial_pending: "En attente",
    read_only: "Lecture seule",
    close: "Fermer",
    open: "Ouvrir",
    download_error: "Erreur de téléchargement",
    delete_error: "Erreur lors de la suppression",
    payment_terms_help: "Lorsqu'ils sont vides, les valeurs par défaut de la configuration globale sont utilisées.",
    payment_terms_parts: "Payment terms — pièces",
    payment_terms_tooling: "Payment terms — moules/outillage",

    offer_payment_terms_section: "Payment terms",
    offer_payment_terms_help: "Apparaissent dans la section Payment Terms du PDF. Laisser vide pour hériter des payment terms du client et, à défaut, des valeurs par défaut globales.",

    offer_planning_section: "Planning (semaines)",
    offer_planning_help: "Apparaissent dans la section Planning du PDF. Laisser vide pour utiliser les valeurs par défaut globales (12 / 2 / 8 / 6).",
    offer_planning_first_article_weeks: "Premier échantillon (semaines)",
    offer_planning_first_series_weeks: "Première série après validation (semaines)",
    offer_planning_supplying_weeks: "Fourniture (semaines)",
    offer_planning_supplying_forecast_weeks: "Fourniture avec forecast (semaines)",

    finishing_admin_title: "Opérations de parachèvement",
    finishing_admin_desc: "Définissez les opérations disponibles dans le panneau « VA Parachèvement » du devis et le tarif horaire correspondant. La cadence (pièces/h) et le rebut (%) sont saisis par le commercial pour chaque devis.",
    new_finishing_rate: "Nouvelle opération",
    no_finishing_rates: "Aucune opération configurée. Créez la première pour qu'elle apparaisse dans les devis.",
    finishing_name_required: "Nom de l'opération obligatoire",
    finishing_rate_created: "Opération créée",
    finishing_rate_updated: "Opération mise à jour",
    finishing_rate_deactivated: "Opération désactivée",
    finishing_rate_activated: "Opération activée",

    new_machine: "Nouvelle Machine",
    tonnage: "Tonnage",
    hourly_rate: "Tarif (€/h)",
    max_area: "Surface max (cm²)",
    max_area_header: "Surface Max (cm²)",
    machine_created: "Machine créée",
    machine_updated: "Machine mise à jour",
    machine_deactivated: "Machine désactivée",
    machine_activated: "Machine activée",

    new_alloy: "Nouvel Alliage",
    alloy_created: "Alliage créé",
    alloy_updated: "Alliage mis à jour",
    alloy_deactivated: "Alliage désactivé",
    alloy_activated: "Alliage activé",
    paf_hint: "PAF (0-1)",

    new_user: "Nouvel Utilisateur",
    administrator: "Administrateur",
    create_user: "Créer Utilisateur",
    user_created: "Utilisateur créé",
    user_updated: "Utilisateur mis à jour",
    user_deactivated: "Utilisateur désactivé",
    user_reactivated: "Utilisateur réactivé",
    deactivate_user_title: "Désactiver l'utilisateur",
    deactivate_user_desc_prefix: "L'utilisateur",
    deactivate_user_desc_suffix: "ne pourra plus accéder à l'application. Vous pourrez le réactiver plus tard.",
    no_profile: "Sans profil",
    portuguese_full: "Português",
    french_full: "Français",
    english_full: "English",

    new_role: "Nouveau Profil",
    permissions: "Permissions",
    create_role: "Créer Profil",
    role_created: "Profil créé",
    role_updated: "Profil mis à jour",
    system_role_locked: "Système — non modifiable",
    permission_help_aria: "Ce que cette permission autorise",
    perm_help_rfq_view_own: "Voir uniquement les RFQ créées ou qui vous sont attribuées.",
    perm_help_rfq_view_all: "Voir toutes les RFQ de la plateforme.",
    perm_help_rfq_create: "Créer de nouvelles RFQ.",
    perm_help_rfq_edit_own: "Modifier vos propres RFQ (créées ou attribuées).",
    perm_help_rfq_edit_all: "Modifier n'importe quelle RFQ, quel que soit le propriétaire.",
    perm_help_rfq_submit: "Soumettre la RFQ dans le flux (tri commercial, clôture d'analyse ou décision).",
    perm_help_rfq_approve: "Approuver la RFQ (décision Administration / G5).",
    perm_help_rfq_reject: "Rejeter la RFQ (rejet stratégique G1 ou décision G5).",
    perm_help_rfq_view_margin: "Voir le prix de vente, les marges et le panneau Rent_Bud.",
    perm_help_rfq_assign_engineer: "Attribuer l'ingénieur responsable après la soumission commerciale.",
    perm_help_doc_attach: "Joindre des documents à la RFQ.",
    perm_help_doc_download: "Télécharger les documents de la RFQ.",
    perm_help_offer_generate: "Générer le PDF de l'offre commerciale.",
    perm_help_offer_edit: "Modifier les champs de l'offre lors de la génération du PDF.",
    perm_help_offer_download: "Télécharger le PDF de l'offre commerciale.",
    perm_help_client_view: "Voir la fiche et la liste des clients.",
    perm_help_client_create: "Créer de nouveaux clients.",
    perm_help_client_edit: "Modifier la fiche générale du client.",
    perm_help_client_financial_edit: "Modifier uniquement les indicateurs financiers du client.",
    perm_help_history_view: "Voir l'historique et les notes de la RFQ.",
    perm_help_history_add: "Ajouter des notes à l'historique de la RFQ.",

    new_client: "Nouveau Client",
    strategic_type: "Type Stratégique",
    growth_potential: "Potentiel de Croissance",
    strategic: "Stratégique",
    standard: "Standard",
    transactional: "Transactionnel",
    high: "Élevé",
    medium: "Moyen",
    low: "Bas",
    potential_label: "Potentiel",
    name_required_toast: "Nom obligatoire",
    no_clients: "Aucun client",
    client_created: "Client créé",
    client_create_error: "Erreur lors de la création du client",
    client_updated: "Client mis à jour",
    client_update_error: "Erreur lors de la mise à jour du client",
    edit_client: "Modifier le client",
    email_primary: "Email principal",
    email_primary_help: "Adresse utilisée par défaut lorsque le commercial demande des informations au client.",
    dept_emails: "Emails par département",
    dept_emails_help: "Chaque email apparaît comme option dans la boîte de sélection du bouton « Demander information supplémentaire ». Laissez vide si le département ne s'applique pas.",
    email_logistica: "Email logistique",
    email_qualidade: "Email qualité",
    email_comercial: "Email commercial",
    email_projeto: "Email projet",
    email_contacts: "Contacts supplémentaires",
    add_contact: "Ajouter un contact",
    no_extra_contacts: "Aucun contact supplémentaire.",
    role_field: "Fonction",
    email_invalid_toast: "Adresse email invalide",

    fill_required_fields: "Veuillez remplir les champs obligatoires",
    invalid_email: "Email invalide",
    username_min_length: "Utilisateur : minimum 3 caractères",
    name_min_length: "Nom : minimum 2 caractères",
    client_name_required: "Nom du client obligatoire",
    rfq_created: "Devis créé avec succès",
    rfq_create_error: "Erreur lors de la création du devis",
    add_client_aria: "Ajouter un client",
    cancel_new_client_aria: "Annuler nouveau client",
    part_ref_placeholder: "Référence pièce client",
    part_designation_placeholder: "Désignation de la pièce",
    context_placeholder: "Observations, contexte de la demande...",
    commercial_context: "Contexte Commercial",
    create_client: "Créer Client",
    rfq_data: "Données du devis",
    creating_wait: "Création...",

    no_rfqs_found: "Aucun devis trouvé",
    reference: "Référence",

    login_success: "Connexion réussie",
    login_error: "Erreur d'authentification",
    login_subtitle: "Gestion des Devis — Fonderie Injectée",
    login_brand_kicker: "Aluthea Group",
    login_brand_lead: "Des devis techniques à la précision de la fonderie injectée d'aluminium.",
    login_brand_point_1: "Workflow commercial, ingénierie et décision au même endroit",
    login_brand_point_2: "Moteur de calcul HPDC et validation de prix",
    login_brand_point_3: "Offre PDF, audit et historique des versions",
    entering: "Connexion en cours...",
    default_admin: "Admin par défaut",
    email_or_username: "Email ou identifiant",
    email_or_username_placeholder: "exemple@entreprise.fr",
    forgot_password: "Mot de passe oublié",
    forgot_password_title: "Récupération du mot de passe",
    forgot_password_subtitle: "Indiquez l'adresse email de votre compte pour recevoir les instructions de récupération.",
    forgot_password_sent: "Si un compte est associé à cette adresse, un email contenant les instructions vient d'être envoyé. Pensez à vérifier le dossier spam.",
    send_reset_link: "Envoyer le lien de récupération",
    sending: "Envoi en cours...",
    back_to_login: "Retour à la connexion",
    reset_password_title: "Définir un nouveau mot de passe",
    reset_password_subtitle: "Choisissez un nouveau mot de passe pour votre compte.",
    reset_password_action: "Modifier le mot de passe",
    reset_password_success: "Mot de passe modifié avec succès. Vous pouvez maintenant vous connecter.",
    reset_password_error: "Impossible de modifier le mot de passe. Veuillez demander un nouveau lien.",
    reset_password_invalid_token: "Lien invalide ou manquant. Veuillez demander un nouveau lien.",
    request_new_link: "Demander un nouveau lien",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    password_min_length: "Minimum 8 caractères.",
    passwords_do_not_match: "Les mots de passe ne correspondent pas.",
    saving: "Enregistrement...",
    generic_error: "Une erreur est survenue. Veuillez réessayer.",

    sidebar_open_menu: "Ouvrir le menu latéral",
    sidebar_close_menu: "Fermer le menu latéral",
    autosave_pending: "Modifications en attente…",
    autosave_saving: "Enregistrement…",
    autosave_saved: "Enregistré",
    autosave_error: "Erreur d'enregistrement",
    main_nav_label: "Navigation principale",
    toggle_to_light: "Activer le mode clair",
    toggle_to_dark: "Activer le mode sombre",
    light_mode: "Mode clair",
    dark_mode: "Mode sombre",
    skip_to_content: "Aller au contenu",
    language_aria: "Langue",

    // ============ Calc v2 ============
    components_section: "Composants / Inserts",
    no_components_yet: "Aucune ligne. Cliquez sur + pour ajouter.",
    add_line: "Ajouter une ligne",
    add_candidate: "Ajouter un candidat",
    no_candidates_yet: "Aucun candidat.",
    component_reference: "Référence",
    component_purchase: "Achat (€)",
    component_transport: "Transport (€)",
    component_qty: "Qté/pièce",
    component_scrap: "Rebut détecté (%)",
    component_shrink: "Écart inventaire (%)",
    component_supplier_margin: "Marge fournisseur (%)",
    subcontract_machining: "Usinage",
    subcontract_surface_treatment: "Traitement Surface",
    subcontract_painting: "Peinture",
    subcontract_other: "Autres",
    selected: "Retenu",
    supplier: "Fournisseur",
    purchase: "Achat (€)",
    transport_pallet: "Transport/palette (€)",
    pcs_pallet: "Pcs/palette",
    scrap_percent: "Rebut (%)",
    pieces_per_box: "Pièces par boîte",
    pieces_per_box_auto_hint: "Calculé automatiquement lorsque la boîte est sélectionnée et que les dimensions de la pièce (Longueur/Largeur/Hauteur) sont renseignées.",
    boxes_per_pallet: "Boîtes par palette",
    boxes_per_pallet_auto_hint: "Europalette 1200×800×144 mm. Maximum de caisses jusqu'au poids max. de pièces (1500 kg) ou jusqu'à la hauteur utile du TIR (2,70 m, palette déduite). C'est la première limite atteinte qui l'emporte.",
    pallet_cost: "Coût palette (€)",
    max_pallet_weight: "Poids max palette (kg)",
    tooling_line_label: "Ligne",
    tooling_cost: "Coût (€)",
    tooling_margin: "Marge (%)",
    tooling_sale: "Vente (€)",
    tooling_guarantee_shots: "Garantie (nb shots)",
    tooling_separate_note: "L'outillage est facturé séparément et n'entre pas dans le prix pièce.",
    tooling_label_mould_foundry: "Moule fonderie",
    tooling_label_mould_cutting: "Moule à couper",
    tooling_label_gabarit_machining: "Gabarit usinage",
    tooling_label_gabarit_control: "Gabarit contrôle",
    tooling_add_line: "Ajouter une ligne",
    tooling_remove_line: "Supprimer la ligne",
    tooling_custom_label_placeholder: "Désignation",
    studies_section: "Études / Développements",
    studies_separate_note: "Les études et développements sont uniquement informatifs — ils n'entrent pas dans le prix pièce ni dans le prix de l'outillage.",
    studies_no_lines: "Aucune ligne. Ajoutez selon les besoins.",
    studies_add_line: "Ajouter une ligne",
    studies_remove_line: "Supprimer la ligne",
    studies_label_placeholder: "Désignation de l'étude",
    shrink_section: "Écart Inventaire",
    inventory_shrink_label: "Écart inventaire (%)",
    inventory_shrink_help: "Pourcentage de perte d'inventaire appliqué à la cascade de rebut. Défaut : 5%.",
    pricing_buckets: "Prix de vente (par bucket)",
    bucket_va_internal: "VA Fonderie + Finition",
    bucket_extra_works: "Travaux supplémentaires",
    bucket_packaging: "Emballage",
    bucket_transport: "Transport",
    bucket_vm: "VM",
    bucket_va_pack_trans: "VA + Emb. + Transp.",
    bucket_components: "Composants",
    bucket_subcontract: "Sous-traitance",
    global_margin: "Marge globale",
    margin_eur: "Marge (€)",
    tooling_total_separate: "Outillage total (facturation séparée)",
    warnings: "Alertes",
    warn_pallet_weight_exceeded: "Le poids de la palette dépasse le maximum configuré.",

    // ===== Structure de coûts / validation de prix =====
    pnl_tab_label: "Structure de coûts",
    pnl_admin_title: "Structure de coûts",
    pnl_admin_subtitle: "Paramètres macro-usine pour la validation de prix. Chaque enregistrement crée une nouvelle version immuable.",
    pnl_year: "Année",
    pnl_active: "Actif",
    pnl_load_error: "Erreur lors du chargement de la configuration PnL",
    pnl_save_error: "Erreur lors de l'enregistrement de la configuration PnL",
    pnl_saved: "Configuration PnL enregistrée",
    pnl_reset_to_defaults: "Réinitialiser aux defaults 26-27",
    pnl_reset_to_defaults_done: "Defaults 26-27 chargés (n'oubliez pas d'enregistrer)",
    pnl_block_fixed_costs: "2.1 — Charges fixes annuelles (k€/an)",
    pnl_fixed_charges: "Charges fixes",
    pnl_indirect_labour: "MOI (main-d'œuvre indirecte)",
    pnl_management_fees: "Management fees",
    pnl_mod_foundry: "MOD Fonderie",
    pnl_mod_finishing: "MOD Finition",
    pnl_block_splits: "2.2 — Splits MOI / Charges fixes",
    pnl_moi_split_foundry: "Split MOI fonderie (0–1)",
    pnl_cf_split_foundry: "Split CF fonderie (0–1)",
    pnl_block_capacity: "2.3 — Capacité (h/an)",
    pnl_press_hours_400: "Heures/an presse 400T",
    pnl_press_hours_600: "Heures/an presse 600T",
    pnl_press_hours_900: "Heures/an presse 900T",
    pnl_press_hours_1100: "Heures/an presse 1100T",
    pnl_labour_hours_finishing: "Heures/an MO finition",
    pnl_working_days: "Jours ouvrés/an",
    pnl_absenteeism: "Taux d'absentéisme",
    pnl_block_rates: "2.4 — Tarifs €/h",
    pnl_rate_press_400: "Tarif presse 400T",
    pnl_rate_press_600: "Tarif presse 600T",
    pnl_rate_press_900: "Tarif presse 900T",
    pnl_rate_press_1100: "Tarif presse 1100T",
    pnl_rate_finishing: "Tarif finition",
    pnl_block_variable_margins: "2.5 — Variable + marges",
    pnl_variable_costs_pct: "% charges variables sur VA",
    pnl_variable_costs_hint: "Default 13.86 % — appliqué sur VA, jamais sur VM/GAS/ST",
    pnl_energy_default: "Énergie €/kg (par défaut)",
    pnl_marge_va_target: "Marge VA cible",
    pnl_marge_va_hint: "20 % par défaut — appliquée UNIQUEMENT sur PR_INJ + PR_Para",
    pnl_ebitda_target: "EBITDA cible (% chiffre d'affaires)",
    pnl_alloys_table: "Tableau des alliages (€/kg)",
    pnl_add_alloy: "Ajouter un alliage",
    pnl_alloy_code: "Code (ex : 47100)",
    pnl_purchase_eur_per_kg: "HA €/kg (achat)",
    pnl_selling_eur_per_kg: "PV €/kg (vente)",
    pnl_energy_table: "Énergie par presse (€/kg)",
    pnl_energy_400: "400T €/kg",
    pnl_energy_600: "600T €/kg",
    pnl_energy_900: "900T €/kg",
    pnl_energy_1100: "1100T €/kg",

    // PnLAuditPanel
    pnl_audit_title: "Audit PnL cross-check",
    pnl_audit_unavailable: "Audit indisponible",
    pnl_audit_unavailable_hint: "Enregistrez le devis pour lancer le cross-check PnL.",
    pnl_verdict_ok: "OK — prix aligné devis",
    pnl_verdict_subprecificado: "Sous-évalué",
    pnl_verdict_sobreprecificado: "Sur-évalué",
    pnl_verdict_critico: "Critique — sous le minimum EBITDA",
    pnl_verdict_error: "Erreur d'audit",
    pnl_reason_reason_below_min_ebitda: "Δ vs minimum EBITDA < -5%",
    pnl_reason_reason_below_theoretical: "Δ vs calculé < -5%",
    pnl_reason_reason_above_theoretical: "Δ vs calculé > +10%",
    pnl_reason_reason_in_range: "Δ vs calculé dans [-5%, +10%]",
    pnl_pv_proposed: "PV proposé",
    pnl_pv_proposed_hint: "Calculé par le moteur existant",
    pnl_pv_theoretical_schreder: "PV théorique",
    pnl_pv_min_ebitda: "PV min EBITDA cible",
    pnl_delta_vs_schreder: "Δ vs calculé",
    pnl_delta_vs_min_ebitda: "Δ vs minimum",
    pnl_breakdown_title: "Décomposition (€/pièce)",
    pnl_vm: "VM",
    pnl_vm_hint: "matière — pass-through, sans marge",
    pnl_pr_inj: "PR_INJ",
    pnl_pr_inj_hint: "presse",
    pnl_pr_para: "PR_Para",
    pnl_pr_para_hint: "finition",
    pnl_pr_gas: "PR_GAS",
    pnl_pr_gas_hint: "énergie",
    pnl_pr_st: "PR_ST",
    pnl_pr_st_hint: "sous-traitance — pass-through",
    pnl_pr_total: "Pr_total",
    pnl_ebitda_implied: "EBITDA implicite",
    pnl_ebitda_implied_hint: "(PV − Pr_total − charges variables) / PV",
    pnl_press_hours: "Heures-presse",
    pnl_press_capacity_used: "de la capacité",
    pnl_finishing_hours: "Heures finition/an",
    pnl_finishing_hours_hint: "absentéisme inclus",
    pnl_diag_alloy: "Alliage",
    pnl_diag_press: "Presse",
    pnl_energy: "Énergie",
    pnl_kg: "kg",
    pnl_warnings: "Alertes",
    pnl_warn_warn_capacity: "La pièce dépasse la capacité annuelle de la presse",
    pnl_warn_warn_loss: "EBITDA implicite négatif — pièce en perte",
    pnl_warn_warn_outlier: "Δ hors plage ±25 % — vérifier les inputs",
    pnl_warn_warn_alloy_unknown: "Alliage non reconnu dans les données PnL",
    pnl_warn_warn_alloy_not_priced: "Alliage sans tarifs configurés — repli sur le 1er",
    pnl_warn_warn_press_unknown: "Tonnage machine indéterminé — bucket 600T utilisé",
    pnl_warn_warn_volume_missing: "Volume annuel manquant",
    pnl_warn_warn_cycle_missing: "Temps de cycle manquant",
    pnl_warn_warn_weight_missing: "Poids de la pièce manquant",
    pnl_warn_warn_scrap_foundry_out_of_range: "Scrap fonderie hors [0, 30 %]",
    pnl_warn_warn_scrap_finishing_out_of_range: "Scrap finition hors [0, 30 %]",
    pnl_warn_warn_audit_exception: "Exception interne dans l'audit",
    pnl_warn_warn_no_pnl_config: "Pas de FactoryPnLConfig active — audit indisponible",
    pnl_warn_warn_no_cost_structure: "Pas de structure de coûts active",
    pnl_warn_warn_energy_fallback: "Énergie €/kg : valeur par défaut (machine sans valeur)",

    price_validation_title: "Validation de prix",
    price_validation_subtitle: "Modèle absorption mono-produit (Rent_Bud)",
    pnl_legacy_snapshot_title: "Ancien résultat",
    pnl_legacy_snapshot_hint: "Calculé avec l'ancien modèle. Enregistrez à nouveau le devis pour mettre à jour.",
    traffic_VERDE: "Vert",
    traffic_AMARELO: "Jaune",
    traffic_VERMELHO: "Rouge",
    kpi_marge_vm_va_pct: "Marge VM+VA (%)",
    price_validation_decomposition: "Décomposition",
    resultado_va: "Résultat VA (€)",
    resultado_vm: "Résultat VM (€)",
    marge_total_eur: "Marge totale (€)",
    price_validation_support: "Données de support",
    qtd_pieces_year: "Quantité (pièces/an)",
    ca_vendu: "CA vendu (€)",
    va_vendu: "VA vendu (€)",
    tonnes: "Tonnes",
    pv_aux_title: "Calculs auxiliaires",
    pv_aux_group_quantity: "Quantité",
    pv_aux_group_margin: "Marge et feu",
    pv_aux_cadence: "Cadence injection (pièces/h)",
    pv_aux_cadence_f: "Injections/h × TRS × Empreintes",
    pv_aux_hours_year: "Heures d'injection / an",
    pv_aux_hours_year_f:
      "Jours ouvrés × Postes/jour × Heures/poste × Nb machines × Utilisation × (1 − Rebut macro)",
    pv_aux_qtd_f: "Heures d'injection/an × Cadence",
    pv_aux_ca_f: "Quantité × Prix de vente",
    pv_aux_va_vendu_f: "(Prix de vente − VM/pièce) × Quantité",
    pv_aux_tonnes_f: "Quantité × Poids pièce ÷ 1000",
    pv_aux_energy: "Énergie (€/an)",
    pv_aux_energy_f: "Quantité × Poids pièce × Énergie €/kg de la machine",
    pv_aux_variable: "Charges variables sur VA (€/an)",
    pv_aux_variable_f: "VA vendu × % variables",
    pv_aux_fixed: "Charges fixes (€/an)",
    pv_aux_fixed_f: "Somme des postes fixes annuels",
    pv_aux_finishing_seconds: "Temps de finition (s/pièce)",
    pv_aux_finishing_seconds_f: "Σ 3600 ÷ cadence de chaque opération active (Polissage × 2)",
    pv_aux_effectif: "Effectif finition (personnes)",
    pv_aux_effectif_f:
      "Quantité × (Secondes/pièce ÷ 3600) ÷ (Jours ouvrés × Heures/poste finition)",
    pv_aux_mod: "MOD finition (€/an)",
    pv_aux_mod_f: "Effectif × Coût annuel par personne",
    pv_aux_transport: "Transport (€/an)",
    pv_aux_transport_f: "Quantité × Transport/pièce",
    pv_aux_resultado_va_f:
      "VA vendu − (Énergie + Variables + Fixes + MOD + Transport)",
    pv_aux_vm_sold: "VM vendue (€/an)",
    pv_aux_vm_sold_f: "Quantité × VM/pièce",
    pv_aux_vm_bought: "VM achetée (€/an)",
    pv_aux_vm_bought_f:
      "Tonnes × (1 + Perte au feu de revente) × (Base MB + Prime d'achat)",
    pv_aux_vm_paf_resold: "VM PAF revendu (€/an)",
    pv_aux_vm_paf_resold_f:
      "Perte au feu de revente × Tonnes × (Valorisation laitier × Base MB × % laitier + Valorisation copeaux × Base MB × % copeaux)",
    pv_aux_resultado_vm_f: "VM vendue − VM achetée + VM PAF revendu",
    pv_aux_marge_f: "Résultat VA + Résultat VM",
    pv_aux_marge_pct_f: "Marge totale ÷ CA vendu",
    pv_aux_thresholds: "Seuils du feu",

    price_validation_simulation: "Simulation",
    sim_sale_price: "Prix de vente (€/pièce)",
    sim_shots_per_hour: "Cadence injection (pièces/h)",
    recalculate: "Recalculer",
    cs_block_capacity: "1. Capacité et calendrier",
    cs_block_fixed: "2. Charges fixes structurelles (€/an)",
    cs_block_mo: "3. Main-d'œuvre finition",
    cs_block_variable: "4. % charges variables sur VA",
    cs_block_fire_loss: "5. Perte au feu",
    cs_block_thresholds: "6. Feux (seuils marge %)",
    cs_save_new_version: "Enregistrer nouvelle version",
    cs_add_fixed_line: "Ajouter une ligne",
    cs_add_var_line: "Ajouter un %",
    machine_energy_eur_per_kg: "Énergie €/kg coulé",
    finishing_parallel_ops: "Opérateurs en parallèle",
    cs_name_version: "Nom de version",
    cs_name_required: "Indiquez le nom de la version avant d'enregistrer.",
    cycle_times_tab: "Temps de cycle",
    ct_import_title: "Importer l'historique (Excel)",
    ct_import_hint:
      "Fichier .xlsx avec colonnes : poids pièce (kg), poids pièce avec grappe (kg), machine, temps de cycle (s/pièce) et n° de moule (optionnel, indicatif). La première ligne doit contenir les en-têtes.",
    ct_import_btn: "Importer Excel",
    ct_importing: "Import en cours…",
    ct_replace_existing: "Remplacer l'historique existant",
    ct_imported: "Lignes importées",
    ct_import_skipped: "Lignes ignorées",
    ct_import_error: "Erreur lors de l'import du fichier.",
    ct_new_record: "Nouvelle ligne d'historique",
    ct_part_weight: "Poids pièce (kg)",
    ct_part_weight_runner: "Poids avec grappe (kg)",
    ct_cycle_time: "Temps de cycle (s/pièce)",
    ct_mold_number: "N° moule",
    ct_created: "Ligne ajoutée.",
    ct_updated: "Ligne mise à jour.",
    ct_deleted: "Ligne supprimée.",
    ct_fields_required: "Renseignez poids pièce, poids avec grappe et temps de cycle (valeurs > 0).",
    ct_empty: "Aucun enregistrement. Importez un Excel ou ajoutez des lignes.",
    ct_suggestion_label: "Suggestion (historique)",
    ct_suggestion_records: "enregistrements",
    ct_suggestion_all_machines: "toutes machines",
    ct_apply: "Appliquer",
    cs_working_days: "Jours ouvrés / an",
    cs_shifts: "Équipes / jour",
    cs_shifts_injection: "Équipes / jour — Injection",
    cs_shifts_finishing: "Équipes / jour — Finition",
    cs_hours_inj: "Heures / équipe — injection",
    cs_hours_fin: "Heures / équipe — finition",
    cs_machine_count: "Nb presses injection",
    cs_utilization: "Taux d'utilisation capacité (0–1)",
    cs_macro_scrap: "Rebut macro usine (0–1)",
    cs_finishing_fte_cost: "Coût MO finition (€ / ETP / an)",
    cs_margin_green: "Seuil vert — marge VM+VA (0–1)",
    cs_margin_warn: "Seuil ambre — marge VM+VA (0–1)",
    cs_fire_loss_resale_pct: "Perte au feu de revente (0–1)",
    cs_slag_valuation_rate: "Valorisation du laitier (0–1)",
    cs_slag_share_rate: "Pourcentage de laitier (0–1)",
    cs_slag_share_rate_hint: "Laitier vendu sur le total des déchets valorisés.",
    cs_chips_valuation_rate: "Valorisation des copeaux (0–1)",
    cs_chips_share_rate: "Pourcentage de copeaux (0–1)",
    cs_chips_share_rate_hint: "Copeaux vendus sur le total des déchets valorisés.",
    cs_fixed_label: "Libellé",
    cs_fixed_amount: "Montant annuel (€)",
    cs_var_label: "Libellé",
    cs_var_pct: "% sur VA vendu",
    cs_versions_title: "Historique des versions",
    cs_activate: "Activer",
    cs_load_error: "Erreur de chargement structure de coûts",
    cs_save_error: "Erreur d'enregistrement de version",
    cs_saved: "Nouvelle version enregistrée et activée",
    cs_activate_done: "Version activée",

    // ===== Tableau de bord (révision pro multi-profil) =====
    greeting_morning: "Bonjour",
    greeting_afternoon: "Bon après-midi",
    greeting_evening: "Bonsoir",
    period_last_7d: "7 jours",
    period_last_30d: "30 jours",
    period_last_90d: "90 jours",
    period_ytd: "YTD",
    period_last_12m: "12 mois",
    period_custom: "Personnalisé",
    period_from: "Du",
    period_to: "Au",
    period_apply: "Appliquer",
    period_invalid_range: "Intervalle invalide",
    vs_previous_period: "vs période précédente",
    dash_kpi_total_rfqs: "RFQs sur la période",
    dash_kpi_conversion: "Taux de conversion",
    dash_kpi_won_revenue: "CA annuel gagné",
    dash_kpi_pipeline_value: "Pipeline actif",
    dash_kpi_blocked: "RFQs bloqués",
    dash_kpi_my_active_rfqs: "Mes RFQs actifs",
    dash_kpi_my_pipeline_value: "Mon pipeline",
    dash_kpi_my_close_rate: "Mon taux de closing",
    dash_kpi_my_follow_up: "Relances urgentes",
    dash_kpi_eng_in_analysis: "RFQs en analyse",
    dash_kpi_eng_overdue: "Hors SLA",
    dash_kpi_eng_avg_time: "Temps moyen Ing.",
    dash_kpi_eng_rework: "Reprises",
    dash_kpi_avg_pipeline_margin: "Marge moy. pipeline",
    dash_kpi_avg_won_margin: "Marge moy. (gagnés)",
    dash_kpi_vm_share: "Coût VM (% PV)",
    dash_kpi_active_with_transport: "Actifs avec transport",
    dash_kpi_annual_weight: "Poids annuel estimé",
    dash_kpi_distinct_box_types: "Types de caisse",
    dash_kpi_active_suppliers: "Fournisseurs actifs",
    chart_loss_reasons: "Motifs de perte",
    chart_funnel_timeseries: "Entonnoir dans le temps",
    chart_pipeline_by_status: "Pipeline par état",
    chart_pnl_by_commercial: "PnL audit par Commercial",
    chart_my_status: "Mes RFQs par état",
    chart_my_funnel_timeseries: "Mon entonnoir dans le temps",
    chart_my_loss_reasons: "Mes motifs de perte",
    chart_engineering_flow: "Flux Ingénierie",
    chart_eng_distribution: "Répartition par état",
    chart_margin_timeseries: "Marge dans le temps",
    chart_cost_composition: "Composition moyenne du coût",
    chart_margin_by_client_type: "Marge par type de client",
    chart_incoterm_mix: "Mix d'incoterms",
    chart_box_type_mix: "Types de caisse",
    chart_subcontract_mix: "Sous-traitance par catégorie",
    table_top_clients: "Top clients (CA gagné)",
    table_awaiting_direction: "En attente de la Direction (G5)",
    table_my_followup: "Mes relances urgentes",
    table_my_deadlines: "Mes échéances proches",
    table_eng_queue: "Ma file par urgence",
    table_underpriced: "RFQs sous-tarifés actifs",
    table_logistics_pending: "RFQs avec transport/emballage à compléter",
    series_created: "Créés",
    series_won: "Gagnés",
    series_lost: "Perdus",
    series_entered: "Entrés",
    series_left: "Sortis",
    series_margin: "Marge (%)",
    total: "Total",
    lost_total: "Perdus",
    cost_total: "Coût moyen",
    rfq_ref: "Réf. RFQ",
    last_update: "Dernière maj",
    days_idle: "Jours sans activité",
    days_remaining: "Jours",
    missing_fields: "À compléter",
    won_revenue_short: "CA gagné",
    won_count_short: "Gagnés",
    conversion_short: "Conversion",
    client: "Client",
    pnl_verdict: "PnL audit",
    ebitda_implied_pct_short: "EBITDA",
    pnl_verdict_ok: "OK",
    pnl_verdict_subprecificado: "Sous-tarifé",
    pnl_verdict_sobreprecificado: "Sur-tarifé",
    pnl_verdict_critico: "Critique",
    pnl_verdict_unknown: "—",
    client_type_strategic: "Stratégique",
    client_type_standard: "Standard",
    client_type_transactional: "Transactionnel",
    cost_vm: "VM (matière)",
    cost_va_foundry: "VA Fonderie",
    cost_va_finishing: "VA Finition",
    cost_va_extra_works: "Travaux extras",
    cost_components: "Composants",
    cost_subcontract: "Sous-traitance",
    subcontract_machining: "Usinage",
    subcontract_surface_treatment: "Traitement surface",
    subcontract_painting: "Peinture",
    subcontract_other: "Autre",
    incoterm_exwork: "Ex Works",
    incoterm_exworks: "Ex Works",
    incoterm_ex_works: "Ex Works",
    incoterm_ddp: "DDP",
    incoterm_dap: "DAP",
    incoterm_fca: "FCA",
    incoterm_fob: "FOB",
    incoterm_cif: "CIF",
    "incoterm_—": "Sans incoterm",
    no_data: "Pas de données sur la période",
    no_followup: "Pas de relances urgentes",
    no_queue: "File vide",
    no_underpriced: "Pas de RFQs sous-tarifés actifs",
    no_logistics_pending: "Tout est complet",
    missing_incoterm: "Incoterm",
    missing_box_type: "Caisse",
    missing_pieces_per_box: "Pcs/caisse",
    table_pending_action: "Actions en attente (de moi)",
    table_pending_action_eng: "Actions en attente (RFQs en analyse)",
    no_pending_action: "Rien en attente",
    days_in_state: "Jours dans l'état",
    kpi_desc_won_lost: "{won} gagnées · {lost} perdues",
    kpi_desc_n_rfqs: "{count} RFQs",
    kpi_desc_blocked_threshold: "> 7 jours sans activité",
    kpi_desc_followup: ">{days}j · {value} €",
    kpi_desc_eng_avg_time: "jours entre Ing→Commercial",
    kpi_desc_eng_rework: "RFQs avec plus d'une version",
    kpi_desc_vm_share: "% du PV en matière première",
    kpi_desc_annual_weight: "kg/an (estimé)",
    kpi_desc_distinct_box_types: "types différents en utilisation",
    kpi_help_total_rfqs: "Nombre de RFQs créées (créées dans la période sélectionnée).",
    kpi_help_conversion: "Gagnées / (Gagnées + Perdues) pour les RFQs dont la décision finale est tombée dans la période. N'inclut pas le pipeline ni les négociations en cours.",
    kpi_help_won_revenue: "Σ (volume annuel × prix de vente) des RFQs gagnées dans la période. C'est le CA annualisé sécurisé.",
    kpi_help_pipeline_value: "Σ (volume annuel × prix de vente) des RFQs encore ouvertes (hors Gagnées/Perdues). Montant en jeu en ce moment.",
    kpi_help_blocked: "RFQs dans des états intermédiaires (Ingénierie, Marges, Finance, Direction) bloquées dans le même état depuis plus de 7 jours sans activité. Attention opérationnelle.",
    kpi_help_my_active_rfqs: "Total des TES RFQs (créées par toi) qui ne sont pas encore Gagnées ou Perdues.",
    kpi_help_my_pipeline_value: "Σ (volume annuel × prix de vente) de TES RFQs actives.",
    kpi_help_my_close_rate: "Gagnées / (Gagnées + Perdues) pour TES RFQs uniquement (filtré par created_by). Ne compte que celles fermées dans la période.",
    kpi_help_my_follow_up: "TES RFQs en 'Offre envoyée' ou 'En négociation' depuis plus de 14 jours sans activité — probablement le client n'a pas répondu, à relancer.",
    kpi_help_eng_in_analysis: "Nombre de RFQs en 'Analyse' qui te sont attribuées (ou toutes si aucune ne t'est attribuée).",
    kpi_help_eng_overdue: "Sous-ensemble de tes RFQs en analyse dont la deadline est dépassée (SLA-overdue). Elles génèrent des notifications automatiques à toi et au commercial créateur.",
    kpi_help_eng_avg_time: "Temps moyen (en jours) entre le submit du Commercial vers l'Ingénierie et le retour avec l'étude technique, calculé pour les passages fermés dans la période. Cadence de l'Ingénierie.",
    kpi_help_eng_rework: "RFQs dont la version actuelle du formulaire est > 1, c'est-à-dire qui ont été renvoyées au Commercial au moins une fois (correction de données, lock-edit, nouveau passage). Mesure la qualité du premier passage technique — plus ce nombre est élevé, plus l'Ingénierie corrige / demande des changements après le submit initial.",
    kpi_help_avg_pipeline_margin: "Moyenne de la marge globale (margin_global_percent) des cotations en pipeline. Exclut Gagnées/Perdues.",
    kpi_help_avg_won_margin: "Moyenne de la marge globale des cotations fermées comme gagnées dans la période. Indique la qualité de ce qui a été vendu.",
    kpi_help_vm_share: "Part du prix de vente correspondant à la matière première (aluminium + premiums + PAF). Exposition aux fluctuations du prix du métal.",
    kpi_help_active_with_transport: "RFQs en pipeline qui ont déjà un Incoterm renseigné.",
    kpi_help_annual_weight: "Σ (volume annuel × poids par pièce) des RFQs actives. Estimation du tonnage annuel à transporter.",
    kpi_help_distinct_box_types: "Nombre de types de caisse distincts utilisés dans les RFQs actives. Indicateur de fragmentation d'emballage.",
    kpi_help_active_suppliers: "Fournisseurs actifs dans le catalogue (Administration → Fournisseurs). Inclut les 4 types : usinage, traitement surface, peinture, autre.",
    dash_kpi_eng_throughput: "Livrées sur la période",
    dash_kpi_eng_upcoming: "Charge 7 prochains jours",
    kpi_desc_eng_throughput: "Sorties de l'analyse vers le Commercial",
    kpi_desc_eng_upcoming: "En analyse · deadline ≤ 7 j",
    kpi_help_eng_throughput: "RFQs dont la transition IN_ANALYSIS → état suivant (typiquement AWAITING_COMMERCIAL_MARGINS) a eu lieu DANS la période sélectionnée. Mesure de productivité réelle de l'Ingénierie : « combien de RFQs as-tu rendues au Commercial sur cet horizon ».",
    kpi_help_eng_upcoming: "RFQs actuellement en analyse chez toi avec une deadline dans les 7 prochains jours (hors celles déjà dépassées — elles sont dans le KPI 'En retard'). Aide à planifier la semaine et anticiper la pression SLA avant qu'elles ne deviennent overdue.",
    chart_machines_won: "Machines dans les RFQs gagnées",
    chart_finishing_won: "Finitions dans les RFQs gagnées",
    chart_my_machines_won: "Mes machines (RFQs gagnées)",
    chart_my_finishing_won: "Mes finitions (RFQs gagnées)",
    chart_machines_won_eng: "Machines (RFQs gagnées passées par l'Ing.)",
    chart_finishing_won_eng: "Finitions (RFQs gagnées passées par l'Ing.)",
    no_won_data: "Aucune RFQ gagnée dans le périmètre",
  },

  en: {
    app_title: "HPDC RFQ",
    login: "Login",
    logout: "Logout",
    username: "Username",
    password: "Password",
    dashboard: "Dashboard",
    rfqs: "Quotations",
    clients: "Clients",
    admin: "Administration",
    config: "Configuration",
    new_rfq: "New Quotation",
    search: "Search",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    expand: "Expand",
    collapse: "Collapse",
    expand_all: "Expand all",
    collapse_all: "Collapse all",
    collection_changed_summary: "List updated — {old} → {new} rows",
    create: "Create",
    back: "Back",
    submit: "Submit",
    approve: "Approve",
    reject: "Reject",
    download: "Download",
    status: "Status",
    deadline: "Deadline",
    client: "Client",
    part_ref: "Part Ref.",
    part_designation: "Designation",
    annual_volume: "Annual Volume (pcs/year)",
    created_at: "Created At",
    engineer: "Engineer",
    commercial: "Commercial",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    no_data: "No data",
    name: "Name",
    code: "Code",
    description: "Description",
    country: "Country",
    contact: "Contact",
    email: "Email",
    full_name: "Full name",
    language: "Language",
    role: "Role",
    notes: "Notes",
    color: "Color",
    actions: "Actions",
    system: "System",
    active: "Active",
    inactive: "Inactive",
    active_m: "Active",
    inactive_m: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    previous: "Previous",
    next: "Next",
    page: "Page",
    page_x_of_y: "Page {page} of {pages}",
    per_page: "Per page",
    results: "results",
    type: "Type",
    required_field: "*",

    in_preparation: "In Preparation",
    awaiting_engineering_assignment: "Awaiting Engineer Assignment",
    in_analysis: "In Technical Analysis",
    awaiting_logistics: "Awaiting Logistics",
    awaiting_commercial_margins: "Awaiting Commercial Margins",
    awaiting_finance: "Awaiting Finance",
    awaiting_direction: "Awaiting Administration (Exception)",
    awaiting_admin: "Awaiting Administration",
    approved: "Approved",
    offer_sent: "Offer Sent",
    won: "Won",
    lost: "Lost",
    in_negotiation: "In Negotiation",
    all_states: "All states",

    gate_g1: "G1 — Strategic Triage",
    gate_g2: "G2 — Document Completeness",
    gate_g3: "G3 — Technical Viability",
    gate_g4: "G4 — Financial Validation",
    gate_g5: "G5 — Administration Exception",
    strategic_triage: "Strategic Triage",
    strategic_reject: "Reject on strategic grounds",
    strategic_reject_title: "Strategic rejection (G1)",
    strategic_reject_desc: "Provide the strategic reason for rejecting this RFQ. The client will be informed outside the application.",
    strategic_rejected_toast: "RFQ rejected on strategic grounds",
    request_client_info: "Request information from client",
    request_client_info_title: "Request additional information",
    request_client_info_desc: "Specify what information you need from the client. The RFQ will be flagged as awaiting external input.",
    client_info_received: "Client information received",
    client_info_received_title: "Mark information as received",
    client_info_requested_toast: "Information request recorded",
    client_info_requested_with_email_toast: "Request recorded and email sent to client",
    client_info_requested_no_email_toast: "Request recorded but email was not sent",
    client_info_no_email_toast: "No recipient provided — no email will be sent",
    client_info_received_toast: "Information marked as received",
    send_email_to_client: "Send automatic email to client",
    email_to_recipients: "Recipients",
    email_to_recipients_help: "Separate multiple addresses with a comma. Pre-filled with the client's primary email.",
    email_recipient_role: "Client recipient",
    email_recipient_role_help: "Choose the client department to contact. Email addresses come from the client record.",
    email_role_custom: "Other address (type manually)",
    email_no_dept_configured: "This client has no department emails configured yet. Use the input below.",
    awaiting_client_flag: "Awaiting client information",
    awaiting_client_pending: "Pending information request(s)",
    return_to_commercial: "Return for rework",
    return_to_commercial_title: "Return to Commercial (technical rework)",
    return_to_commercial_desc: "Describe the technical adjustments required. A new quotation version will be created.",
    returned_to_commercial_toast: "RFQ returned for rework",
    submit_to_logistics: "Send to Logistics",
    submit_to_logistics_title: "Send for transport & packaging validation",
    submit_to_logistics_desc: "Classify technical risk. The RFQ goes to Logistics to validate transport and packaging.",
    submitted_logistics_toast: "RFQ sent to Logistics",
    submit_to_commercial_margins: "Send to Commercial",
    submit_to_commercial_margins_title: "Send for margin adjustment",
    submit_to_commercial_margins_desc: "Classify technical risk. The RFQ goes directly to Commercial for margin adjustment (skipping Logistics in the new simplified flow).",
    submitted_commercial_margins_toast: "RFQ sent to Commercial for margins",
    gate_logistics: "Logistics — Transport & packaging",
    gate_logistics_desc: "Validate or complete transport and packaging. When ready, confirm to return the RFQ to Commercial for margin adjustments.",
    logistics_complete: "Logistics validation complete",
    logistics_complete_title: "Complete logistics validation",
    logistics_complete_desc: "Optional note for history. The RFQ returns to Commercial for margin adjustments.",
    logistics_complete_toast: "Logistics validation recorded",
    gate_commercial_margins: "Commercial — Margin adjustment",
    gate_commercial_margins_desc: "Adjust segmented margins (internal ops, packaging, transport) and submit to Finance for final validation.",
    gate_commercial_margins_desc_v2: "Adjust the segmented margins. On submission, the system decides automatically whether to approve or escalate to Administration based on the PnL audit.",
    submit_for_finance: "Submit to Finance",
    submit_for_finance_title: "Submit to Finance (G4)",
    submit_for_finance_desc_commercial: "Confirm submission for financial validation. You may add an optional note.",
    submit_to_administration: "Submit to Administration",
    submit_for_approval: "Submit for approval",
    submit_escalate_title: "Submit to Administration",
    submit_escalate_desc: "PnL audit shows EBITDA target negative — the RFQ will be escalated to Administration (G5) for decision.",
    submit_approve_title: "Submit for approval",
    submit_approve_desc: "PnL audit validates the proposed margin. The RFQ will be approved automatically.",
    final_decision_will_escalate: "PnL audit shows EBITDA target below threshold — on submission, the RFQ will be escalated to Administration (G5).",
    final_decision_will_warn_admin: "The RFQ can be auto-approved, but Administration will be notified because the Schreder theoretical PV is negative.",
    final_decision_will_approve: "PnL audit within limits — on submission, the RFQ will be auto-approved.",
    escalated_to_administration_toast: "RFQ escalated to Administration",
    approved_with_admin_warning_toast: "RFQ approved (Administration notified — Schreder negative)",
    submitted_finance_toast: "Submitted for financial validation",
    technical_risk: "Technical Risk",
    risk_low: "Low",
    risk_medium: "Medium",
    risk_high: "High",
    risk_required: "Risk classification is mandatory",
    approve_finance: "Approve (Finance)",
    reject_escalate: "Reject and escalate to Administration",
    reject_escalate_title: "Reject and escalate to Administration (G4 → G5)",
    reject_escalate_desc: "Provide the financial reason. The RFQ will be escalated to the Administration for exceptional review.",
    escalated_toast: "RFQ escalated to Administration",
    approve_exception: "Approve by exception",
    approve_exception_title: "Approve by exception (G5)",
    approve_exception_desc: "The Administration approves this RFQ as an exception, despite the financial rejection.",
    reject_final: "Final rejection",
    reject_final_title: "Final rejection (G5)",
    reject_final_desc: "Provide the final reason. The RFQ will be marked as lost by governance decision.",
    rework_version: "Rework",
    rework_version_badge: "Rework v",

    engineering_overdue: "Engineering — Overdue",
    no_engineering_overdue: "No engineering overdue items",
    days_overdue_suffix: "days overdue",
    sla_overdue_badge: "Overdue",
    deadline_required: "Set a deadline before submitting to Engineering",
    required_for_submit: "Required to submit to Engineering",
    cannot_submit_reasons: "Missing before submitting to Engineering:",
    missing_document: "Attach at least one document",
    missing_engineer: "Assign a responsible engineer",
    missing_deadline: "Set a response deadline",
    missing_client_reply: "Mark the client's information as received",
    min_chars_hint: "Minimum {n} characters",
    submission_data: "Submission data",
    save_rfq_meta: "Save data",
    rfq_meta_saved: "Data updated",
    engineer_responsible_label: "Responsible engineer",
    engineer_not_assigned: "Not assigned",
    commercial_engineer_section: "Engineer assignment (Commercial)",
    error_load_assignable: "Could not load the engineer list.",
    download_document: "Download file",
    error_download_doc: "Could not download the file.",

    versions_title: "Form versions",
    versions_empty: "No sealed versions yet. v1 is created automatically when Commercial submits the RFQ to Engineering.",
    version_number_short: "v{n}",
    version_label_baseline: "Baseline",
    version_label_engineering: "Engineering",
    version_label_commercial_rework: "Commercial rework",
    version_author: "Author",
    version_created_at: "Created at",
    version_status_at_snapshot: "Status at snapshot",
    version_no_changes: "No changes vs previous version",
    rfq_info_title: "RFQ data",
    quotation_form_title: "Quotation form",
    yes: "Yes",
    no: "No",
    strategic_notes: "Strategic notes",
    loss_reason: "Loss reason",
    commercial_result: "Commercial result",
    result_notes: "Result notes",
    version_changes_count: "{n} field(s) changed",
    view_version: "View",
    compare_vs_previous: "Differences vs previous version",
    form_snapshot: "Form (snapshot)",
    calc_snapshot: "Calculation result",
    field: "Field",
    old_value: "Previous value",
    new_value: "New value",
    edit_rfq_version: "Edit (new version)",
    lock_edit_version: "Finish editing and seal",
    editing_mode_banner: "Editing a new version — changes are highlighted in amber. Click 'Finish editing' to seal vN.",
    locked_for_edit_info: "This version is sealed. To change values, click 'Edit' and create a new version.",
    unlock_confirm: "Open a new editable version?",
    lock_edit_comment_label: "Brief description of changes (optional)",
    changes_summary_header: "Changes in this version",
    fields_highlighted_from_baseline: "Fields changed vs baseline",

    vm_section: "Material Value (VM)",
    va_foundry_section: "VA Foundry",
    va_finishing_section: "VA Finishing",
    extra_works_section: "Extra Works",
    extra_works_empty: "No operations configured under Extra Works. Create them in the admin panel (Finishing → category \"Extra works\").",
    va_machining_control_label: "VA Machining & Control",
    category_finishing: "Finishing",
    category_extra_works: "Extra works",
    finishing_admin_category: "Category",
    all: "All",
    finishing_op_backstand_rebarbagem: "Backstand / Rebar finishing",
    finishing_op_granalagem: "Shot blasting",
    finishing_op_polimento: "Polishing",
    finishing_op_maquinagem_cnc: "CNC machining",
    finishing_op_controlo_gabarit: "Control / Gauge",
    finishing_op_pintura: "Painting",
    finishing_op_name: "Operation",
    finishing_cadence_hdr: "Cadence (pcs/h)",
    finishing_rate_hdr: "Rate (€/h)",
    finishing_scrap_hdr: "Scrap (%)",
    finishing_cadence_placeholder: "pcs/h",
    finishing_rate_placeholder: "€/h",
    finishing_scrap_placeholder: "%",
    subcontract_section: "Subcontracting",
    packaging_section: "Packaging",
    transport_section: "Transport",
    packaging_transport_section: "Packaging & Transport",
    tooling_section: "Tooling",
    margin_section: "Commercial Margin",
    results_section: "Calculation Result",
    packaging_section_card: "Packaging (pallet + box + separators)",
    transport_section_card: "Transport",
    piece_length_mm: "Part length (mm)",
    piece_width_mm: "Part width (mm)",
    piece_height_mm: "Part height (mm)",
    machine_pressure_bar: "Machine pressure (bar)",
    finishing_rate_from_config: "Rate defined in admin configuration",
    boxes_per_lot: "Boxes per lot",
    separators_per_box: "Separators per box",
    transport_incoterm: "Transport type / incoterm",
    transport_incoterm_other: "Other",
    transport_km: "Km to travel",
    transport_eur_per_km: "€ / km",
    transport_pieces_per_trip: "Pieces per trip",
    commercial_margins_segmented: "Commercial margins (segmented)",
    commercial_margins_segmented_help:
      "Each bucket (internal VA, packaging, transport, extra works, subcontracting and components) has its own margin. Empty cells count as 0%. Extra-works margin falls back to the internal margin when left blank.",
    margin_internal_ops: "Margin internal ops (foundry+finishing) (%)",
    margin_packaging: "Packaging margin (%)",
    margin_transport: "Transport margin (%)",
    margin_extra_works: "Extra works margin (%)",
    margin_subcontract: "Subcontracting margin (%)",
    margin_components: "Components margin (%)",
    recycling_rate: "Recycling rate",
    machine_override: "Manual machine (override)",
    cycle_time_manual: "Manual cycle time",
    subcontract_machining_supplier: "Machining supplier",
    subcontract_other_description: "Description (other subcontract)",
    tooling_cost_foundry_eur: "Foundry mould cost (€)",
    tooling_sale_price_eur: "Tool sale price (€)",
    gabarit_cost_eur: "Gabarit cost (€)",
    gabarit_margin_percent: "Gabarit margin (%)",
    position: "Position",
    qty_per_piece: "Qty per piece",
    category: "Category",
    lot_size: "Lot size",
    pcs_per_pallet: "Pieces per pallet",
    designation: "Designation",
    cost_eur: "Cost (€)",
    box_type_label: "Box type",
    box_type_placeholder: "Select…",
    box_type_none: "None (pallet only / manual cost)",
    packaging_manual_counts_hint: "With no box type, Pieces per box and Boxes per pallet are entered manually.",
    cross_profile_notes_title: "Cross-team comments",
    cross_profile_notes_desc: "Observations visible to teams with access to this RFQ.",
    cross_profile_notes_placeholder: "Write a note…",
    cross_profile_notes_post: "Post note",
    cross_profile_notes_empty: "No notes yet.",
    cross_profile_note_added: "Note added",

    alloy: "Alloy",
    base_mb: "Base MB (€/T)",
    premium: "Premium (€/T)",
    premium_buy: "Buy Premium (€/T)",
    premium_sell: "Sell Premium (€/T)",
    alloy_premiums_required: "Buy and sell premiums are required.",
    alloy_total_buy: "Total Buy (€/T)",
    alloy_version: "Alloy version",
    select_alloy_version: "Select version...",
    chart_alloy_price_evolution: "Alloy price evolution",
    history: "History",
    effective_date: "Effective date",
    alloy_history_title: "Alloy price history",
    alloy_history_hint: "Each price change creates a new version.",
    project_name: "Project name",
    plan_number: "Plan number",
    plan_revision: "Revision",
    plan_revision_date: "Revision date",
    g2_project_info: "Project / plan identification",
    base_mb_edit_comment: "Reason for Base MB edit",
    base_mb_comment_required: "Provide the reason for the Base MB edit",
    base_mb_comment_min: "The Base MB edit reason must be at least {n} characters.",
    duplicating: "Duplicating...",
    recorded_by: "Recorded by",
    system_author: "System",
    base_mb_overridden: "Base MB manually edited",
    base_mb_overridden_by: "Edited by",
    cycle_time_per_piece: "Cycle time (s/piece)",
    shots_per_day: "Shots/day",
    pieces_per_day: "Pieces/day",
    pieces_per_day_no_scrap: "Pieces/day (excl. scrap)",
    assign_engineer: "Assign engineer",
    assign_engineer_title: "Engineer assignment (Technical Director)",
    assign_engineer_hint: "Select the responsible engineer to start the technical analysis.",
    engineer_assigned_ok: "Engineer assigned",
    paf: "PAF (%)",
    piece_weight: "Piece Weight (kg)",
    runner_weight: "Runner Weight (kg)",
    projected_area: "Projected Area (cm²)",
    safety_factor: "Slider Coef.",
    safety_factor_hint: "Between 0 and 1 — 0.1 without sliders, 0.2 with sliders; the formula uses (1 + coefficient).",
    mold_complexity_coef: "Safety coefficient",
    mold_complexity_hint: "Between 0 and 1 (default 0.5); the formula uses (1 + coefficient).",
    projection_coef: "Projection coefficient",
    projection_coef_hint: "Fraction of the L×W bounding box that the part actually occupies (default 0.7). Parts that nearly fill the rectangle approach 0.9–1.0; thin/lobed parts go below 0.5.",
    calculated_tonnage: "Clamping force (T)",
    tonnage_missing_inputs: "Fill in Machine Pressure for the formula to apply.",
    runner_weight_coef: "Runner weight coefficient",
    runner_weight_coef_hint: "Between 0 and 1; clamping force uses the factor (1 + coefficient).",
    auto_selected: "auto-selected",
    machine: "Machine",
    cavities: "Cavities",
    shots_hour: "Shots per Hour",
    trs: "OEE (%)",
    cycle_time: "Cycle Time (s)",
    scrap_rate: "Scrap (%)",
    production_cost: "Production Cost",
    sale_price: "Sale Price",
    margin: "Margin",
    margin_percent_label: "Margin (%)",
    auto_by_area: "Auto (by area)",
    inactive_marker: "(inactive)",
    select_alloy: "Select alloy...",
    select_client: "Select client...",
    select_placeholder: "Select...",

    subcontract_machining: "Subcontract Machining (€/pc)",
    subcontract_surface: "Surface Treatment (€/pc)",
    subcontract_painting: "Subcontract Painting (€/pc)",
    subcontract_other: "Other (€/pc)",
    packaging_per_piece: "Packaging (€/pc)",
    transport_per_lot: "Transport (€/lot)",
    pieces_per_lot: "Pieces per lot",

    tooling_amortized: "Tooling (amort.)",
    vm_share: "VM share",
    expected_annual_va: "Expected annual VA",
    expected_annual_va_detail:
      "= {volume} × {rate} €/pc (VA Foundry + Finishing bucket with internal margin). The VA lines above are shown to 2 decimals; the engine uses higher precision, so the total may differ slightly from multiplying the rounded figures.",
    annual_revenue: "Annual revenue",
    total_scrap_estimate: "Total scrap est.",
    save_quotation_to_see: "Save the quotation to see the result",
    engine_mode: "Mode",
    engine_version: "Engine",

    snapshot_alloy: "Alloy",
    snapshot_piece_weight: "Piece weight (kg)",
    snapshot_runner_weight: "Runner weight (kg)",
    snapshot_projected_area: "Proj. area (cm²)",
    snapshot_cadence: "Cadence (shots/h)",
    snapshot_cavities: "# cavities",
    snapshot_margin: "Margin",
    snapshot_sale_price: "Sale price (€/pc)",
    snapshot_production_cost: "Production cost (€/pc)",

    save_quotation: "Save Quotation",
    saving_wait: "Saving...",
    submit_engineering: "Submit to Engineering",
    submit_validation: "Submit for Validation",
    mark_offer_sent: "Mark Offer as Sent",
    duplicate: "Duplicate",
    comment_placeholder: "Comment/Justification...",

    commercial_outcome_title: "Commercial Outcome",
    commercial_outcome_desc: "Record the client's decision on the sent proposal. This feeds the dashboard KPIs.",
    mark_won: "Won",
    mark_lost: "Lost",
    mark_in_negotiation: "In negotiation",
    mark_won_title: "Mark as won",
    mark_lost_title: "Mark as lost",
    mark_in_negotiation_title: "Mark in negotiation",
    mark_won_desc: "The client accepted the proposal. You can optionally add a note.",
    mark_lost_desc: "The client rejected the proposal. Please state the loss reason.",
    mark_in_negotiation_desc: "The client refuted the proposal. The quotation moves to negotiation and can be reopened to create a new version (goes back through Engineering).",
    outcome_notes: "Notes (optional)",
    loss_reason_label: "Loss reason",
    loss_reason_price: "Price",
    loss_reason_lead_time: "Lead time",
    loss_reason_technical: "Technical",
    loss_reason_strategic_pass: "Strategic",
    loss_reason_competitor: "Competitor",
    loss_reason_other: "Other",
    outcome_won_toast: "Outcome recorded: won",
    outcome_lost_toast: "Outcome recorded: lost",
    outcome_in_negotiation_toast: "Quotation marked 'in negotiation'",
    confirm_outcome: "Confirm",
    in_negotiation_title: "Quotation in negotiation",
    in_negotiation_desc: "The client refuted the proposal. Reopen the quotation to create a new version; it will go back through Engineering before it can be closed as Won/Lost.",
    reopen_negotiation_action: "Reopen / Re-quote",
    reopen_negotiation_title: "Reopen quotation for new version",
    reopen_negotiation_desc: "The quotation goes back to 'in preparation' (edit mode). Any change creates a new version and goes back through Engineering.",
    reopened_negotiation_toast: "Quotation reopened for new version",

    all_clients: "All clients",
    all_alloys: "All alloys",
    all_machines: "All machines",
    clear_filters: "Clear filters",
    pieces_unit: "pcs/year",

    saved_and_recalculated: "Quotation saved and recalculated",
    submitted_engineering: "Submitted to Engineering",
    submitted_validation: "Submitted for validation",
    approved_toast: "Approved",
    rejected_toast: "Rejected with justification",
    offer_sent_toast: "Offer marked as sent",
    offer_pdf_section: "Commercial offer (PDF)",
    generate_offer_pdf: "Generate Offer (PDF)",
    generate_offer_pdf_title: "Generate commercial offer PDF",
    generate_offer_pdf_desc: "The fields below appear in the PDF. Leave empty to use default values (validity from global config, no additional conditions).",
    offer_pdf_language: "PDF language",
    offer_pdf_language_help: "Applies to labels and standard offer copy. Client data, amounts and observations are not translated.",
    offer_lang_en: "English",
    offer_lang_fr: "French",
    offer_lang_pt: "Portuguese",
    offer_validity_days: "Validity (days)",
    offer_specific_conditions: "Specific conditions",
    offer_observations: "Observations",
    offer_generated_toast: "Offer PDF generated",
    offer_generate_error: "Error generating offer PDF",
    offer_download_error: "Error downloading PDF",
    no_offers_yet: "No PDFs generated yet.",
    duplicated_toast: "RFQ duplicated",
    rfq_deleted_toast: "RFQ deleted",
    delete_rfq_confirm: "Delete RFQ {ref}? This action cannot be undone.",
    error_operation: "Operation error",
    error_saving: "Error saving",
    error_loading_rfq: "Error loading RFQ",
    justification_min_chars: "Justification minimum: 20 characters",
    rfq_not_found: "RFQ not found",
    doc_attached: "Document attached",
    extracting_drawing: "Extracting 2D drawing data (text + OCR)... May take 10–30 s.",
    error_attaching_doc: "Error attaching document",

    documents: "Documents",
    no_documents: "No documents",
    attach_document: "Attach document",
    g1_essential_documents: "Essential documents (G1)",
    slot_model_3d: "3D model",
    slot_drawing_2d: "2D drawing (Injection)",
    slot_drawing_2d_machining: "2D drawing (Machining)",
    slot_additional: "Quality specifications",
    slot_hint_3d: "Expected: .step / .stp / .stl",
    slot_hint_2d: "Expected: PDF (with text layer)",
    slot_hint_additional: "Quality requirements, standards and acceptance criteria",
    attach: "Attach",
    replace: "Replace",
    remove: "Remove",
    no_file: "No file",
    drawing_extracted_info: "Info detected in 2D drawing",
    drawing_extracted_disclaimer: "discovery mode (does not pre-fill the quote)",
    reextract: "Re-extract",
    extraction_loading: "Extracting…",
    extraction_keyword_hits: "Detected keywords",
    extraction_numeric_tokens: "Detected numeric values",
    extraction_title_block: "Title block (bottom-right corner)",
    extraction_revisions: "Revision hints",
    extraction_pages: "Pages / sizes",
    extraction_warning_no_text: "PDF has no text layer — extraction unavailable (OCR will be required in a future iteration).",
    extraction_warning_multipage: "Multi-page document — all pages were analysed.",
    extraction_warning_unsupported: "Unsupported format for extraction (PDF expected).",
    extraction_empty: "No extractable information was detected.",
    section_drawing_data: "Drawing data",
    section_piece_metadata: "Piece metadata",
    section_dimension_candidates: "Overall dimension candidates",
    section_raw_advanced: "Advanced mode (raw output)",
    field_part_number: "Part number",
    field_designation: "Designation",
    field_scale: "Scale",
    field_page_format: "Sheet format",
    field_step_ref: "Referenced 3D file",
    field_drawn_date: "Drawing date",
    field_revision: "Revision",
    field_weight: "Estimated weight",
    field_material: "Material / alloy",
    field_tolerance: "Tolerance standard",
    dimension_candidates_disclaimer: "Top 3 largest values after filtering IDs, standards, angles, radii and references. Confidence is a heuristic — always confirm with the drawings.",
    show_more_candidates: "Show more candidates",
    // ============ Quotation Suggestions panel (pre-fill from 2D drawing) ============
    suggest_panel_title: "Pre-fill quotation from 2D drawing",
    suggest_panel_disclaimer: "auto-applies high-confidence fields",
    suggest_count_label: "suggestions",
    suggest_auto_section: "Automatically applied",
    suggest_pending_section: "To confirm — verify values",
    suggest_info_section: "Warnings",
    suggest_already_filled_section: "Already filled ({n}) — suggestion ignored",
    suggest_apply_selected: "Apply selected ({n})",
    suggest_threshold_hint: "Fields with confidence ≥ {pct}% are auto-applied; the rest require confirmation.",
    suggest_auto_applied: "{n} suggestion(s) applied automatically",
    suggest_applied: "{n} suggestion(s) applied",
    suggest_overridden: "Value overridden",
    suggest_override: "apply anyway",
    suggest_field_badge: "Suggested",
    suggest_field_tooltip: "Pre-filled from 2D drawing. Edit to confirm.",
    suggest_part_reference: "Part reference",
    suggest_part_designation: "Part designation",
    suggest_alloy: "Alloy",
    suggest_piece_weight: "Piece weight",
    suggest_piece_length: "Length (L)",
    suggest_piece_width: "Width (W)",
    suggest_piece_height: "Height (H)",
    suggest_warn_height_low_conf: "height — verify",
    suggest_warn_weight_no_unit: "weight without unit — verify",
    suggest_warn_alloy_not_in_config: "alloy not in config — ask admin to create it",
    status_history: "Status History",
    no_history: "No history",
    hide_quotation: "Hide quotation",
    view_quotation_snapshot: "View quotation at this point",

    pending_action: "Pending",
    near_deadline: "Near Deadline",
    recent_activity: "Recent Activity",
    total_rfqs: "Total RFQs",
    conversion_rate: "Conversion Rate",
    pipeline_value: "Pipeline Value",
    blocked_rfqs: "Blocked RFQs",
    avg_pipeline_margin: "Avg Pipeline Margin",
    my_pipeline_value: "My Pipeline",
    real_close_rate: "Real Close Rate",
    proposals_to_follow_up: "Proposals to Follow Up",
    engineering_short: "Eng",
    finance_short: "Fin",
    administration_short: "Adm",
    rfqs_suffix: "RFQs",
    no_pending_rfqs: "No pending RFQs",
    no_near_deadline: "No RFQs near deadline",
    no_recent_activity: "No recent activity",
    action_col: "Action",
    detail_col: "Detail",
    date_col: "Date",
    error_loading_dashboard: "Error loading dashboard",

    justification_required: "Justification required (min. 20 characters)",
    comment: "Comment",

    notifications: "Notifications",
    mark_all_read: "Mark all as read",
    no_notifications: "No notifications",
    unread_suffix: "unread",
    delete_notification: "Delete notification",
    clear_all_notifications: "Clear all",

    users: "Users",
    roles: "Roles",
    machines: "Machines",
    alloys: "Alloys",
    finishing_rates: "Finishing Rates",
    global_config: "Global Configuration",
    calc_mode: "Calculation Mode",
    legacy_mode: "Legacy (Excel)",
    enhanced_mode: "Enhanced",

    access_restricted: "Access restricted",
    admin_only_desc: "Only users with administrator profile have access to this page.",
    load_error: "Error loading data",
    create_error: "Error creating",
    save_error: "Error saving",
    created: "Created",
    saved: "Saved",
    no_results: "No results",
    activity_sectors_tab: "Activity sectors",
    activity_sectors_title: "Activity sectors",
    activity_sectors_desc: "Values for the 'Activity sector' dropdown in the client form.",
    new_activity_sector: "New activity sector",
    contact_functions_tab: "Contact functions",
    contact_functions_title: "Contact functions",
    contact_functions_desc: "Values for the 'Function' dropdown in client team contacts.",
    new_contact_function: "New contact function",

    boxes_admin_tab: "Boxes",
    boxes_admin_title: "Box catalogue",
    boxes_admin_desc: "Boxes available in the quotation Packaging card. Dimensions and useful volume drive the automatic \"Pieces per box\" calculation when the part dimensions are filled in.",
    pallet_cost_admin_title: "Pallet cost",
    pallet_cost_admin_desc: "Single europallet cost, applied automatically to every quotation. On the Packaging card the field is read-only.",
    pallet_cost_saved: "Pallet cost saved",
    pallet_cost_invalid: "Enter a valid pallet cost (≥ 0).",
    pallet_cost_readonly_hint: "Set in Administration (Boxes tab). Not editable on the quotation.",
    new_box_type: "New box",
    box_type_name: "Name",
    box_type_description: "Description",
    box_type_length_mm: "Length (mm)",
    box_type_width_mm: "Width (mm)",
    box_type_height_mm: "Height (mm)",
    box_type_price_eur: "Price (€)",
    box_type_volume_l: "Volume (L)",
    box_type_volume_hint: "Liters (1 L = 1,000 cm³). Leave blank to auto-derive from the dimensions.",
    box_type_created: "Box created",
    box_type_updated: "Box updated",
    box_type_deactivated: "Box deactivated",
    box_type_activated: "Box activated",

    suppliers_admin_tab: "Suppliers",
    suppliers_admin_title: "Supplier catalog",
    suppliers_admin_desc: "Suppliers available in the \"Supplier\" select on the Subcontract card. Each supplier is linked to a type (machining, surface treatment, painting, other) and the card automatically filters options by line type.",
    new_supplier: "New supplier",
    supplier_name: "Name",
    supplier_type: "Supplier type",
    supplier_type_machining: "Machining",
    supplier_type_surface_treatment: "Surface treatment",
    supplier_type_painting: "Painting",
    supplier_type_other: "Other",
    supplier_notes: "Notes",
    supplier_created: "Supplier created",
    supplier_updated: "Supplier updated",
    supplier_deactivated: "Supplier deactivated",
    supplier_activated: "Supplier activated",
    supplier_select_placeholder: "Select supplier…",
    supplier_no_options: "No suppliers of this type (configure under Administration → Suppliers).",

    slot_part_image: "Part image",
    slot_hint_part_image: "Photo/render (.png, .jpg). Embedded into the commercial offer PDF.",

    payment_terms_section: "Payment Terms (offer PDF)",
    internal_code: "Internal code",
    address_field: "Address",
    activity_sector: "Activity sector",
    purchase_volume_eur: "Purchase volume (€)",
    team_contacts: "Client team contacts",
    function_field: "Function",
    phone_field: "Phone",
    financial_health: "Financial health",
    liquidity_days: "Liquidity (average supplier payment term, days)",
    liabilities_total: "Total liabilities (€)",
    equity: "Equity (€)",
    solvency_ratio: "Solvency (liabilities / equity)",
    ebitda_eur: "Profitability — EBITDA (€)",
    risk_rating: "Risk assessment",
    risk_1: "no risk",
    risk_2: "low risk",
    risk_3: "moderate",
    risk_4: "risky",
    risk_5: "very risky",
    financial_reports: "Financial reports",
    upload_report: "Attach report",
    uploading: "Uploading…",
    save_financial: "Save indicators",
    financial_saved: "Financial indicators saved",
    financial_save_error: "Error saving indicators",
    financial_complete: "Complete",
    financial_pending: "Pending",
    read_only: "Read only",
    close: "Close",
    open: "Open",
    download_error: "Download error",
    delete_error: "Delete error",
    payment_terms_help: "When empty, the global configuration defaults are used.",
    payment_terms_parts: "Payment terms — parts",
    payment_terms_tooling: "Payment terms — tooling",

    offer_payment_terms_section: "Payment terms",
    offer_payment_terms_help: "Appear in the Payment Terms section of the PDF. Leave empty to inherit the client's payment terms and, failing that, the global defaults.",

    offer_planning_section: "Planning (weeks)",
    offer_planning_help: "Appear in the Planning section of the PDF. Leave empty to use the global defaults (12 / 2 / 8 / 6).",
    offer_planning_first_article_weeks: "First article (weeks)",
    offer_planning_first_series_weeks: "First series after agreement (weeks)",
    offer_planning_supplying_weeks: "Supplying (weeks)",
    offer_planning_supplying_forecast_weeks: "Supplying with forecast (weeks)",

    finishing_admin_title: "Finishing operations",
    finishing_admin_desc: "Define the operations available in the quotation \"VA Finishing\" panel and their hourly rate. Cadence (pcs/h) and scrap (%) are entered by the commercial in each quotation.",
    new_finishing_rate: "New operation",
    no_finishing_rates: "No operations configured. Create the first one so it appears in quotations.",
    finishing_name_required: "Operation name is required",
    finishing_rate_created: "Operation created",
    finishing_rate_updated: "Operation updated",
    finishing_rate_deactivated: "Operation deactivated",
    finishing_rate_activated: "Operation activated",

    new_machine: "New Machine",
    tonnage: "Tonnage",
    hourly_rate: "Hourly Rate (€/h)",
    max_area: "Max area (cm²)",
    max_area_header: "Max Area (cm²)",
    machine_created: "Machine created",
    machine_updated: "Machine updated",
    machine_deactivated: "Machine deactivated",
    machine_activated: "Machine activated",

    new_alloy: "New Alloy",
    alloy_created: "Alloy created",
    alloy_updated: "Alloy updated",
    alloy_deactivated: "Alloy deactivated",
    alloy_activated: "Alloy activated",
    paf_hint: "PAF (0-1)",

    new_user: "New User",
    administrator: "Administrator",
    create_user: "Create User",
    user_created: "User created",
    user_updated: "User updated",
    user_deactivated: "User deactivated",
    user_reactivated: "User reactivated",
    deactivate_user_title: "Deactivate user",
    deactivate_user_desc_prefix: "User",
    deactivate_user_desc_suffix: "will no longer be able to access the application. You can reactivate later.",
    no_profile: "No profile",
    portuguese_full: "Português",
    french_full: "Français",
    english_full: "English",

    new_role: "New Role",
    permissions: "Permissions",
    create_role: "Create Role",
    role_created: "Role created",
    role_updated: "Role updated",
    system_role_locked: "System — not editable",
    permission_help_aria: "What this permission allows",
    perm_help_rfq_view_own: "View only RFQs you created or that are assigned to you.",
    perm_help_rfq_view_all: "View all RFQs on the platform.",
    perm_help_rfq_create: "Create new RFQs.",
    perm_help_rfq_edit_own: "Edit your own RFQs (created or assigned).",
    perm_help_rfq_edit_all: "Edit any RFQ, regardless of owner.",
    perm_help_rfq_submit: "Submit the RFQ in the workflow (commercial screening, analysis close, or decision).",
    perm_help_rfq_approve: "Approve the RFQ (Administration / G5 decision).",
    perm_help_rfq_reject: "Reject the RFQ (G1 strategic rejection or G5 decision).",
    perm_help_rfq_view_margin: "See selling price, margins and the Rent_Bud panel.",
    perm_help_rfq_assign_engineer: "Assign the responsible engineer after commercial submission.",
    perm_help_doc_attach: "Attach documents to the RFQ.",
    perm_help_doc_download: "Download RFQ documents.",
    perm_help_offer_generate: "Generate the commercial offer PDF.",
    perm_help_offer_edit: "Edit offer fields when generating the PDF.",
    perm_help_offer_download: "Download the commercial offer PDF.",
    perm_help_client_view: "View client records and the client list.",
    perm_help_client_create: "Create new clients.",
    perm_help_client_edit: "Edit the general client record.",
    perm_help_client_financial_edit: "Edit only the client's financial indicators.",
    perm_help_history_view: "View RFQ history and notes.",
    perm_help_history_add: "Add notes to the RFQ history.",

    new_client: "New Client",
    strategic_type: "Strategic Type",
    growth_potential: "Growth Potential",
    strategic: "Strategic",
    standard: "Standard",
    transactional: "Transactional",
    high: "High",
    medium: "Medium",
    low: "Low",
    potential_label: "Potential",
    name_required_toast: "Name required",
    no_clients: "No clients",
    client_created: "Client created",
    client_create_error: "Error creating client",
    client_updated: "Client updated",
    client_update_error: "Error updating client",
    edit_client: "Edit client",
    email_primary: "Primary email",
    email_primary_help: "Default address used when the commercial requests information from the client.",
    dept_emails: "Department emails",
    dept_emails_help: "Each email appears as an option in the \"Request additional information\" dialog. Leave blank when a department is not applicable.",
    email_logistica: "Logistics email",
    email_qualidade: "Quality email",
    email_comercial: "Commercial email",
    email_projeto: "Project email",
    email_contacts: "Additional contacts",
    add_contact: "Add contact",
    no_extra_contacts: "No additional contacts.",
    role_field: "Role",
    email_invalid_toast: "Invalid email address",

    fill_required_fields: "Please fill in required fields",
    invalid_email: "Invalid email",
    username_min_length: "Username: minimum 3 characters",
    name_min_length: "Name: minimum 2 characters",
    client_name_required: "Client name required",
    rfq_created: "RFQ created successfully",
    rfq_create_error: "Error creating RFQ",
    add_client_aria: "Add client",
    cancel_new_client_aria: "Cancel new client",
    part_ref_placeholder: "Client part reference",
    part_designation_placeholder: "Part designation",
    context_placeholder: "Notes, request context...",
    commercial_context: "Commercial Context",
    create_client: "Create Client",
    rfq_data: "RFQ Data",
    creating_wait: "Creating...",

    no_rfqs_found: "No RFQs found",
    reference: "Reference",

    login_success: "Login successful",
    login_error: "Authentication error",
    login_subtitle: "Quotation Management — High Pressure Die Casting",
    login_brand_kicker: "Aluthea Group",
    login_brand_lead: "Technical quotations with the precision of high-pressure aluminium die casting.",
    login_brand_point_1: "Commercial, engineering and decision workflow in one place",
    login_brand_point_2: "HPDC calculation engine and price validation",
    login_brand_point_3: "Offer PDF, audit trail and version history",
    entering: "Logging in...",
    default_admin: "Default admin",
    email_or_username: "Email or username",
    email_or_username_placeholder: "user@company.com",
    forgot_password: "Forgot password?",
    forgot_password_title: "Recover password",
    forgot_password_subtitle: "Enter your account email to receive recovery instructions.",
    forgot_password_sent: "If an account is associated with that email, a message with recovery instructions has been sent. Please also check your spam folder.",
    send_reset_link: "Send recovery link",
    sending: "Sending...",
    back_to_login: "Back to login",
    reset_password_title: "Set a new password",
    reset_password_subtitle: "Choose a new password for your account.",
    reset_password_action: "Change password",
    reset_password_success: "Password changed successfully. You can now sign in.",
    reset_password_error: "Could not change the password. Please request a new link.",
    reset_password_invalid_token: "Missing or invalid link. Please request a new recovery email.",
    request_new_link: "Request a new link",
    new_password: "New password",
    confirm_password: "Confirm new password",
    password_min_length: "Minimum 8 characters.",
    passwords_do_not_match: "Passwords do not match.",
    saving: "Saving...",
    generic_error: "An error occurred. Please try again.",

    sidebar_open_menu: "Open side menu",
    sidebar_close_menu: "Close side menu",
    autosave_pending: "Pending changes…",
    autosave_saving: "Saving…",
    autosave_saved: "Saved",
    autosave_error: "Save failed",
    main_nav_label: "Main navigation",
    toggle_to_light: "Switch to light mode",
    toggle_to_dark: "Switch to dark mode",
    light_mode: "Light mode",
    dark_mode: "Dark mode",
    skip_to_content: "Skip to content",
    language_aria: "Language",

    // ============ Calc v2 ============
    components_section: "Components / Inserts",
    no_components_yet: "No component lines. Click + to add.",
    add_line: "Add line",
    add_candidate: "Add candidate",
    no_candidates_yet: "No candidates.",
    component_reference: "Reference",
    component_purchase: "Purchase (€)",
    component_transport: "Transport (€)",
    component_qty: "Qty/piece",
    component_scrap: "Detected scrap (%)",
    component_shrink: "Inventory shrink (%)",
    component_supplier_margin: "Supplier margin (%)",
    subcontract_machining: "Machining",
    subcontract_surface_treatment: "Surface treatment",
    subcontract_painting: "Painting",
    subcontract_other: "Other",
    selected: "Selected",
    supplier: "Supplier",
    purchase: "Purchase (€)",
    transport_pallet: "Transport/pallet (€)",
    pcs_pallet: "Pcs/pallet",
    scrap_percent: "Scrap (%)",
    pieces_per_box: "Pieces per box",
    pieces_per_box_auto_hint: "Auto-calculated when a box is selected and the part dimensions (Length/Width/Height) are filled in.",
    boxes_per_pallet: "Boxes per pallet",
    boxes_per_pallet_auto_hint: "Europallet 1200×800×144 mm. Max boxes until piece weight (1500 kg) or TIR useful height (2.70 m, pallet deducted) is reached. The first limit hit wins.",
    pallet_cost: "Pallet cost (€)",
    max_pallet_weight: "Max pallet weight (kg)",
    tooling_line_label: "Line",
    tooling_cost: "Cost (€)",
    tooling_margin: "Margin (%)",
    tooling_sale: "Sale (€)",
    tooling_guarantee_shots: "Guarantee (shots qty)",
    tooling_separate_note: "Tooling is invoiced separately and does not enter the per-piece price.",
    tooling_label_mould_foundry: "Foundry mould",
    tooling_label_mould_cutting: "Cutting mould",
    tooling_label_gabarit_machining: "Machining fixture",
    tooling_label_gabarit_control: "Control fixture",
    tooling_add_line: "Add line",
    tooling_remove_line: "Remove line",
    tooling_custom_label_placeholder: "Designation",
    studies_section: "Studies / Developments",
    studies_separate_note: "Studies and developments are informational only — they do not enter the per-piece or tooling price.",
    studies_no_lines: "No lines. Add as needed.",
    studies_add_line: "Add line",
    studies_remove_line: "Remove line",
    studies_label_placeholder: "Study designation",
    shrink_section: "Inventory Shrink",
    inventory_shrink_label: "Inventory shrink (%)",
    inventory_shrink_help: "Inventory-loss percentage applied to the scrap cascade. Default: 5%.",
    pricing_buckets: "Sale price (per bucket)",
    bucket_va_internal: "VA Foundry + Finishing",
    bucket_extra_works: "Extra works",
    bucket_packaging: "Packaging",
    bucket_transport: "Transport",
    bucket_vm: "VM",
    bucket_va_pack_trans: "VA + Pack. + Transp.",
    bucket_components: "Components",
    bucket_subcontract: "Subcontracting",
    global_margin: "Global margin",
    margin_eur: "Margin (€)",
    tooling_total_separate: "Total tooling (separate invoice)",
    warnings: "Warnings",
    warn_pallet_weight_exceeded: "Pallet weight exceeds configured maximum.",

    // ===== Cost structure / price validation =====
    pnl_tab_label: "Cost structure",
    pnl_admin_title: "Cost structure",
    pnl_admin_subtitle: "Factory macro parameters for price validation. Each save creates a new immutable version.",
    pnl_year: "Year",
    pnl_active: "Active",
    pnl_load_error: "Failed to load PnL configuration",
    pnl_save_error: "Failed to save PnL configuration",
    pnl_saved: "PnL configuration saved",
    pnl_reset_to_defaults: "Reset to 26-27 defaults",
    pnl_reset_to_defaults_done: "26-27 defaults loaded (don't forget to save)",
    pnl_block_fixed_costs: "2.1 — Fixed annual costs (k€/year)",
    pnl_fixed_charges: "Fixed charges",
    pnl_indirect_labour: "Indirect labour (MOI)",
    pnl_management_fees: "Management fees",
    pnl_mod_foundry: "Direct labour — Foundry",
    pnl_mod_finishing: "Direct labour — Finishing",
    pnl_block_splits: "2.2 — MOI / Fixed-charges splits",
    pnl_moi_split_foundry: "MOI foundry split (0–1)",
    pnl_cf_split_foundry: "Fixed-charges foundry split (0–1)",
    pnl_block_capacity: "2.3 — Capacity (h/year)",
    pnl_press_hours_400: "Press hours/year — 400T",
    pnl_press_hours_600: "Press hours/year — 600T",
    pnl_press_hours_900: "Press hours/year — 900T",
    pnl_press_hours_1100: "Press hours/year — 1100T",
    pnl_labour_hours_finishing: "Finishing labour hours/year",
    pnl_working_days: "Working days/year",
    pnl_absenteeism: "Absenteeism rate",
    pnl_block_rates: "2.4 — Rates €/h",
    pnl_rate_press_400: "Press rate — 400T",
    pnl_rate_press_600: "Press rate — 600T",
    pnl_rate_press_900: "Press rate — 900T",
    pnl_rate_press_1100: "Press rate — 1100T",
    pnl_rate_finishing: "Finishing rate",
    pnl_block_variable_margins: "2.5 — Variable + targets",
    pnl_variable_costs_pct: "% variable costs over VA",
    pnl_variable_costs_hint: "Default 13.86 % — applied on VA, never on VM/GAS/ST",
    pnl_energy_default: "Energy €/kg (fallback)",
    pnl_marge_va_target: "VA target margin",
    pnl_marge_va_hint: "20 % default — applied ONLY on PR_INJ + PR_Para",
    pnl_ebitda_target: "EBITDA target (% revenue)",
    pnl_alloys_table: "Alloys table (€/kg)",
    pnl_add_alloy: "Add alloy",
    pnl_alloy_code: "Code (e.g. 47100)",
    pnl_purchase_eur_per_kg: "HA €/kg (purchase)",
    pnl_selling_eur_per_kg: "PV €/kg (selling)",
    pnl_energy_table: "Energy by press (€/kg)",
    pnl_energy_400: "400T €/kg",
    pnl_energy_600: "600T €/kg",
    pnl_energy_900: "900T €/kg",
    pnl_energy_1100: "1100T €/kg",

    // PnLAuditPanel
    pnl_audit_title: "PnL cross-check audit",
    pnl_audit_unavailable: "Audit not available",
    pnl_audit_unavailable_hint: "Save the quotation to run the PnL cross-check.",
    pnl_verdict_ok: "OK — price aligned with quotation",
    pnl_verdict_subprecificado: "Underpriced",
    pnl_verdict_sobreprecificado: "Overpriced",
    pnl_verdict_critico: "Critical — below EBITDA minimum",
    pnl_verdict_error: "Audit error",
    pnl_reason_reason_below_min_ebitda: "Δ vs EBITDA minimum < -5%",
    pnl_reason_reason_below_theoretical: "Δ vs computed < -5%",
    pnl_reason_reason_above_theoretical: "Δ vs computed > +10%",
    pnl_reason_reason_in_range: "Δ vs computed within [-5%, +10%]",
    pnl_pv_proposed: "Proposed sale price",
    pnl_pv_proposed_hint: "Computed by the existing engine",
    pnl_pv_theoretical_schreder: "Theoretical sale price",
    pnl_pv_min_ebitda: "Min EBITDA target price",
    pnl_delta_vs_schreder: "Δ vs computed",
    pnl_delta_vs_min_ebitda: "Δ vs minimum",
    pnl_breakdown_title: "Breakdown (€/part)",
    pnl_vm: "VM",
    pnl_vm_hint: "raw material — pass-through, no margin",
    pnl_pr_inj: "PR_INJ",
    pnl_pr_inj_hint: "press",
    pnl_pr_para: "PR_Para",
    pnl_pr_para_hint: "finishing",
    pnl_pr_gas: "PR_GAS",
    pnl_pr_gas_hint: "energy",
    pnl_pr_st: "PR_ST",
    pnl_pr_st_hint: "subcontracting — pass-through",
    pnl_pr_total: "Pr_total",
    pnl_ebitda_implied: "Implied EBITDA",
    pnl_ebitda_implied_hint: "(PV − Pr_total − variable charges) / PV",
    pnl_press_hours: "Press hours",
    pnl_press_capacity_used: "of capacity",
    pnl_finishing_hours: "Finishing hours/year",
    pnl_finishing_hours_hint: "absenteeism included",
    pnl_diag_alloy: "Alloy",
    pnl_diag_press: "Press",
    pnl_energy: "Energy",
    pnl_kg: "kg",
    pnl_warnings: "Warnings",
    pnl_warn_warn_capacity: "Part exceeds annual press capacity",
    pnl_warn_warn_loss: "Negative implied EBITDA — part is loss-making",
    pnl_warn_warn_outlier: "Δ outside ±25 % — review inputs",
    pnl_warn_warn_alloy_unknown: "Alloy not recognised in PnL data",
    pnl_warn_warn_alloy_not_priced: "Alloy not priced — falling back to first entry",
    pnl_warn_warn_press_unknown: "Machine tonnage unknown — using 600T bucket",
    pnl_warn_warn_volume_missing: "Annual volume missing",
    pnl_warn_warn_cycle_missing: "Cycle time missing",
    pnl_warn_warn_weight_missing: "Part weight missing",
    pnl_warn_warn_scrap_foundry_out_of_range: "Foundry scrap outside [0, 30 %]",
    pnl_warn_warn_scrap_finishing_out_of_range: "Finishing scrap outside [0, 30 %]",
    pnl_warn_warn_audit_exception: "Internal exception in audit",
    pnl_warn_warn_no_pnl_config: "No active FactoryPnLConfig — audit unavailable",
    pnl_warn_warn_no_cost_structure: "No active cost structure",
    pnl_warn_warn_energy_fallback: "Energy €/kg: fallback used (machine unset)",

    price_validation_title: "Price validation",
    price_validation_subtitle: "Single-product absorption model (Rent_Bud)",
    pnl_legacy_snapshot_title: "Legacy snapshot",
    pnl_legacy_snapshot_hint: "Computed with the previous model. Save the quotation again to refresh.",
    traffic_VERDE: "Green",
    traffic_AMARELO: "Amber",
    traffic_VERMELHO: "Red",
    kpi_marge_vm_va_pct: "VM+VA margin (%)",
    price_validation_decomposition: "Breakdown",
    resultado_va: "VA result (€)",
    resultado_vm: "VM result (€)",
    marge_total_eur: "Total margin (€)",
    price_validation_support: "Supporting data",
    qtd_pieces_year: "Quantity (parts/year)",
    ca_vendu: "Revenue (€)",
    va_vendu: "VA sold (€)",
    tonnes: "Tonnes",
    pv_aux_title: "Auxiliary calculations",
    pv_aux_group_quantity: "Quantity",
    pv_aux_group_margin: "Margin and traffic light",
    pv_aux_cadence: "Injection cadence (parts/h)",
    pv_aux_cadence_f: "Shots/h × TRS × Cavities",
    pv_aux_hours_year: "Injection hours / year",
    pv_aux_hours_year_f:
      "Working days × Shifts/day × Hours/shift × Machines × Utilisation × (1 − Macro scrap)",
    pv_aux_qtd_f: "Injection hours/year × Cadence",
    pv_aux_ca_f: "Quantity × Sale price",
    pv_aux_va_vendu_f: "(Sale price − VM/part) × Quantity",
    pv_aux_tonnes_f: "Quantity × Part weight ÷ 1000",
    pv_aux_energy: "Energy (€/year)",
    pv_aux_energy_f: "Quantity × Part weight × Machine energy €/kg",
    pv_aux_variable: "Variable costs on VA (€/year)",
    pv_aux_variable_f: "VA sold × Variable %",
    pv_aux_fixed: "Fixed costs (€/year)",
    pv_aux_fixed_f: "Sum of annual fixed lines",
    pv_aux_finishing_seconds: "Finishing time (s/part)",
    pv_aux_finishing_seconds_f: "Σ 3600 ÷ cadence of each active operation (Polishing × 2)",
    pv_aux_effectif: "Finishing headcount (people)",
    pv_aux_effectif_f:
      "Quantity × (Seconds/part ÷ 3600) ÷ (Working days × Hours/shift finishing)",
    pv_aux_mod: "Finishing labour (€/year)",
    pv_aux_mod_f: "Headcount × Annual cost per person",
    pv_aux_transport: "Transport (€/year)",
    pv_aux_transport_f: "Quantity × Transport/part",
    pv_aux_resultado_va_f:
      "VA sold − (Energy + Variable + Fixed + Labour + Transport)",
    pv_aux_vm_sold: "VM sold (€/year)",
    pv_aux_vm_sold_f: "Quantity × VM/part",
    pv_aux_vm_bought: "VM purchased (€/year)",
    pv_aux_vm_bought_f:
      "Tonnes × (1 + Resale fire loss) × (Base MB + Buy premium)",
    pv_aux_vm_paf_resold: "Resold fire-loss VM (€/year)",
    pv_aux_vm_paf_resold_f:
      "Resale fire loss × Tonnes × (Slag valuation × Base MB × Slag share + Chips valuation × Base MB × Chips share)",
    pv_aux_resultado_vm_f: "VM sold − VM purchased + Resold fire-loss VM",
    pv_aux_marge_f: "VA result + VM result",
    pv_aux_marge_pct_f: "Total margin ÷ Revenue",
    pv_aux_thresholds: "Traffic light thresholds",

    price_validation_simulation: "Simulation",
    sim_sale_price: "Sale price (€/part)",
    sim_shots_per_hour: "Injection cadence (parts/h)",
    recalculate: "Recalculate",
    cs_block_capacity: "1. Capacity & calendar",
    cs_block_fixed: "2. Structural fixed costs (€/year)",
    cs_block_mo: "3. Finishing labour",
    cs_block_variable: "4. % variable costs on VA",
    cs_block_fire_loss: "5. Fire loss",
    cs_block_thresholds: "6. Traffic-light thresholds (margin %)",
    cs_save_new_version: "Save new version",
    cs_add_fixed_line: "Add line",
    cs_add_var_line: "Add %",
    machine_energy_eur_per_kg: "Energy €/kg cast",
    finishing_parallel_ops: "Parallel operators",
    cs_name_version: "Version name",
    cs_name_required: "Enter a version name before saving.",
    cycle_times_tab: "Cycle times",
    ct_import_title: "Import history (Excel)",
    ct_import_hint:
      ".xlsx file with columns: part weight (kg), part weight with runner (kg), machine, cycle time (s/part) and mold no. (optional, indicative). The first row must contain the headers.",
    ct_import_btn: "Import Excel",
    ct_importing: "Importing…",
    ct_replace_existing: "Replace existing history",
    ct_imported: "Rows imported",
    ct_import_skipped: "Rows skipped",
    ct_import_error: "Failed to import the file.",
    ct_new_record: "New history row",
    ct_part_weight: "Part weight (kg)",
    ct_part_weight_runner: "Weight w/ runner (kg)",
    ct_cycle_time: "Cycle time (s/part)",
    ct_mold_number: "Mold no.",
    ct_created: "Row added.",
    ct_updated: "Row updated.",
    ct_deleted: "Row removed.",
    ct_fields_required: "Fill in part weight, weight with runner and cycle time (values > 0).",
    ct_empty: "No history records. Import an Excel file or add rows.",
    ct_suggestion_label: "Suggestion (history)",
    ct_suggestion_records: "records",
    ct_suggestion_all_machines: "all machines",
    ct_apply: "Apply",
    cs_working_days: "Working days / year",
    cs_shifts: "Shifts / day",
    cs_shifts_injection: "Shifts / day — Injection",
    cs_shifts_finishing: "Shifts / day — Finishing",
    cs_hours_inj: "Hours / shift — injection",
    cs_hours_fin: "Hours / shift — finishing",
    cs_machine_count: "Injection machine count",
    cs_utilization: "Capacity utilisation rate (0–1)",
    cs_macro_scrap: "Macro factory scrap (0–1)",
    cs_finishing_fte_cost: "Finishing labour cost (€ / FTE / year)",
    cs_margin_green: "Green threshold — VM+VA margin (0–1)",
    cs_margin_warn: "Amber threshold — VM+VA margin (0–1)",
    cs_fire_loss_resale_pct: "Resale fire loss (0–1)",
    cs_slag_valuation_rate: "Slag valuation (0–1)",
    cs_slag_share_rate: "Slag share (0–1)",
    cs_slag_share_rate_hint: "Slag sold out of the total recovered waste.",
    cs_chips_valuation_rate: "Chips valuation (0–1)",
    cs_chips_share_rate: "Chips share (0–1)",
    cs_chips_share_rate_hint: "Chips sold out of the total recovered waste.",
    cs_fixed_label: "Label",
    cs_fixed_amount: "Annual amount (€)",
    cs_var_label: "Label",
    cs_var_pct: "% of VA sold",
    cs_versions_title: "Version history",
    cs_activate: "Activate",
    cs_load_error: "Failed to load cost structure",
    cs_save_error: "Failed to save version",
    cs_saved: "New version saved and activated",
    cs_activate_done: "Version activated",

    // ===== Dashboard (multi-profile professional revamp) =====
    greeting_morning: "Good morning",
    greeting_afternoon: "Good afternoon",
    greeting_evening: "Good evening",
    period_last_7d: "7 days",
    period_last_30d: "30 days",
    period_last_90d: "90 days",
    period_ytd: "YTD",
    period_last_12m: "12 months",
    period_custom: "Custom",
    period_from: "From",
    period_to: "To",
    period_apply: "Apply",
    period_invalid_range: "Invalid range",
    vs_previous_period: "vs previous period",
    dash_kpi_total_rfqs: "RFQs in period",
    dash_kpi_conversion: "Conversion rate",
    dash_kpi_won_revenue: "Annual revenue won",
    dash_kpi_pipeline_value: "Active pipeline",
    dash_kpi_blocked: "Blocked RFQs",
    dash_kpi_my_active_rfqs: "My active RFQs",
    dash_kpi_my_pipeline_value: "My pipeline",
    dash_kpi_my_close_rate: "My close rate",
    dash_kpi_my_follow_up: "Urgent follow-ups",
    dash_kpi_eng_in_analysis: "RFQs in analysis",
    dash_kpi_eng_overdue: "SLA-overdue",
    dash_kpi_eng_avg_time: "Avg. time in Eng.",
    dash_kpi_eng_rework: "Rework",
    dash_kpi_avg_pipeline_margin: "Avg. pipeline margin",
    dash_kpi_avg_won_margin: "Avg. won margin",
    dash_kpi_vm_share: "VM cost (% SP)",
    dash_kpi_active_with_transport: "Active w/ transport",
    dash_kpi_annual_weight: "Annual weight (est.)",
    dash_kpi_distinct_box_types: "Box types in use",
    dash_kpi_active_suppliers: "Active suppliers",
    chart_loss_reasons: "Loss reasons",
    chart_funnel_timeseries: "Funnel over time",
    chart_pipeline_by_status: "Pipeline by status",
    chart_pnl_by_commercial: "PnL audit by Commercial",
    chart_my_status: "My RFQs by status",
    chart_my_funnel_timeseries: "My funnel over time",
    chart_my_loss_reasons: "My loss reasons",
    chart_engineering_flow: "Engineering flow",
    chart_eng_distribution: "Distribution by status",
    chart_margin_timeseries: "Margin over time",
    chart_cost_composition: "Avg. cost composition",
    chart_margin_by_client_type: "Margin by client type",
    chart_incoterm_mix: "Incoterm mix",
    chart_box_type_mix: "Box types",
    chart_subcontract_mix: "Subcontracting by category",
    table_top_clients: "Top clients (won revenue)",
    table_awaiting_direction: "Awaiting Administration (G5)",
    table_my_followup: "My urgent follow-ups",
    table_my_deadlines: "My upcoming deadlines",
    table_eng_queue: "My queue ordered by urgency",
    table_underpriced: "Active underpriced RFQs",
    table_logistics_pending: "RFQs with transport/packaging to complete",
    series_created: "Created",
    series_won: "Won",
    series_lost: "Lost",
    series_entered: "Entered",
    series_left: "Left",
    series_margin: "Margin (%)",
    total: "Total",
    lost_total: "Lost",
    cost_total: "Avg. cost",
    rfq_ref: "RFQ ref.",
    last_update: "Last update",
    days_idle: "Days idle",
    days_remaining: "Days",
    missing_fields: "To complete",
    won_revenue_short: "Won revenue",
    won_count_short: "Won",
    conversion_short: "Conversion",
    client: "Client",
    pnl_verdict: "PnL audit",
    ebitda_implied_pct_short: "EBITDA",
    pnl_verdict_ok: "OK",
    pnl_verdict_subprecificado: "Underpriced",
    pnl_verdict_sobreprecificado: "Overpriced",
    pnl_verdict_critico: "Critical",
    pnl_verdict_unknown: "—",
    client_type_strategic: "Strategic",
    client_type_standard: "Standard",
    client_type_transactional: "Transactional",
    cost_vm: "VM (raw material)",
    cost_va_foundry: "VA Foundry",
    cost_va_finishing: "VA Finishing",
    cost_va_extra_works: "Extra works",
    cost_components: "Components",
    cost_subcontract: "Subcontracting",
    subcontract_machining: "Machining",
    subcontract_surface_treatment: "Surface treatment",
    subcontract_painting: "Painting",
    subcontract_other: "Other",
    incoterm_exwork: "Ex Works",
    incoterm_exworks: "Ex Works",
    incoterm_ex_works: "Ex Works",
    incoterm_ddp: "DDP",
    incoterm_dap: "DAP",
    incoterm_fca: "FCA",
    incoterm_fob: "FOB",
    incoterm_cif: "CIF",
    "incoterm_—": "No incoterm",
    no_data: "No data in selected period",
    no_followup: "No urgent follow-ups",
    no_queue: "Queue is empty",
    no_underpriced: "No active underpriced RFQs",
    no_logistics_pending: "All complete",
    missing_incoterm: "Incoterm",
    missing_box_type: "Box",
    missing_pieces_per_box: "Pcs/box",
    table_pending_action: "Pending action (waiting on me)",
    table_pending_action_eng: "Pending action (RFQs in analysis)",
    no_pending_action: "Nothing waiting on you",
    days_in_state: "Days in state",
    kpi_desc_won_lost: "{won} won · {lost} lost",
    kpi_desc_n_rfqs: "{count} RFQs",
    kpi_desc_blocked_threshold: "> 7 days idle",
    kpi_desc_followup: ">{days}d · {value} €",
    kpi_desc_eng_avg_time: "days from Eng→Commercial",
    kpi_desc_eng_rework: "RFQs with more than one version",
    kpi_desc_vm_share: "% of SP in raw material",
    kpi_desc_annual_weight: "kg/year (estimated)",
    kpi_desc_distinct_box_types: "distinct types in use",
    kpi_help_total_rfqs: "Number of RFQs created in the selected period.",
    kpi_help_conversion: "Won / (Won + Lost) for RFQs whose final decision fell within the period. Excludes pipeline and ongoing negotiations.",
    kpi_help_won_revenue: "Σ (annual volume × selling price) for RFQs marked won in the period. Annualized revenue secured.",
    kpi_help_pipeline_value: "Σ (annual volume × selling price) for RFQs not yet closed (excludes Won/Lost). What's at stake right now.",
    kpi_help_blocked: "RFQs in intermediate states (Engineering, Margins, Finance, Direction) stuck in the same state for more than 7 days. Operational attention.",
    kpi_help_my_active_rfqs: "Total YOUR RFQs (created by you) not yet closed as Won/Lost.",
    kpi_help_my_pipeline_value: "Σ (annual volume × selling price) of YOUR active RFQs.",
    kpi_help_my_close_rate: "Won / (Won + Lost) for YOUR RFQs only (filtered by created_by). Counts only those closed in the period.",
    kpi_help_my_follow_up: "Your RFQs in 'Offer sent' or 'In negotiation' for more than 14 days with no activity — client likely didn't reply, worth a nudge.",
    kpi_help_eng_in_analysis: "Number of RFQs in 'In analysis' assigned to you as engineering responsible (or all if none assigned).",
    kpi_help_eng_overdue: "Subset of your in-analysis RFQs whose deadline has passed (SLA-overdue). These trigger automatic notifications to you and the creating commercial.",
    kpi_help_eng_avg_time: "Average time (in days) between the Commercial's submit to Engineering and the return with the technical study, computed for closures within the period. Engineering throughput.",
    kpi_help_eng_rework: "RFQs whose current form version is > 1, meaning they were returned to Commercial at least once (data correction, lock-edit, new pass). Measures first-pass technical quality — the higher this is, the more Engineering is correcting / requesting changes after the initial submit.",
    kpi_help_avg_pipeline_margin: "Average global margin (margin_global_percent) of active pipeline quotations. Excludes Won/Lost.",
    kpi_help_avg_won_margin: "Average global margin of quotations closed as won in the period. Indicates the quality of what was actually sold.",
    kpi_help_vm_share: "How much of the selling price is raw material (aluminium + premiums + PAF). Signals exposure to metal price fluctuations.",
    kpi_help_active_with_transport: "Pipeline RFQs that already have an Incoterm set.",
    kpi_help_annual_weight: "Σ (annual volume × weight per piece) of active RFQs. Estimate of annual tonnage to ship.",
    kpi_help_distinct_box_types: "How many distinct box types are referenced in active RFQs. Higher means more packaging fragmentation.",
    kpi_help_active_suppliers: "Active suppliers in the catalog (Administration → Suppliers). Includes all 4 types: machining, surface treatment, painting, other.",
    dash_kpi_eng_throughput: "Delivered in period",
    dash_kpi_eng_upcoming: "Next 7 days load",
    kpi_desc_eng_throughput: "Returned from analysis to Commercial",
    kpi_desc_eng_upcoming: "In analysis · deadline ≤ 7 d",
    kpi_help_eng_throughput: "RFQs whose transition IN_ANALYSIS → next state (typically AWAITING_COMMERCIAL_MARGINS) happened WITHIN the selected period. Real Engineering throughput: 'how many RFQs did you return to Commercial in this horizon'.",
    kpi_help_eng_upcoming: "RFQs currently in analysis with you and whose deadline falls within the next 7 days (excluding already past ones — those are in the 'Overdue' KPI). Helps plan the week and anticipate SLA pressure before they become overdue.",
    chart_machines_won: "Machines in won RFQs",
    chart_finishing_won: "Finishing ops in won RFQs",
    chart_my_machines_won: "My machines (won RFQs)",
    chart_my_finishing_won: "My finishing ops (won RFQs)",
    chart_machines_won_eng: "Machines (won RFQs handled by Eng.)",
    chart_finishing_won_eng: "Finishing ops (won RFQs handled by Eng.)",
    no_won_data: "No won RFQs in scope",
  },
};

export function t(key, lang = 'pt') {
  return translations[lang]?.[key] || translations.pt[key] || key;
}

export default translations;
